import React from 'react';
import  { useState,   useCallback,
    useMemo,
    useRef,
  
    StrictMode, } from 'react';
import  { useEffect }from 'react';
import './DnevnepromjeneDonat.css'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { componentStyles } from '../services/elementDesign'
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import Fab from '@mui/material/Fab';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';


import Grid from '@mui/material/Unstable_Grid2';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';


import Loader3 from './Loader3';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { APICall } from './services/api.service';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from "./redux/actions"
import AutoModal from './AutoModal';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {statusObradeOptions, trebaLiSklonitiOptions} from './variables/variables.js';

import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import Swal from 'sweetalert2';
import { Alert } from '@mui/material';

import * as useLocalStorage from './services/useLocalStorage'
import BijeleStranice from './BijeleStranice.js';
import ZuteStranice from './ZuteStranice.js';

import { AllCommunityModule } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";

import { Autocomplete} from '@mui/material';

import {
    ClientSideRowModelModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    ModuleRegistry,
    ValidationModule,
    createGrid,
    themeQuartz,
    themeBalham,


    RowSelectionModule,
    RenderApiModule,


  } from "ag-grid-community";
import { AiOutlineConsoleSql } from 'react-icons/ai';
import { DiDart } from 'react-icons/di';
  


import { RowApiModule } from 'ag-grid-community'; 
import useDebouncedClick from "./useDebouncedClick";

import { styled } from "@mui/material/styles";


const MyTextField = styled(TextField)(() => ({
  ".MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "black",
    color: "black"
  }
}));

  ModuleRegistry.registerModules([
    RowSelectionModule,
    ClientSideRowModelModule,


    ValidationModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    RowApiModule,
    RenderApiModule,
   
  ]);



  const myTheme = themeBalham.withParams({
    headerHeight: "30px",
    headerTextColor: "black",
    headerBackgroundColor: "#99ABCD",
    headerCellHoverBackgroundColor: "rgba(80, 40, 140, 0.66)",
    headerCellMovingBackgroundColor: "rgb(80, 40, 140)",
    selectedRowBackgroundColor: '#8386a6',
    fontSize: 14,
    fontWeight:400

  });
  

const myThemeBijele = themeQuartz.withParams({
    
    headerHeight: "30px",
    headerTextColor: "black",
    headerBackgroundColor: "#99ABCD",
    headerCellHoverBackgroundColor: "rgba(80, 40, 140, 0.66)",
    headerCellMovingBackgroundColor: "rgb(80, 40, 140)",
    selectedRowBackgroundColor: '#8386a6',
    //cellFontFamily: "serif",
    //headerFontFamily: "Georgia",
    fontSize: 14,
    fontWeight:600
  

});

const myThemeSimilar = themeQuartz.withParams({
    headerHeight: '30px',
    headerTextColor: 'black',
    headerBackgroundColor: '#99ABCD',
    headerCellHoverBackgroundColor: 'rgba(80, 40, 140, 0.66)',
    headerCellMovingBackgroundColor: 'rgb(80, 40, 140)',
    backgroundColor: "lightyellow",
    //cellFontFamily: "serif",
    //headerFontFamily: "Georgia",
    fontSize: 14,
    fontWeight:400
});




const theme = createTheme({
    palette: {
        primary: {
            main: '#520074'
        }
    },
    mixins: {
        MuiDataGrid: {
          // Pinned columns sections
          pinnedBackground: '#520074',
          // Headers, and top & bottom fixed rows
          containerBackground: 'primary',
        },
      },

});




function DnevnePromjeneTele2() {

    const gridRef = useRef();
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);



    const autoSizeStrategy = useMemo(() => {
        return {
          type: "fitCellContents",
          skipHeader : true
        };
      }, []);

      const autoSizeAll = useCallback((skipHeader) => {
        const allColumnIds = [];
        gridRef.current.api.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        });
        gridRef.current.api.autoSizeColumns(allColumnIds, skipHeader);
      }, []);


      const onGridReady = useCallback((event) => {
        console.log("Grid ready *********************************************************************************")
        let nodes = event.api.getRenderedNodes();
        autoSizeAll();
        if (nodes.length) {
          //nodes[0].setSelected(true); //selects the first row in the rendered view
          //nodes[1].setSelected(true);
        }
      }, []);

      const selectAll = useCallback((event) =>{
            console.log("I wanna select it all!!!!!");

            event.api.selectAll();
            console.log("Selected");
      }, []);

      const onColumnResized = useCallback((params) => {
      }, []);

      const themeAG = useMemo(() => {
        return myTheme;
      }, []);
    
      const onRowSelected = useCallback((event) => {

      }, []);

      const onRowDoubleClicked = useCallback((event)=>{
                                        
        console.log("DoubleClick");
        console.log(event.node);

    }, []); 
    
      const onSelectionChanged = useCallback((event) => {
        const rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, " + rowCount + " rows selected");
        let items=[]
        let itemsTelefon=[]

        //console.log(event.api.getSelectedNodes()[0].data);
        for(var i=0; i<event.api.getSelectedNodes().length; i++) {
            console.log("I je: " + i);
            console.log(event.api.getSelectedNodes()[i]);

            //items.push(filteredTableData.rows.filter(row=>row.id===event.api.getSelectedNodes()[i].id));
            
            //items.push([i, event.api.getSelectedNodes()[i].data]);
            //items.push([event.api.getSelectedNodes()[i].id, event.api.getSelectedNodes()[i].data]);

            items.push(event.api.getSelectedNodes()[i].data);

  
            console.log(items);

            itemsTelefon.push(event.api.getSelectedNodes()[i].data.Telefon);
        }
        
       
      
        console.log("Selecetedddeeddeeddde");
        console.log(items.length);
        console.log(items)
        setSelectedItems(items);
        setSelectedItemsTelefon(itemsTelefon);
     
      
      }, []);


    
      const handleSingleClick = (event) => {
        console.log("1 klik: ", event);
        console.log(event.node);
        cellClicked(event.node);
      };
    
      const handleDoubleClick = (event) => {
        console.log("2 klika:", event);



        console.log(event.node);
        console.log(event.node.data);
        console.log(event.node.data["Novi Telefon"]);
        cellClicked(event.node);
        getBijeleZuteDnevne(event.node.data["Novi Telefon"]);



      };
    
      const debounceClick = useDebouncedClick(handleSingleClick, handleDoubleClick, 500);


      const cellClicked = useCallback(async (cell)=>{
      
         
                     
                      //console.log(cell);
      
                      console.log(cell);
      
                      console.log(cell.data.MJESTO)
                      console.log(cell.data.sifra_ulice)
                                                 
                      let tmpMj = await getMjestoNaziv(cell.data.MJESTO);           
                      let tmpUl = await getUlicaNaziv(cell.data.sifra_ulice);  
      
                      console.log(cell.data.stariMjID)
                      console.log(cell.data.stariUlID)
                 
                      let tmpMjSt = await getMjestoNaziv(cell.data.stariMjID);           
                      let tmpUlSt = await getUlicaNaziv(cell.data.stariUlID);  
      
      
                      console.log("Ulica/mjesto");
      
                      console.log(tmpMj);
                      console.log(tmpUl);
      
                      let tmpAdresaNew = tmpUl;
      
                      if(cell.data.newKBR && cell.data.newKBR!=''){
      
                          tmpAdresaNew = tmpAdresaNew + ' ' + cell.data.newKBR;
      
                      }                                
      
                      if(cell.data.newKBR_Dod && cell.data.newKBR_Dod!=''){
                          tmpAdresaNew = tmpAdresaNew + ' ' + cell.data.newKBR_Dod;
                      }
      
                      console.log(tmpAdresaNew);
                                   
                      console.log(tmpMjSt);
                      console.log(tmpUlSt);
      
                      let tmpAdresaOld = tmpUlSt;
      
                      if(cell.data.KBR && cell.data.KBR!=''){
      
                          tmpAdresaOld = tmpAdresaOld + ' ' + cell.data.KBR;
      
                      }                                
      
                      if(cell.data.KBR_Dod && cell.data.KBR_Dod!=''){
                          tmpAdresaOld = tmpAdresaOld + ' ' + cell.data.KBR_Dod;
                      }
                                   
                      console.log(tmpAdresaOld);
      
                      setCnt(cell.data.cnt?cell.data.cnt:'');

                      console.log("**************************************");

                      console.log(cnt);
                      console.log("**************************************");

      
                      //setErrorUlica(cell.data.Greska);

                      setErrorUlica(true);
      
                      setNewUlica(tmpAdresaNew);
                      setNewMjesto(tmpMj);
      
                      setOldUlica(tmpAdresaOld)
                      setOldMjesto(tmpMjSt);
                                                  
      
                      setDiffMjesto(false);
                      setDiffNaziv(false);
                      setDiffOIB(false);
                      setDiffPTT(false);
                      setDiffUlica(false);
                      setDiffTel(false);
                      setDiffTIP1(false);
                      setDiffTIP2(false);
                      setDiffTIP3(false);
                      setDiffName(false);
                      setDiffSurname(false);
      
                      setMJESTO_ID(cell.data.MJESTO);
      
                    
                      setULICA_ID(cell.data.sifra_ulice);
      
                      setKbr2(cell.data.newKBR);
                      setKbr_Dod2(cell.data.newKBR_Dod)
      
                  
                      setDoubleClickedRow(cell.data)
                      setSelectedCell(cell.data);
      
                      setSelectedCellForBS(cell.data);
      
                      getDataPhone(cell.data.Telefon)
      
                      setTelefon(cell.data.Telefon);
                      setTelefon2(cell.data['Novi Telefon']);
                     
      
                      setOperator(cell.data['ID operatera']);
      
      
                      setNaziv1(cell.data.Naziv)
                     
      
                      console.log("surname and surname s");
                      console.log(cell.data.surname_s);
      
                      //setNaziv2(cell.data.Naziv_n)
                      setNaziv12(cell.data['Novi naziv']);
      
                      setName2(cell.data.name);
                      setName(cell.data.name_s);
      
      
                      setSurname2(cell.data.surname);
                      setSurname(cell.data.surname_s)
                      
                      setOIB(cell.data.OIB);
                      setOIB2(cell.data.OIB_n);
      
      
      
      
                      if(cell.data.Naziv.trim() != cell.data['Novi naziv'].trim() && cell.data['Vrsta rada'].includes('PROMJENA')){
      
                          setDiffNaziv(true);
                      }
                      if(cell.data.name.trim() != cell.data.name_s.trim() && cell.data['Vrsta rada'].includes('PROMJENA')){
                          console.log("Rezlicito ime!!!")
      
                          setDiffName(true);
                      }
      
                      if(cell.data.surname.trim() != cell.data.surname_s.trim() && cell.data['Vrsta rada'].includes('PROMJENA')){
      
                          setDiffSurname(true);
                      }
      
                      if(cell.data.OIB.trim() != cell.data.OIB.trim() && cell.data['Vrsta rada'].includes('PROMJENA')){
      
                          setDiffOIB(true);
                      }
                      if(cell.data.Telefon.trim() != cell.data['Novi Telefon'].trim() && cell.data['Vrsta rada'].includes('PROMJENA')){
      
                          setDiffTel(true);
                      }
      
            
      
                      if(cell.data.Objava == 0){
      
      
                              setIsObjava(false);
      
                      } else {
      
                              setIsObjava(true);
                      }
      
                      //setIsObjava(cell.data.Tajni);
      
                      setMjesto(cell.data.Mjesto_s)
                      setMjesto2(cell.data.Mjesto)
      
                      setPtt(cell.data.PTT);
                      setPtt2(cell.data.PTT_n);
      
                      
                      setUlica(cell.data.Adresa_s);
                      setUlica2(cell.data.Adresa);
      
      
                      if(cell.data.PTT.trim() != cell.data.PTT_n.trim() && cell.data['Vrsta rada'].includes('PROMJENA')){
      
                          setDiffPTT(true);
                      }

                      

                let tmpMj2 = tmpMj?tmpMj.trim():'';
                let tmpMjOld2 = tmpMjSt?tmpMjSt.trim():''

                let tmpAdresa2 = tmpAdresaNew?tmpAdresaNew.trim():'';
                let tmpAdresaSt2 = tmpAdresaOld?tmpAdresaOld.trim():''

               



                if(tmpMj2.trim().localeCompare(tmpMjOld2) != 0 && cell.data['Vrsta rada'].includes('PROMJENA')){

                            setDiffMjesto(true);
                }
                if(tmpAdresaSt2.trim().localeCompare(tmpAdresa2)!= 0 && cell.data['Vrsta rada'].includes('PROMJENA')){

                            setDiffUlica(true);
                }
                      /*
                      if(cell.data.Mjesto_s.trim() != cell.data.Mjesto.trim() && cell.data['Vrsta rada'].includes('PROMJENA')){
      
                          setDiffMjesto(true);
                      }
                      if(cell.data.Adresa_s.trim() != cell.data.Adresa.trim() && cell.data['Vrsta rada'].includes('PROMJENA')){
      
                          setDiffUlica(true);
                      }
                          */
                      
      
      
                      
                      setTip(cell.data.Tip1);
                      setTip12(cell.data.Tip1_n);
      
                      setTip2(cell.data.Tip2);
      
                      setTip22(cell.data.Tip2_n);
                      setTip3(cell.data.Tip3);
                      setTip32(cell.data.Tip3_n);
      
                      setKomentar(cell.data.Komentar);
      
                      if(cell.data.Tip1 != cell.data.Tip1_n){
      
                          //setDiffTIP1(true);
                      }
                      if(cell.data.Tip2 != cell.data.Tip2_n){
      
                          //setDiffTIP2(true);
                      }
                      if(cell.data.Tip3 != cell.data.Tip3_n){
      
                          //setDiffTIP3(true);
                      }
      
                      setDiffTIP1(false);
                      setDiffTIP2(false);
                      setDiffTIP3(false);
      
                      let dateVal = new Date(cell.data.Datum);
      
                      const options = {
                      
                          year: "numeric",
                          month: "numeric",
                          day: "numeric",
                      };
                      let tmpDate= dateVal.toLocaleDateString("hr-HR", options);
      
                      setDatumVal(tmpDate);
                      
                      //setDatumVal(cell.data.Datum);
      
                     
      
                      //setName(cell.data.name);
                      //setSurname(cell.data.surname);
      
                      setStatusObrade(cell.data.Stanje);
      
                      setSkloniti(cell.data.Gotovo);
      
                      setObrnuto('  ');
                      setObrnuto2('  ');
      
                      setTkOperatorRow(cell.data.Operater);
                      setAkcijaRow(cell.data["Vrsta rada"]);
      
                      setActiveTKCRow(cell.data.TKC);
                      setTkOperatorRowID(cell.data["ID operatera"]);
      
      
                      
      
                      if(cell.data.rucnoAdresaID && cell.data.rucnoAdresaID!='' && cell.data.rucnoMjestoID && cell.data.rucnoMjestoID!=''){
      
      
                          let selUlica = await getUlicaFromID(cell.data.rucnoAdresaID, cell.data.rucnoMjestoID);
      
                          let selMjesto = await getMjestoFromID(cell.data.rucnoMjestoID);
      
                          if(selUlica && selUlica.data.ulica && selMjesto && selMjesto.data.mjesto){
      
                              setSelectedUlica(selUlica.data.ulica);
                              setSelectedMjesto(selMjesto.data.mjesto);
          
                              setRucnoKBR(cell.data.rucnoKBR?cell.data.rucnoKBR:'');
                              setRucnoKBRDodatak(cell.data.rucnoDodatak?cell.data.rucnoDodatak:'');
                              setRucnoMjesto(selMjesto.NAZIV?selMjesto.NAZIV:selMjesto.naziv);
                              setRucnoUlica(selUlica.NAZIV?selUlica.NAZIV:selUlica.naziv);
                              setRucnoNaziv1(cell.data.rucnoNaziv1?cell.data.rucnoNaziv1:'');
                              setRucnoNaziv2(cell.data.rucnoNaziv2?cell.data.rucnoNaziv2:'');
          
                             
      
                              let tip = (cell.data.rucnoTip=='Poslovni')?2:(cell.data.rucnoTip=='Privatni'?0:3);
                              setSelectedRucnoTip(tip);
          
                              setRucnoTip(cell.data.rucnoTip?cell.data.rucnoTip:'');
      
                          } else{
      
                              setRucnoKBR('');
                              setRucnoKBRDodatak('');
                              setRucnoMjesto('');
                              setRucnoUlica('');
                              setRucnoNaziv1('');
                              setRucnoNaziv2('');
          
                              setSelectedUlica({'ULICA_ID':0, 'NAZIV':''});
          
              
                              setSelectedMjesto({'MJESTO_ID':0, 'NAZIV':''});
          
                              setSelectedRucnoTip(3);
          
                              setRucnoTip(cell.data.rucnoTip?cell.data.rucnoTip:'');
      
                          }
      
      
      
                      } else {
      
      
                          setRucnoKBR('');
                          setRucnoKBRDodatak('');
                          setRucnoMjesto('');
                          setRucnoUlica('');
                          setRucnoNaziv1('');
                          setRucnoNaziv2('');
      
                          setSelectedUlica({'ULICA_ID':0, 'NAZIV':''});
      
          
                          setSelectedMjesto({'MJESTO_ID':0, 'NAZIV':''});
      
                          setSelectedRucnoTip(3);
      
                          setRucnoTip(cell.data.rucnoTip?cell.data.rucnoTip:'');
                      }
                     
      
      
                      setListMjesta([]);
                      setListUlice([]);
      
                      
                      setRucneKorekcije(false);
      
                      if(cell.data["Vrsta rada"].toUpperCase().includes('UKLJU') || cell.data["Vrsta rada"].toUpperCase().includes('PROMJ') ){
      
                          setRucneKorekcije(true);
                      }
      
      
      })
      
/*
     const cellClicked = useCallback(async (cell)=>{

   
               
                console.log(cell);

                setCnt(cell.data.cnt?cell.data.cnt:'');

                setErrorUlica(cell.data.Greska);

                setNewUlica(cell.data.newUlica);
                setNewMjesto(cell.data.newMjesto);
                                            

                setDiffMjesto(false);
                setDiffNaziv(false);
                setDiffOIB(false);
                setDiffPTT(false);
                setDiffUlica(false);
                setDiffTel(false);
                setDiffTIP1(false);
                setDiffTIP2(false);
                setDiffTIP3(false);
                setDiffName(false);
                setDiffSurname(false);

                setMJESTO_ID(cell.data.MJESTO);

              
                console.log(cell.data.MJESTO);

                console.log("Setting sifra ulice");
                console.log(cell.data.sifra_ulice)
                setULICA_ID(cell.data.sifra_ulice);

                setKbr2(cell.data.newKBR);
                setKbr_Dod2(cell.data.newKBR_Dod)
                

            
                setDoubleClickedRow(cell.data)
                setSelectedCell(cell.data);

                setSelectedCellForBS(cell.data);

                console.log("Chosen row:");
                console.log(cell.data.Telefon)
                getDataPhone(cell.data.Telefon)

                setTelefon(cell.data.Telefon);
                setTelefon2(cell.data['Novi Telefon']);
                console.log(cell.data['Novi Telefon'])

                setOperator(cell.data['ID operatera']);

                console.log("Chosen Phone operator: ");
                console.log(cell.data.Operater);

                setNaziv1(cell.data.Naziv)
                //setNaziv2(cell.data.Naziv_n)
                setNaziv12(cell.data['Novi naziv']);


                setName2(cell.data.name);
                setName(cell.data.name_s);


                setSurname2(cell.data.surname);
                setSurname(cell.data.surname_s)
                
                setOIB(cell.data.OIB);
                setOIB2(cell.data.OIB_n);

                console.log("Vrste radaaaaaaaaaaa");
                console.log(cell.data['Vrsta rada']);

                console.log(cell.data.name.trim());
                console.log(cell.data.name_s.trim());


                if(cell.data.Naziv.trim() != cell.data['Novi naziv'].trim() && cell.data['Vrsta rada'].includes('PROMJENA')){

                    setDiffNaziv(true);
                }
                if(cell.data.name.trim() != cell.data.name_s.trim() && cell.data['Vrsta rada'].includes('PROMJENA')){
                    console.log("Rezlicito ime!!!")

                    setDiffName(true);
                }

                if(cell.data.surname.trim() != cell.data.surname_s.trim() && cell.data['Vrsta rada'].includes('PROMJENA')){

                    setDiffSurname(true);
                }

                if(cell.data.OIB.trim() != cell.data.OIB.trim() && cell.data['Vrsta rada'].includes('PROMJENA')){

                    setDiffOIB(true);
                }
                if(cell.data.Telefon.trim() != cell.data['Novi Telefon'].trim() && cell.data['Vrsta rada'].includes('PROMJENA')){

                    setDiffTel(true);
                }

                console.log(cell.data.Tajni);
                console.log(cell.data.Tajni_staro);

                if(cell.data.Objava == 0){

                        console.log("Nema objave!!!");

                        setIsObjava(false);

                } else {

                        setIsObjava(true);
                }

                //setIsObjava(cell.data.Tajni);

                setMjesto(cell.data.Mjesto_s)
                setMjesto2(cell.data.Mjesto)

                setPtt(cell.data.PTT);
                setPtt2(cell.data.PTT_n);

                
                setUlica(cell.data.Adresa_s);
                setUlica2(cell.data.Adresa);

                if(cell.data.PTT.trim() != cell.data.PTT_n.trim() && cell.data['Vrsta rada'].includes('PROMJENA')){

                    setDiffPTT(true);
                }
                if(cell.data.Mjesto_s.trim() != cell.data.Mjesto.trim() && cell.data['Vrsta rada'].includes('PROMJENA')){

                    setDiffMjesto(true);
                }
                if(cell.data.Adresa_s.trim() != cell.data.Adresa.trim() && cell.data['Vrsta rada'].includes('PROMJENA')){

                    setDiffUlica(true);
                }
                


                
                setTip(cell.data.Tip1);
                setTip12(cell.data.Tip1_n);

                setTip2(cell.data.Tip2);

                setTip22(cell.data.Tip2_n);
                setTip3(cell.data.Tip3);
                setTip32(cell.data.Tip3_n);

                setKomentar(cell.data.Komentar);

                if(cell.data.Tip1 != cell.data.Tip1_n){

                    //setDiffTIP1(true);
                }
                if(cell.data.Tip2 != cell.data.Tip2_n){

                    //setDiffTIP2(true);
                }
                if(cell.data.Tip3 != cell.data.Tip3_n){

                    //setDiffTIP3(true);
                }

                setDiffTIP1(false);
                setDiffTIP2(false);
                setDiffTIP3(false);

                let dateVal = new Date(cell.data.Datum);

                const options = {
                
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                };
                let tmpDate= dateVal.toLocaleDateString("hr-HR", options);

                setDatumVal(tmpDate);
                
                //setDatumVal(cell.data.Datum);

                //console.log(cell.data.Datum)


                setStatusObrade(cell.data.Stanje);

                console.log("Setting status; ");
                console.log(cell.data.Stanje);
                console.log(cell.data.Gotovo);
                setSkloniti(cell.data.Gotovo);

                setObrnuto('  ');
                setObrnuto2('  ');

                setTkOperatorRow(cell.data.Operater);
                setAkcijaRow(cell.data["Vrsta rada"]);

                setActiveTKCRow(cell.data.TKC);
                setTkOperatorRowID(cell.data["ID operatera"]);


                console.log("Rucnooooo");
                

                if(cell.data.rucnoAdresaID && cell.data.rucnoAdresaID!='' && cell.data.rucnoMjestoID && cell.data.rucnoMjestoID!=''){

                    console.log("Postoji nesto rucno!!!");

                    let selUlica = await getUlicaFromID(cell.data.rucnoAdresaID, cell.data.rucnoMjestoID);

                    console.log(selUlica);
                    let selMjesto = await getMjestoFromID(cell.data.rucnoMjestoID);

                    if(selUlica && selUlica.data.ulica && selMjesto && selMjesto.data.mjesto){

                        setSelectedUlica(selUlica.data.ulica);
                        setSelectedMjesto(selMjesto.data.mjesto);
    
                        setRucnoKBR(cell.data.rucnoKBR?cell.data.rucnoKBR:'');
                        setRucnoKBRDodatak(cell.data.rucnoDodatak?cell.data.rucnoDodatak:'');
                        setRucnoMjesto(selMjesto.NAZIV?selMjesto.NAZIV:selMjesto.naziv);
                        setRucnoUlica(selUlica.NAZIV?selUlica.NAZIV:selUlica.naziv);
                        setRucnoNaziv1(cell.data.rucnoNaziv1?cell.data.rucnoNaziv1:'');
                        setRucnoNaziv2(cell.data.rucnoNaziv2?cell.data.rucnoNaziv2:'');
    
                        console.log("Rucni tiiiiiiiiip");
                        console.log(cell.data.rucnoTip);

                        let tip = (cell.data.rucnoTip=='Poslovni')?2:(cell.data.rucnoTip=='Privatni'?0:3);
                        setSelectedRucnoTip(tip);
    
                        setRucnoTip(cell.data.rucnoTip?cell.data.rucnoTip:'');

                    } else{

                        setRucnoKBR('');
                        setRucnoKBRDodatak('');
                        setRucnoMjesto('');
                        setRucnoUlica('');
                        setRucnoNaziv1('');
                        setRucnoNaziv2('');
    
                        setSelectedUlica({'ULICA_ID':0, 'NAZIV':''});
    
        
                        setSelectedMjesto({'MJESTO_ID':0, 'NAZIV':''});
    
                        setSelectedRucnoTip(3);
    
                        setRucnoTip(cell.data.rucnoTip?cell.data.rucnoTip:'');

                    }



                } else {


                    setRucnoKBR('');
                    setRucnoKBRDodatak('');
                    setRucnoMjesto('');
                    setRucnoUlica('');
                    setRucnoNaziv1('');
                    setRucnoNaziv2('');

                    setSelectedUlica({'ULICA_ID':0, 'NAZIV':''});

    
                    setSelectedMjesto({'MJESTO_ID':0, 'NAZIV':''});

                    setSelectedRucnoTip(3);

                    setRucnoTip(cell.data.rucnoTip?cell.data.rucnoTip:'');
                }
               


                setListMjesta([]);
                setListUlice([]);

                setRucneKorekcije(false);

                if(cell.data["Vrsta rada"].toUpperCase().includes('UKLJU') || cell.data["Vrsta rada"].toUpperCase().includes('PROMJ') ){

                    console.log("Promjena ili ukljucenje!!!!");
                    setRucneKorekcije(true);
                }


     })
*/

     const [sortType, setSortType] = useState(0);

      const onSortChanged= useCallback((e) => {
        e.api.refreshCells();
        
        });


         const onCellKeyDown = useCallback((e) => {
                 console.log("onCellKeyDown", e);
                 if (!e.event) {
                 return;
                 }
                 const api = gridRef.current.api;
                 const keyboardEvent = e.event;
                 const key = keyboardEvent.key;
                 if (key.length) {
     
                 if (key === "ArrowDown") {
     
                
                     api.forEachNode(function (node) {
                   
                             if(node.rowIndex == e.node.rowIndex){
                          
                                 node.setSelected(false);
     
                             }
                             if(node.rowIndex == e.node.rowIndex + 1){
     
                                 node.setSelected(true);
     
                                 cellClicked(node);
                                 
                             }
     
     
                     });
                 
     
     
                 }
     
                 if (key === "ArrowUp") {
       
                     if(e.node.rowIndex>0){
                     api.forEachNode(function (node) {
     
     
                             if(node.rowIndex == e.node.rowIndex){
                                 
                                 node.setSelected(false);
     
                             }
                             if(node.rowIndex == e.node.rowIndex - 1){
     
                                 node.setSelected(true);
     
                                 cellClicked(node);
                                 
                             }
     
     
                     });
                 }
     
     
                 }            
                 }
       }, []);
     
    const getRowStyle = useCallback(params => {


        if(params.node.data.Komentar && params.node.data.Komentar.localeCompare("Duplikat")==0){
           
            return { background: 'lightgreen' };
        }
        if(params.node.data.arhivaNew && params.node.data.arhivaNew==1){
           
            return { background: 'lightyellow' };
        }    
        //if(params.node.data.upareno && params.node.data.upareno==1){
        //   
        //    return { background: 'lightblue '};
        //}                 
    }, []);


        const getRowStyleArchive = useCallback(params => {
    
               
                return { background: 'lightyellow' };
            
    
        }, []);
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */


async function getMjestoNaziv(mjestoID) {
  console.log("Taaaa");
  console.log(mjestoID);

  dispatch(actions.isLoading());

  try {
    const response = await APICall(
      '/GetMjestoNaziv',
      { mjesto: mjestoID },
      { token }
    );

    dispatch(actions.isNotLoading());

    if (response?.status === 200) {
      console.log(response.data);
      return response.data.nazivMjesto;
    } else if (response?.status === 401) {
      console.log("Istekla sesija");
      toast.error(response.data.message, toastError);
      dispatch(actions.logOut());
      navigate('/');
      return '';
    } else {
      return '';
    }
  } catch (error) {
    dispatch(actions.isNotLoading());

    if (!error.response || !error.response.status) {
      return '';
    }

    if (error.response.status === 401) {
      toast.error(error.response.data.message, toastError);
      setTimeout(() => {
        dispatch(actions.logOut());
        navigate('/');
      }, 5000);
    }

    return '';
  }
}

async function getUlicaNaziv(ulicaID) {
  dispatch(actions.isLoading());

  try {
    const response = await APICall(
      '/GetUlicaNaziv',
      { ulica: ulicaID },
      { token }
    );

    dispatch(actions.isNotLoading());

    if (response?.status === 200) {
      return response.data.nazivUlica;
    }

    if (response?.status === 401) {
      console.log("Istekla sesija");
      toast.error(response.data.message, toastError);
      dispatch(actions.logOut());
      navigate('/');
      return '';
    }

    return '';
  } catch (error) {
    dispatch(actions.isNotLoading());

    if (!error.response || !error.response.status) {
      return '';
    }

    if (error.response.status === 401) {
      toast.error(error.response.data.message, toastError);
      setTimeout(() => {
        dispatch(actions.logOut());
        navigate('/');
      }, 5000);
    }

    return '';
  }
}





    const gridRefBijele = useRef();
    const containerStyleBijele = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyleBijele = useMemo(() => ({ height: "100%", width: "100%" }), []);



    const autoSizeStrategyBijele = useMemo(() => {
        return {
        type: "fitGridWidth",
        defaultMinWidth: 100
        };
      }, []);



    const autoSizeAllBijele = useCallback((skipHeader) => {
        const allColumnIds = [];
        gridRefBijele.current.api.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        });
        gridRefBijele.current.api.autoSizeColumns(allColumnIds, skipHeader);
    }, []);


    const onGridReadyBijele = useCallback((event) => {
        console.log("Grid ready *********************************************************************************")
        let nodes = event.api.getRenderedNodes();
        autoSizeAllBijele();
        if (nodes.length) {
          //nodes[0].setSelected(true); //selects the first row in the rendered view
          //nodes[1].setSelected(true);
        }
    }, []);



      const onColumnResizedBijele = useCallback((params) => {
      }, []);

      const themeAGBijele = useMemo(() => {
        return myThemeBijele;
      }, []);
    
      const onRowSelectedBijele = useCallback((event) => {

      }, []);

 

      const onSelectionChangedBijele = useCallback((event) => {

     
      
      }, []);





     const cellClickedBijele = useCallback(async (cell)=>{

   
        console.log("Cell is clicked!!!!!!!!!!!!!!!!!!!!!!!!!!")

        console.log(cell);
 
        
        console.log("Selected: ");
       
        setVratiObjavu(cell.data)
        

        console.log("Sifra; ");
        console.log(cell.data.sifra);
        setCurrentCodeBijele(cell.data.sifra);
        setCurrentTKCBijele(cell.data.tkcID);

        

     })


/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */


    const gridRefAutoBijele = useRef();
    const containerStyleAutoBijele = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyleAutoBijele = useMemo(() => ({ height: "100%", width: "100%" }), []);



    const autoSizeStrategyAutoBijele = useMemo(() => {
        return {
        type: "fitGridWidth",
        defaultMinWidth: 100
        };
      }, []);



    const autoSizeAllAutoBijele = useCallback((skipHeader) => {
        const allColumnIds = [];
        gridRefAutoBijele.current.api.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        });
        gridRefAutoBijele.current.api.autoSizeColumns(allColumnIds, skipHeader);
    }, []);


    const onGridReadyAutoBijele = useCallback((event) => {
        console.log("Grid ready *********************************************************************************")
        let nodes = event.api.getRenderedNodes();
        autoSizeAllAutoBijele();
        if (nodes.length) {
          //nodes[0].setSelected(true); //selects the first row in the rendered view
          //nodes[1].setSelected(true);
        }
    }, []);



      const onColumnResizedAutoBijele = useCallback((params) => {
      }, []);

      const themeAGAutoBijele = useMemo(() => {
        return myThemeBijele;
      }, []);
    
      const onRowSelectedAutoBijele = useCallback((event) => {

      }, []);

 

      const onSelectionChangedAutoBijele = useCallback((event) => {

     
      
      }, []);





     const cellClickedAutoBijele = useCallback(async (cell)=>{

   
        console.log("Cell is clicked!!!!!!!!!!!!!!!!!!!!!!!!!!")

        console.log(cell);
 

     })


                                    
   const [columnDefsAutoBijele, setColumnDefsAutoBijele] = useState([
 
    { field: "Novi Telefon", headerName:'Telefon'},
    { field: "Naziv", headerName:'Naziv'},
    { field: "Novi naziv", headerName:'Novi naziv'},
    
    { field: "Mjesto", hide: true},
    { field: "Telefon", hide: true},

    { field: "Operater", hide: true},
    { field: "Usluga", hide: true},
    { field: "Usluga_n", hide: true},
    { field: "cnt", hide: true},
    { field: "newKBR", hide: true},
    { field: "newKBR_Dod", hide: true},
    { field: "newMjesto", headerName:'Mjesto'},
    { field: "Adresa", headerName:'Adresa'},
    { field: "newUlica", hide: true},
    { field: "oldKBR", hide: true},
    { field: "oldKBRDod", hide: true},
    { field: "oldMjestoID", hide: true},
    { field: "oldUlicaID", hide: true},
    { field: "rbr", hide: true},
    { field: "sifra_ulice", hide: true},
    { field: "rucnoAdresaID", hide: true},
    { field: "rucnoTip", hide: true},
    { field: "rucnoNaziv2", hide: true},
    { field: "rucnoNaziv1", hide: true},
    { field: "rucnoMjestoID", hide: true},
    { field: "rucnoKBR", hide: true},
    { field: "rucnoDodatak", hide: true},
    { field: "Ref", hide: true},
    { field: "Datum", hide: true},
    { field: "Mjesto_s", hide: true},
    { field: "MJESTO", hide: true},
    { field: "PTT_n", hide: true},
    { field: "PTT", hide: true},
    { field: "id", hide: true},
    { field: "surname_s", hide: true},
    { field: "name_s", hide: true},
    { field: "name", hide: true},
    { field: "surname", hide: true},
    { field: "Filter", hide: true},
    { field: "OIB", hide: true},
    { field: "OIB_n", headerName:'OIB'},
    { field: "ID operatera", hide: true},
    { field: "sekvenca", hide: true},
    { field: "TKC", hide: true},
    { field: "T_mob_tip", hide: true},
    { field: "Tip3_n", hide: true},
    { field: "Tip3", hide: true},
    { field: "Tip2_n", hide: true},
    { field: "Tip2", hide: true},
    { field: "Tip1_n", hide: true},
    { field: "Tip1", hide: true},
    { field: "Objava", hide: true},
    { field: "Tajni_staro", hide: true},
    { field: "Tajni", hide: true},
    { field: "Priklj", hide: true},
    { field: "Komentar", hide: true},
    { field: "Gotovo", hide: true},
    { field: "Stanje", hide: true},
    { field: "Vrsta rada", hide: true},
    { field: "Operater", hide: true},

  ]);


/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */


    const gridRefSimilar = useRef();
    const containerStyleSimilar = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyleSimilar = useMemo(() => ({ height: "100%", width: "100%" }), []);



    const autoSizeStrategySimilar = useMemo(() => {
        return {
        type: "fitGridWidth",
        defaultMinWidth: 100
        };
      }, []);



    const autoSizeAllSimilar = useCallback((skipHeader) => {
        const allColumnIds = [];
        gridRefSimilar.current.api.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        });
        gridRefSimilar.current.api.autoSizeColumns(allColumnIds, skipHeader);
    }, []);


    const onGridReadySimilar = useCallback((event) => {
        console.log("Grid ready *********************************************************************************")
        let nodes = event.api.getRenderedNodes();
        autoSizeAllSimilar();
        if (nodes.length) {
          //nodes[0].setSelected(true); //selects the first row in the rendered view
          //nodes[1].setSelected(true);
        }
    }, []);



      const onColumnResizedSimilar = useCallback((params) => {
        
      }, []);

      const themeAGSimilar = useMemo(() => {
        return myThemeSimilar;
      }, []);
    
      const onRowSelectedSimilar = useCallback((event) => {

      }, []);

 

      const onSelectionChangedSimilar = useCallback((event) => {

     
      
      }, []);





     const cellClickedSimilar = useCallback(async (cell)=>{

   
        console.log("Cell is clicked!!!!!!!!!!!!!!!!!!!!!!!!!!")

        console.log(cell);
 

        

     })


/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */




/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*************************************STATE VARIJABLE**************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

    const dispatch = useDispatch()
    const navigate = useNavigate();

    const [tkList, setTkList] = useState([77]);

    const [curr_time, setCurrTime] = useState('');

    const token = localStorage.getItem("token");

    const togglingValue = useSelector((state) => state.togglingVariable?state.togglingVariable.value: 0);
    const isMenuOpen = useSelector(store=>store.menu?store.menu.open:false)


    
    //const korisnik = useSelector((state) =>state.korisnik ? state.korisnik.value : "" )
    //const tkc = JSON.parse(localStorage.getItem("tkc"));
    //const [poziv, setPoziv] = useState(JSON.parse(useLocalStorage.getItem("tkc")));
    //const tkc2 = useSelector((state) =>state.TKC ? state.TKC.value : {tkc: "", pozivni: ""} )


    //const tkc2 = useSelector((state) =>state.tkc)
    //const { user: currentUser } = useSelector((state) => state.auth);
    const user = localStorage.getItem("user");
    const username = localStorage.getItem("username");
    const ref = localStorage.getItem("id");



    const [allowedUsers, setAllowedUsers] = useState([])


    const [filteredTableData, setFilteredTableData] = useState([],[])
    const [data, setData] = useState([])



    ///////////////MODALI

    const [bijeleStraniceOpen, setBijeleStraniceOpen] = useState(false);
    const [zuteStraniceOpen, setZuteStraniceOpen] = useState(false);

    const [pojavljivanjeBijeleIsOpen, setPojavljivanjeBijeleIsOpen] = useState(false);

    const [openModalPosiljke, setOpenModalPosiljke] = useState(false);

    const [automaticBijeleOpen, setAutomaticBijeleOpen] = useState(false);

    const [similarTvrtkeModalOpen, setSimilarTvrtkeModalOpen] = useState(false);



    const [tableDataModalPosiljke, setTableDataModalPosiljke] = useState([]);

    const [bijeleZuteData, setBijeleZuteData] = useState([],[]);


    const [txtSearchAutoBijele, setTxtSearchAutoBijele] = useState('');

    const [similarCompanyData, setSimilarCompanyData] = useState([],[]);


    const [MJESTO_ID, setMJESTO_ID] = useState(0);

    const [ULICA_ID, setULICA_ID] = useState(0);

    const [kbr_Dod2, setKbr_Dod2] = useState('');

    

    





    
    
    const [filters, setFilters] = useState([false, false, false, false, false, false, false, false, false])

    const [check0, setCheck0] = useState(false);
    const [check1, setCheck1] = useState(false);
    const [check2, setCheck2] = useState(false);
    const [check3, setCheck3] = useState(false);
    const [check4, setCheck4] = useState(false);
    const [check5, setCheck5] = useState(false);
    const [check6, setCheck6] = useState(false);
    const [check7, setCheck7] = useState(false);
    const [check8, setCheck8] = useState(false);
    
    
    const [selectedItems, setSelectedItems] = useState([])
    const [selectedItemsTelefon, setSelectedItemsTelefon] = useState([])
    const [selectedItemsGrid, setSelectedItemsGrid] = useState([],[]);
    
    
    


    const [selectedReferent ,setSelectedReferent] = useState("")
    
    
    
    const [rasporedivanjeZadatakaIsShown, setRasporedivanjeZadatakaIsShown] = useState(false)
    

    

    const [changeVisible, setChangeVisible] = useState(false);
       const [archiveView, setArchiveView] = useState(false);





    


    const [doubleClickedRow, setDoubleClickedRow] = useState();

    const [bureInfo, setBureInfo] = useState('');

    const [telefon, setTelefon] = useState('');
    const [OIB, setOIB] = useState('');
    const [obrnuto, setObrnuto] = useState('');
    const [telefon2, setTelefon2] = useState('');
    const [OIB2, setOIB2] = useState('');
    const [obrnuto2, setObrnuto2] = useState('');

 const [errorUlica, setErrorUlica] = useState(false);


    const [oldUlica, setOldUlica] = useState('');
    const [oldMjesto, setOldMjesto] = useState('');    
 
     const [newUlica, setNewUlica] = useState('');
     const [newMjesto, setNewMjesto] = useState('');

    const [naziv1, setNaziv1] = useState('');
    const [naziv2, setNaziv2] = useState('');
    const [naziv12, setNaziv12] = useState('');
    const [naziv22, setNaziv22] = useState('');
    const [mjesto, setMjesto] = useState('');
    const [mjesto2, setMjesto2] = useState('');
    const [ulica, setUlica] = useState('');
    const [ulica2, setUlica2] = useState('');
    const [kbr, setKbr] = useState('');
    const [kbr2, setKbr2] = useState('');
    const [ptt, setPtt] = useState('');
    const [ptt2, setPtt2] = useState('');
    const [tip, setTip] = useState('');
    const [tip2, setTip2] = useState('');
    const [tip3, setTip3] = useState('');
    const [tip12, setTip12] = useState('');
    const [tip22, setTip22] = useState('');
    const [tip32, setTip32] = useState('');
    const [datum_mobile, setDatumMobile] = useState('');
    const [datum_mobile2, setDatumMobile2] = useState('');
    const [datumVal, setDatumVal] = useState('');
    const [datumVal2, setDatumVal2] = useState('');
    const [operator, setOperator] = useState('');
    const [akcija, setAkcija] = useState('');
    const [isObjava, setIsObjava] = useState(false);

    const [cnt, setCnt] = useState('');

    const [name, setName] = useState('');
    const [name2, setName2] = useState('');
    const [surname, setSurname] = useState('');
    const [surname2, setSurname2] = useState('');

    const [diffName, setDiffName] = useState('');
    const [diffSurname, setDiffSurname] = useState('');

    const [diffTel, setDiffTel] = useState(false);
    const [diffNaziv, setDiffNaziv] = useState(false);
    const [diffOIB, setDiffOIB] = useState(false);
    const [diffTip1, setDiffTIP1] = useState(false);
    const [diffTip2, setDiffTIP2] = useState(false);
    const [diffTip3, setDiffTIP3] = useState(false);
    const [diffMjesto, setDiffMjesto] = useState(false);
    const [diffUlica, setDiffUlica] = useState(false);
    const [diffPTT, setDiffPTT] = useState(false);


    const [statusObrade, setStatusObrade] = useState('');
    const [skloniti, setSkloniti] = useState('');
    const [komentar, setKomentar] = useState('');

    const [rucnoNaziv1, setRucnoNaziv1] = useState('');
    const [rucnoNaziv2, setRucnoNaziv2] = useState('');
    const [rucnoMjesto, setRucnoMjesto] = useState('');
    const [rucnoUlica, setRucnoUlica] = useState('');
    const [rucnoKBR, setRucnoKBR] = useState('');
    const [rucnoKBRDodatak, setRucnoKBRDodatak] = useState('');
    const [selectedRucnoTip, setSelectedRucnoTip] = useState(3);
        const [rucnoTip, setRucnoTip] = useState('');

    const [rucneKorekcije, setRucneKorekcije] = useState(false);

    const [tkOperatorRow, setTkOperatorRow] = useState('');
    const [tkOperatorRowID, setTkOperatorRowID] = useState('');
    const [akcijaRow, setAkcijaRow] = useState('');
    const [changingTKC, setChangingTKC] = useState(false);

    const [activeTKCRow, setActiveTKCRow] = useState('');
    

    const [chosenTKCRow, setChosenTKCRow] = useState('');


    const [flagChangeName, setFlagChangeName] = useState(false);


    const [listOfPozivni, setListOfPozivni] = useState([]);
    

    
    const [selectedCell, setSelectedCell] = useState()

    

    const [vratiObjavu, setVratiObjavu] = useState();


    const [changeOwner, setChangeOwner] = useState(false);

    const  [selectedOwner, setSelectedOwner] = useState(0)


    const [selectedCellForBS, setSelectedCellForBS] = useState([]);


    


    const [tkcFirma, setTkcFirma] = useState('');


    const [listUlice, setListUlice] = useState([]);
    const [selectedUlica, setSelectedUlica] = useState({'ULICA_ID':'', 'NAZIV':''});


    const [listMjesta, setListMjesta] = useState([]);
    const [selectedMjesto, setSelectedMjesto] = useState({'MJESTO_ID':'', 'NAZIV':''});

    const VISIBLE_FIELDS = ['Naziv', 'Telefon', 'Adresa'];


    const [menuListIsOpen, setMenuListIsOpen] = useState(null);    
    const [modalRowToBeShown, setModalRowToBeShown]= useState('')

    const [currentCodeBijele, setCurrentCodeBijele] = useState('');
    const [currentTKCBijele, setCurrentTKCBijele] = useState('');


/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*************************************LOKALIZACIJA MUI*************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

    const customLocaleText = {
        // Filter panel
        filterPanelAddFilter: 'Dodajte filter',
        filterPanelDeleteIconLabel: 'Ukloniti',
        filterPanelOperators: 'Operatori',
        filterPanelOperatorAnd: 'I',
        filterPanelOperatorOr: 'Ili',
        filterPanelColumns: 'Stupci',
        filterPanelInputLabel: 'Spremi',
    
        // Toolbar
        toolbarColumns: 'Stupci',
        toolbarFilters: 'Filteri',
        toolbarDensity: 'Gustoća',
        toolbarExport: 'Eksport',
        
        // Column menu
        columnMenuSortAsc: 'Uzlazno sortiranje',
        columnMenuSortDesc: 'Silazno sortiranje',
        columnMenuFilter: 'Filtrirati',
        columnMenuHideColumn: 'Sakrij stupac',
        columnMenuUnsort: 'Ukloni sortiranje',

        toolbarQuickFilterPlaceholder: 'Traži...',
        toolbarQuickFilterLabel: 'Traži',
        toolbarQuickFilterDeleteIconLabel: 'Očisti',
        // Filter operators text
        filterOperatorContains: 'sadrži',
        filterOperatorDoesNotContain: 'ne sadrži',
        filterOperatorEquals: 'jednako',
        filterOperatorDoesNotEqual: 'nije jednako',
        filterOperatorStartsWith: 'počinje s',
        filterOperatorEndsWith: 'završava s',
        filterOperatorIs: 'je',
        filterOperatorNot: 'nije',
        filterOperatorAfter: 'je iza',
        filterOperatorOnOrAfter: 'je na ili iza',
        filterOperatorBefore: 'je prije',
        filterOperatorOnOrBefore: 'je na ili prije',
        filterOperatorIsEmpty: 'je prazno',
        filterOperatorIsNotEmpty: 'nije prazno',
        filterOperatorIsAnyOf: 'je među',
        'filterOperator=': '=',
        'filterOperator!=': '!=',
        'filterOperator>': '>',
        'filterOperator>=': '>=',
        'filterOperator<': '<',
        'filterOperator<=': '<=',

        // Column menu text
        columnMenuLabel: 'Izbornik',
        columnMenuShowColumns: 'Pokaži stupce',
        columnMenuManageColumns: 'Uredi stupce',
        columnMenuFilter: 'Filter',
        columnMenuHideColumn: 'Sakrij stupac',
        columnMenuUnsort: 'Ukloni sortiranje',
        columnMenuSortAsc: 'Sortiraj uzlazno',
        columnMenuSortDesc: 'Sortiraj silazno',

        // Columns management text
        columnsManagementSearchTitle: 'Traži',
        columnsManagementNoColumns: 'Nema stupaca',
        columnsManagementShowHideAllText: 'Prikaži/sakrij sve',
        columnsManagementReset: 'Resetiraj',

        // Checkbox selection text
        checkboxSelectionHeaderName: 'Odabir redaka',
        checkboxSelectionSelectAllRows: 'Odaberi sve retke',
        checkboxSelectionUnselectAllRows: 'Ukloni odabir',
        checkboxSelectionSelectRow: 'Odaberi redak',
        checkboxSelectionUnselectRow: 'Ukloni odabir retka',
    
        // Rows
        footerRowSelected: (count) => `${count} redaka odabrano`,
        noRowsLabel: 'Nije odabran nijedan redak',
    };




/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

const resetPositionModal=(e)=>{




    if(e.keyCode==81 ) {
        console.log("Testing");
        console.log(automaticBijeleOpen);

        if(automaticBijeleOpen){
            console.log(e.keyCode);
            setModalPositionAutomaticBijele({x:0,y:0});
        } else if(openModalPosiljke){
            setModalPositionFiles({x:0,y:0});

        //} else if(bijeleStraniceOpen){
        //    setModalPosition({x:0,y:0});

        //}else if(zuteStraniceOpen){
        //    setModalPositionAutomaticBijele({x:0,y:0});

        } else if(pojavljivanjeBijeleIsOpen){
            setModalPojavljivanjeBijele({x:0,y:0});

        }else{
            console.log("Ignore!!!");
        }
    }
}

const [isDraggingAutomaticBijele, setIsDraggingAutomaticBijele] = useState(false)
const [automaticBijeleOpenPosition,setAutomaticBijeleOpenPosition] = useState(false)

const [modalPositionaAutomaticBijele, setModalPositionAutomaticBijele] = useState({x:0,y:0})
const startPositionAutomaticBijele = useRef({x:0,y:0})
const popupRefAutomaticBijele = useRef(null)



const [isDraggingPojavljivanjeBijele, setIsDraggingPojavljivanjeBijele] = useState(false)
const [pojavljivanjeBijelePosition,setPojavljivanjeBijelePosition] = useState(false)

const [modalPositionaPojavljivanjeBijele, setModalPojavljivanjeBijele] = useState({x:0,y:0})
const startPositionPojavljivanjeBijele = useRef({x:0,y:0})
const popupRefPojavljivanjeBijele = useRef(null)


const [isDraggingFilesModal, setIsDraggingFilesModal] = useState(false)
const [filesModalPosition,setFilesModalPosition] = useState(false)

const [modalPositionFiles, setModalPositionFiles] = useState({x:0,y:0})
const startPositionFiles = useRef({x:0,y:0})
const popupRefFiles = useRef(null)

const onMouseMove = useCallback((e) => {
    //console.log(e.clientx, startPosition);
  if (!isDraggingAutomaticBijele) return;
  setModalPositionAutomaticBijele({
    x: e.clientX - startPositionAutomaticBijele.current.x,
    y: e.clientY - startPositionAutomaticBijele.current.y,
  });
  if (!isDraggingPojavljivanjeBijele) return;
  setModalPojavljivanjeBijele({
    x: e.clientX - startPositionPojavljivanjeBijele.current.x,
    y: e.clientY - startPositionPojavljivanjeBijele.current.y,
  });
  if (!isDraggingFilesModal) return;
  setModalPositionFiles({
    x: e.clientX - startPositionFiles.current.x,
    y: e.clientY - startPositionFiles.current.y,
  });
  
},
[isDraggingAutomaticBijele, isDraggingPojavljivanjeBijele, isDraggingFilesModal]
);

// Function to handle the end of a drag event
const onMouseUp = () => {
    setIsDraggingAutomaticBijele(false);
    setIsDraggingPojavljivanjeBijele(false);
    setIsDraggingFilesModal(false);
};

const onMouseDown = (e) => {
console.log("on mouse down")
e.stopPropagation();
setIsDraggingAutomaticBijele(true);
startPositionAutomaticBijele.current = { x: e.clientX - modalPositionaAutomaticBijele.x, y: e.clientY - modalPositionaAutomaticBijele.y }

setIsDraggingPojavljivanjeBijele(true);
startPositionPojavljivanjeBijele.current = { x: e.clientX - modalPositionaPojavljivanjeBijele.x, y: e.clientY - modalPositionaPojavljivanjeBijele.y }

setIsDraggingFilesModal(true);
startPositionFiles.current = { x: e.clientX - modalPositionFiles.x, y: e.clientY - modalPositionFiles.y }
}


useEffect(() => {
window.addEventListener("mousemove", onMouseMove);
window.addEventListener("mouseup", onMouseUp);
window.addEventListener("keydown", resetPositionModal);

return () => {
  window.removeEventListener("mousemove", onMouseMove);
  window.removeEventListener("mouseup", onMouseUp);
  window.removeEventListener("keydown", resetPositionModal);

};
}, [onMouseMove], resetPositionModal);

// Reset position when the popup is closed
useEffect(() => {
if (!automaticBijeleOpen) {
  setAutomaticBijeleOpenPosition({ x: 0, y: 0 });
}
if (!pojavljivanjeBijeleIsOpen) {
    setPojavljivanjeBijelePosition({ x: 0, y: 0 });
  }

if (!openModalPosiljke) {
    setFilesModalPosition({ x: 0, y: 0 });
}
}, [automaticBijeleOpen, pojavljivanjeBijeleIsOpen, openModalPosiljke]);


/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*************************************TOAST************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

const toastError = {                                                        
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "light",
};

const toastSuccess = {                                                        
         position: "top-center",
         autoClose: 2000,
         hideProgressBar: false,
         closeOnClick: true,
         pauseOnHover: false,
         draggable: true,
         progress: undefined,
         theme: "light",
};

const toastInfo = {                                                        
         position: "top-center",
         autoClose: 2000,
         hideProgressBar: false,
         closeOnClick: true,
         pauseOnHover: false,
         draggable: true,
         progress: undefined,
         theme: "light",
};


/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*************************************USEEFFECT********************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */


const [selectedNetwork, setSelectedNetwork] = useState(null);

useEffect(() => {

    
        getAllowedUsers();

        let tmp = new Date();

        tmp.setMinutes(tmp.getMinutes() - 25);


        let timeNow = tmp.getDate() + "." + (tmp.getMonth() + 1) + "." + " " + tmp.getHours() + ":" + tmp.getMinutes();

        
        setCurrTime(timeNow);

        getFiles();


        // Load stored object from sessionStorage

        GetPozivni();

        console.log("Getting the tkc from sessionStorage")

        const storedData = sessionStorage.getItem("selectedNet");
        if (storedData) {

            try {
                const parsedData = JSON.parse(storedData);
                setSelectedNetwork(parsedData);
                } catch (error) {
                console.error("Error parsing sessionStorage:", error);
                sessionStorage.removeItem("selectedNet"); 
                }

        }
        

}, []);

useEffect(()=>{
        document.title="Telemach"
},[])


const handleChange = (event) => {

    console.log(event.target);

    let sel = '';

    if(event.target.value && event.target.value!=''){
            const selected = listOfPozivni.find((obj) => {
                console.log("Checking");
                console.log(obj);
                console.log(obj.pozivni);
                console.log(event.target.value);
                
                if (obj.pozivni === event.target.value)
                return obj;
            });
            console.log(selected);
            setSelectedNetwork(selected);

            sel = selected;
            sessionStorage.setItem("selectedNet", JSON.stringify(selected));
    } else {

            sel = {pozivni:'', tkc:''}
            console.log("Setting");
            console.log(sel);
            setSelectedNetwork(sel);
            sessionStorage.setItem("selectedNet", JSON.stringify(sel));

    }

    console.log("Did the network change!!!");

    console.log("Checkthechanges");

    console.log(sel);

    if(changeVisible){

            if(selectedOwner == 1){

                getDataChangesRefNet(sel.tkc);

            } else {

                getDataChangesNet(sel.tkc);
            }
    }

};

/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*************************************FUNKCIJE*********************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */



const skiniOznacene = () => {



    
    let activeNetTmp = '';

    if(!selectedNetwork || selectedNetwork.tkc==''){


        console.log("Nije odabrana mreža za referente!!");
  

        toast.error("Ne možete skidati podatke dok niste odabrali mrežu i prebacili podatke na sebe", toastError);

    }else {

            console.log("Odabrana je mreža");
            console.log(selectedNetwork)

            console.log(selectedNetwork.tkc);

            Swal.fire({
                title: `Jeste li sigurni da želite skinuti sve podatke koji su u statusu 2,1 i 5,1 iz odabrane županije?`,
                text: "Ova radnja se ne može poništiti",
                icon: "warning",
                iconSize: '5',
        
                showCancelButton: true,
                confirmButtonColor: "#e31b2e",
                cancelButtonColor: "#29648a",
                showCancelButton: true,
                confirmButtonText: "Skini",
                cancelButtonText: "Odustani",
                reverseButtons: true
              }).then((result) => {
                if (result.isConfirmed) {
        
                    
                    APICall("/makniGotoveDnevnik_Sve", {

                        platform: '0',
                        version:'1.0',
                        tkID: tkList.map(item=>item.toString()),
                        referent: ref,
                        tkc:selectedNetwork.tkc
                        
                
                    }, {
                        token
                    }).then(response=>{
                        
                        if(response.status !== 200) {
                
                            if(response.status == 401){
                
                                console.log("Istekla sesija");
                
                                toast.error(response.data.message, toastError);
                                
                                dispatch(actions.logOut());
                                navigate('/');
                
                        } else{
                
                
                                toast.error(response.data.message, toastError);
                
                               
                
                        }
                
                
                        } else {
                            
                       
                            toast.success("Uspješno skinute odabrane promjene", toastSuccess);
                
                            if(selectedOwner == 1){
                
                                getDataChangesRef();
                
                            } else {
                
                                getDataChanges();
                            }
                        }
                        
                    
                    }).catch(error=> {
                            
                            console.log(error);
                
                
                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);                    
                
                           
                    })
                }
              });


    }


    
};   




async function getAllowedUsers() {


    console.log("Getting allowed users");

    //console.log(tkc)
    console.log(selectedNetwork)


    let activeNetTmp = '';

    //if(!tkc || tkc==''){
    if(!selectedNetwork || selectedNetwork.tkc==''){


            console.log("Nije odabrana mreža za referente!!");
            //console.log(tkc);
            //console.log(selectedNetwork)

            activeNetTmp = '';

    }else {

            console.log("Odabrana je mreža");
            //console.log(tkc);
            console.log(selectedNetwork)

            //console.log(tkc.length);
            //console.log(tkc.pozivni);
            console.log(selectedNetwork.pozivni);

            //activeNetTmp = tkc.pozivni;

            activeNetTmp = selectedNetwork.pozivni;

    
    } 

    APICall("/GetAllowedUsers", {

        platform: '0',
        version:'1.0',
        poziv: activeNetTmp

        
    }, {
        token
    }).then(response=>{
            
            console.log("Gotten response for allowed users!!!");
            console.log(response)

            if(response.status !== 200) {

                    if(response.status == 401){


                            toast.error(response.data.message, toastError);

                            setTimeout(() => {
                                    dispatch(actions.logOut());
                                    navigate('/');
                            }, 5000);   


                    } else{

                            toast.error(response.data.message, toastError);

                    }


            } else {
                
                if(response.data.list && response.data.list.length!=0){

                        console.log(response.data.list)
                        setAllowedUsers(response.data.list)

                } else {

                        console.log("Ne postoje dozvoljeni korisnici")
                        //toast.info(response.data.message, toastInfo);
                }

            }
            
        
    }).catch(error=> {
            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                toastError);   
    })
}

async function getFiles() {
    
    
    APICall("/GetFiles", {

        platform: '0',
        version:'1.0',
        tkID: tkList.map(item=>item.toString()),

    }, {
        token
    }).then(response=>{
        
        if(response.status !== 200) {

            if(response.status == 401){


                    toast.error(response.data.message, toastError);

                    setTimeout(() => {
                        dispatch(actions.logOut());
                        navigate('/');
                    }, 5000);   


            } else{

                    toast.error(response.data.message, toastError);

            }


        } else {
            
            if(response.data.list && response.data.list.length!=0){

                    let formattedData = response.data.list.map((item) => {
                        
                        let dateObj = new Date(item.date_start);
                        let dateObj2 = new Date(item.date_end);


                        const options = {              
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                        };

                        let formattedDate = dateObj.toLocaleDateString("hr-HR", options);
                        let formattedDate2 = dateObj2.toLocaleDateString("hr-HR", options);


                        return { ...item, date_start: formattedDate, date_end: formattedDate2 };
                    });

                    //setTableDataModalPosiljke(response.data.list)
                    setTableDataModalPosiljke(formattedData);

            } else {

                    toast.info(response.data.message, toastInfo);
            }

        }
        
    
    }).catch(error=> {
            

            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                toastError);                    

           
    })
        
}

const GetPozivni = async() => {
    dispatch(actions.isLoading());
   await  APICall("/GetPozivni", {
      platform: '0',
      version:'1.0'
    },{
      token
    }).then(response =>{
            if(response.status !== 200) {

              if(response.status == 401){

                      console.log("Istekla sesija");

                      toast.error(response.data.message, toastError);
                      
                      dispatch(actions.logOut());
                      navigate('/');

              } else{

                      //toast.error(response.data.message, toastError);


              }
              



          } else {
              
                  console.log("Getting pozivni in navigation!!!!!!!")
                  console.log(response.data.list);
                  let tmp = response.data.list;
                  tmp = tmp.sort((a,b) => a.pozivni - b.pozivni);
                  console.log("Sorted!!!");
                  console.log(tmp);
                  setListOfPozivni(tmp);
          }


          if (response==undefined) dispatch(actions.isNotLoading());
    })
    dispatch(actions.isNotLoading());
}

async function getDataChanges () {


    dispatch(actions.isLoading());

    console.log(filters);

    

    setSelectedItems([]);
    setSelectedItemsTelefon([]);

    setSelectedOwner(0);

   /*
    setFilters([false, false, false, false, false, false, false, false, false]);

    setCheck0(false);
    setCheck1(false);
    setCheck2(false);
    setCheck3(false);
    setCheck4(false);
    setCheck5(false);
    setCheck6(false);
    setCheck7(false);
    setCheck8(false);
    */

    
    APICall(
     
        '/GetDnevnePromjene',
        
        {

             platform: '0',
             version:'1.0',
             oper: tkList.map(item=>item.toString()),

         },
        {
            token
        }).then(


            (response) => {
               
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
            
                if(response.status==200){
                            if(response.data.list && response.data.list.length!=0){
                                  var dataTmp = response.data;

                          
                                console.log(dataTmp.list[0]);


                          

                                let dataNew = [];

                                //if(tkc && tkc.tkc != ''){

                                if(selectedNetwork && selectedNetwork.tkc != ''){

                                    console.log("Tkc je odabran!!!");
                                    //console.log(tkc.tkc);
                                    console.log(selectedNetwork.tkc);

                                    dataNew = dataTmp.list.filter((val)=>{
                                        console.log(val);
                                        //if(val.TKC == tkc.tkc) return val;
                                        if(val.TKC == selectedNetwork.tkc) return val;
                                        
                                    })

                                } else {

                                    dataNew = dataTmp.list;
                                }

                                handleFilterChangesOnArrival(filters, dataNew);

                                setData(dataNew);

                                /*

                                  let i = 0;

                                  let columns= Object.getOwnPropertyNames(dataNew[0]).map((column,index)=>{
                                        var a = column.charAt(0).toUpperCase() + column.slice(1);
                                        return(
                                            {
                                                "field": column,
                                                "getRowId": index,
                                                
                                            
                                            }
                                        )
                                    })

                                    

                                const comparator = (v1, v2) => {
                                    const currVal = v1.startsWith('***')?v1.substring(3):v1;
                                    const nextVal = v2.startsWith('***') ?v2.substring(3):v2;
                                  
                                    if (currVal === nextVal) { return 0; }
                                  
                                    return currVal < nextVal ? -1 : 1;
                                  }
                                  



                                const updatedColumns = columns.map((col) => {
                               
                                    if(col.field == 'rbr'){

                                        return{

                                            ...col,
                                            'headerCheckboxSelection': true,
                                        }
                                    }
                                    if(col.field == 'Datum'){

                                        return {
                                            ...col,
                                            valueFormatter: ({ value }) => {
                                              if (value) {
                                                
                                               
                                                let date = new Date(value);


                                                //return date.toLocaleDateString("DD.MM.YYYY"); // Format as MM/DD/YYYY (or customize)
                                                const options = {
                                                 
                                                    year: "numeric",
                                                    month: "numeric",
                                                    day: "numeric",
                                                  };
                                                  return date.toLocaleDateString("hr-HR", options);
                                                
                                               
                                              }
                                              return value;
                                            },
                                            sortComparator: (v1, v2) => {
                                              const date1 = new Date(v1);
                                              const date2 = new Date(v2);
                                              return date1 - date2; // Compare dates
                                            },
                                          };
                                        

                                    }

                                    if(col.field == 'Vrsta rada'){

                                        return {
                                            ...col, comparator
                                         
                                          };
                                        

                                    }

                                    return col;
                                });


                                    columns = updatedColumns;

                                    
                                    let rows =dataNew.map((item, index)=> {
                                        return({...item,id:index})
                                    })

                                  

                                    setFilteredTableData({
                                            columns,
                                            rows
                                    })
                                */




                   
                                       
                                  }else{

     

                                   // toast.info(response.data.message,
                                   //     toastError);
                               
              

                                   setFilteredTableData([],[])

                                   setData([]);     

                            }

                        } else {
        
                            if(response.status == 401){
        
                                    console.log("Istekla sesija");
            
                                    toast.error(response.data.message, toastError);
                                    
                                    dispatch(actions.logOut());
                                    navigate('/');
        
                            } else {
                                    toast.error(response.data.message,
                                        toastError);
                                                        
        
                            }
        
                    
                        }     
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
                setFilteredTableData([],[]);


            
                        if(!error.response){

                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);
                          


                        } else {


                             if(!error.response.status){

                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);

                             }else{

                                  if (error.response.status == 401) {
              
                           
                                       toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                  
                             
                                  } else {
                             
                             
                                            toast.error(error.response.data.message,
                                                 toastError);
                                                                           
                                       
                                  }
                             }
                        }
                    
                   
            
            
            });

            
            
}      

async function getDataChangesRef () {


    console.log("Filters are:");
    console.log(filters);

    setSelectedOwner(1);


    

    setSelectedItems([]);
    setSelectedItemsTelefon([]);
/*
    setFilters([false, false, false, false, false, false, false, false, false]);



    setCheck0(false);
    setCheck1(false);
    setCheck2(false);
    setCheck3(false);
    setCheck4(false);
    setCheck5(false);
    setCheck6(false);
    setCheck7(false);
    setCheck8(false);
    */

    dispatch(actions.isLoading());

    

    
    APICall(
        //'/GetDnevneFiksni',
        '/GetDnevnePromjeneFiltered',
        
        {

             platform: '0',
             version:'1.0',
             oper: tkList.map(item=>item.toString()),
             ref: ref

         },
        {
            token
        }).then(


            (response) => {
               
                            console.log("Whaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaat?!");

                            console.log(response);

                            dispatch(actions.isNotLoading());

                            if(response==undefined) dispatch(actions.isNotLoading());
            
                            if(response.data.list && response.data.list.length!=0){
                                    var dataTmp = response.data;

                                    console.log(dataTmp.list[0]);
                          

                                    let dataNew = [];
    
                                    //if(tkc && tkc.tkc != ''){
                                    if(selectedNetwork && selectedNetwork.tkc != ''){
    
                                        dataNew = dataTmp.list.filter((val)=>{
                                            console.log(val);
                                            //if(val.TKC == tkc.tkc) return val;
                                            if(val.TKC == selectedNetwork.tkc) return val;
                                            
                                        })
    
                                    } else {
    
                                        dataNew = dataTmp.list;
                                    }
                                    
                                    handleFilterChangesOnArrival(filters, dataNew);

                                    setData(dataNew);

                                    /*
    
                                      let i = 0;
    
                                      let columns= Object.getOwnPropertyNames(dataNew[0]).map((column,index)=>{
                                            var a = column.charAt(0).toUpperCase() + column.slice(1);
                                            return(
                                                {
                                                    "field": column,
                                                    "getRowId": index,
                                                    
                                                
                                                }
                                            )
                                        })
    
                                        
    
                                    const comparator = (v1, v2) => {
                                        const currVal = v1.startsWith('***')?v1.substring(3):v1;
                                        const nextVal = v2.startsWith('***') ?v2.substring(3):v2;
                                      
                                        if (currVal === nextVal) { return 0; }
                                      
                                        return currVal < nextVal ? -1 : 1;
                                      }
                                      
    
    
    
                                    const updatedColumns = columns.map((col) => {
                                   
                                        if(col.field == 'rbr'){
    
                                            return{
    
                                                ...col,
                                                'headerCheckboxSelection': true,
                                            }
                                        }
                                        if(col.field == 'Datum'){
    
                                            return {
                                                ...col,
                                                valueFormatter: ({ value }) => {
                                                  if (value) {
                                                    
                                                   
                                                    let date = new Date(value);
    
    
                                                    //return date.toLocaleDateString("DD.MM.YYYY"); // Format as MM/DD/YYYY (or customize)
                                                    const options = {
                                                     
                                                        year: "numeric",
                                                        month: "numeric",
                                                        day: "numeric",
                                                      };
                                                      return date.toLocaleDateString("hr-HR", options);
                                                    
                                                   
                                                  }
                                                  return value;
                                                },
                                                sortComparator: (v1, v2) => {
                                                  const date1 = new Date(v1);
                                                  const date2 = new Date(v2);
                                                  return date1 - date2; // Compare dates
                                                },
                                              };
                                            
    
                                        }
    
                                        if(col.field == 'Vrsta rada'){
    
                                            return {
                                                ...col, comparator
                                             
                                              };
                                            
    
                                        }
    
                                        return col;
                                    });
    
    
                                        columns = updatedColumns;
    
                                        
                                        let rows =dataNew.map((item, index)=> {
                                            return({...item,id:index})
                                        })
    
                                      
    
                                        setFilteredTableData({
                                                columns,
                                                rows
                                        })

                                        */
                                       

                   
                                       
                                  }else{

     

                                            //toast.info(response.data.message,
                                            //     toastError);
                                         
                                      

                                            setFilteredTableData([],[])

                                            setData([]);
         
              
                                         

                                  }
           
                    
            
            },

            (error) => {

                        dispatch(actions.isNotLoading());

                        setFilteredTableData([],[]);

            
            
                        console.log("It's an error init?");

            
                        if(!error.response){

                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);
                          


                        } else {


                             if(!error.response.status){

                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);

                             }else{

                                  if (error.response.status == 401) {
              
                           
                                       toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                  
                             
                                  } else {
                             
                             
                                            toast.error(error.response.data.message,
                                                 toastError);
                                                                           
                                       
                                  }
                             }
                        }
                    
                   
            
            
            });

            
            
}       

/*********************************************************** */

async function getDataChangesNet (net) {


    dispatch(actions.isLoading());

    console.log(filters);

    

    setSelectedItems([]);
    setSelectedItemsTelefon([]);

    setSelectedOwner(0);

    console.log("Getting changes from netowrk");
    console.log(net);

    
    APICall(
     
        '/GetDnevnePromjene',
        
        {

             platform: '0',
             version:'1.0',
             oper: tkList.map(item=>item.toString()),

         },
        {
            token
        }).then(


            (response) => {
               
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
            
                            if(response.data.list && response.data.list.length!=0){
                                  var dataTmp = response.data;

                          
                                console.log(dataTmp.list[0]);


                          

                                let dataNew = [];

                                //if(tkc && tkc.tkc != ''){

                                if(net && net != ''){

                                    console.log("Tkc je odabran!!!");
                                    //console.log(tkc.tkc);
                                    console.log(net);

                                    dataNew = dataTmp.list.filter((val)=>{
                                        console.log(val);
                                        //if(val.TKC == tkc.tkc) return val;
                                        if(val.TKC == net) return val;
                                        
                                    })

                                } else {

                                    dataNew = dataTmp.list;
                                }

                                handleFilterChangesOnArrival(filters, dataNew);

                                setData(dataNew);

                   
                                       
                                  }else{

     
              

                                   setFilteredTableData([],[])

                                   setData([]);     

                                  }
           
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
                setFilteredTableData([],[]);


            
                        if(!error.response){

                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);
                          


                        } else {


                             if(!error.response.status){

                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);

                             }else{

                                  if (error.response.status == 401) {
              
                           
                                       toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                  
                             
                                  } else {
                             
                             
                                            toast.error(error.response.data.message,
                                                 toastError);
                                                                           
                                       
                                  }
                             }
                        }
                    
                   
            
            
            });

            
            
}      

async function getDataChangesRefNet (net) {


    console.log("Getting changes from netowrk");
    console.log(net);


    console.log("Filters are:");
    console.log(filters);

    setSelectedOwner(1);


    

    setSelectedItems([]);
    setSelectedItemsTelefon([]);


    dispatch(actions.isLoading());


    APICall(

        '/GetDnevnePromjeneFiltered',
        
        {

             platform: '0',
             version:'1.0',
             oper: tkList.map(item=>item.toString()),
             ref: ref

         },
        {
            token
        }).then(


            (response) => {
               
             

                            console.log(response);

                            dispatch(actions.isNotLoading());

                            if(response==undefined) dispatch(actions.isNotLoading());
            
                            if(response.data.list && response.data.list.length!=0){
                                    var dataTmp = response.data;

                                    console.log(dataTmp.list[0]);
                          

                                    let dataNew = [];
    
                                    //if(tkc && tkc.tkc != ''){
                                    if(net && net != ''){
    
                                        dataNew = dataTmp.list.filter((val)=>{
                                            console.log(val);
                                            //if(val.TKC == tkc.tkc) return val;
                                            if(val.TKC == net) return val;
                                            
                                        })
    
                                    } else {
    
                                        dataNew = dataTmp.list;
                                    }
                                    
                                    handleFilterChangesOnArrival(filters, dataNew);

                                    setData(dataNew);

                                       
                                  }else{


                                            setFilteredTableData([],[])

                                            setData([]);
         
              
                                         

                                  }
           
                    
            
            },

            (error) => {

                        dispatch(actions.isNotLoading());

                        setFilteredTableData([],[]);

            
            
                        console.log("It's an error init?");

            
                        if(!error.response){

                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);
                          


                        } else {


                             if(!error.response.status){

                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);

                             }else{

                                  if (error.response.status == 401) {
              
                           
                                       toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                  
                             
                                  } else {
                             
                             
                                            toast.error(error.response.data.message,
                                                 toastError);
                                                                           
                                       
                                  }
                             }
                        }
                    
                   
            
            
            });

            
            
}      






/*********************************************************** */
function promijeniStatusStanjeInterval(stat, got){



    let unmounted = false;
    let source = axios.CancelToken.source();

    console.log("Status-stanje interval!!!");

    console.log(selectedItems.length);
    /*
    console.log(telefon);
    */
    console.log(stat);
    console.log(got)
    console.log(ref)
    console.log(operator);




    if(!selectedItems || selectedItems.length == 0){

                toast.error("Nema odabranih podataka za mijenjanje podataka", toastError);

    } else {

        APICall(
            '/IzmjenaStatusa_Interval',
            {
    
                platform: '0',
                version:'1.0',
                list:selectedItems,
                status: stat,
                stanje: got,
                tkID: tkList.map(item=>item.toString()),
                //tkID: operator,
                ref:ref,
                komentar: komentar
    
            },
            {
                token
            }).then(
    
    
                (response) => {
    
            
            
                    dispatch(actions.isNotLoading());

                    if(response==undefined) dispatch(actions.isNotLoading());
                
                    if(response.status == 200){
                            
                            toast.info(response.data.message, toastInfo);


                            if(selectedOwner == 1){

                                getDataChangesRef();
                            } else {

                                getDataChanges();
                            }
                            
    
                    } else {
    
                        if(response.status == 401){
    
                                console.log("Istekla sesija");
        
                                toast.error(response.data.message, toastError);
                                
                                dispatch(actions.logOut());
                                navigate('/');
    
                        } else {
                                toast.error(response.data.message,
                                    toastError);
                                                    
    
                        }
    
                
                    }        
                

                
                },
    
                (error) => {
    
                    if (!unmounted) {
                
                
    
    
                
                            if(!error.response){
    
                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            
    
    
                            } else {
    
    
                                if(!error.response.status){
    
                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
    
                                }else{
    
                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   
    
                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                            }
                        
                    }
                
                
                });
    }








}

function promijeniStatusStanje(stat, got, currRef){



    let unmounted = false;
    let source = axios.CancelToken.source();

    console.log("Status-stanje!!!");
    console.log(telefon);
    console.log(stat);
    console.log(got)
    console.log(ref)
    console.log(operator);

    console.log(currRef);


    if(currRef != ref){

                toast.error("Ne možete mijenjati status podataka koje niste preuzeli na sebe");

    } else {

        APICall(
            '/IzmjenaStatusa',
            {
    
                platform: '0',
                version:'1.0',
                tel:telefon,
                status: stat,
                stanje: got,
                cnt:cnt,
                //tkID: tkList.map(item=>item.toString()),
                tkID: operator,
                ref:ref,
                komentar: komentar
    
            },
            {
                token
            }).then(
    
    
                (response) => {
    
            
            
                    dispatch(actions.isNotLoading());

                    if(response==undefined) dispatch(actions.isNotLoading());
                
                    if(response.status == 200){
                            
                            toast.info(response.data.message, toastInfo);

                            if(selectedOwner == 1){

                                getDataChangesRef();
                            } else {

                                getDataChanges();
                            }
                            
    
                    } else {
    
                        if(response.status == 401){
    
                                console.log("Istekla sesija");
        
                                toast.error(response.data.message, toastError);
                                
                                dispatch(actions.logOut());
                                navigate('/');
    
                        } else {
                                toast.error(response.data.message,
                                    toastError);
                                                    
    
                        }
    
                
                    }        
                

                
                },
    
                (error) => {
    
                    if (!unmounted) {
                
                
    
    
                
                            if(!error.response){
    
                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            
    
    
                            } else {
    
    
                                if(!error.response.status){
    
                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
    
                                }else{
    
                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   
    
                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                            }
                        
                    }
                
                
                });
    }








}

async function getDataPhone (oznaka) {


    dispatch(actions.isLoading());

    
    APICall(

        '/GetTelefonDnevne',
        
        {

             platform: '0',
             version:'1.0',
             oznaka: oznaka,

         },
        {
            token
        }).then(


            (response) => {
               
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());

                if(response.status==200){
            
                        if(response.data.naziv && response.data.naziv != ""){
                                
                                        let mj = '';
                                        let adr = '';
                                        let pt = '';
                            

                                        if(response.data.nazivMjesto && response.data.nazivMjesto!=''){

                                            mj = response.data.nazivMjesto;

                                        }
                                        if(response.data.nazivUlica && response.data.nazivUlica!=''){

                                            adr = response.data.nazivUlica;

                                        }
                                        if(response.data.adm_kucni_broj && response.data.adm_kucni_broj!=''){

                                            adr = adr + ' ' + response.data.adm_kucni_broj;

                                        }                                
                                        if(response.data.ptt && response.data.ptt!=''){

                                            pt = response.data.ptt;

                                        }
                                        if(response.data.adm_kbr_dodatak && response.data.adm_kbr_dodatak!=''){
                                            
                                            adr = adr + ' ' + response.data.adm_kbr_dodatak;
                                        }
                                        let obj = response.data.objava?"DA":"NE";

                                        setBureInfo("" + response.data.naziv + " - " + response.data.tip + " / " + response.data.tajnost + " / " 
                                            + "Objava=" + obj + " --- "
                                            + mj + " --- " + adr + " --- " + pt +   
                                             
                                            " --- " + response.data.tk_oper + "---" + response.data.tk_operator
                                        )


                        
                                            
                        }else if(response.data.setMsg && response.data.setMsg==1){

                                        setBureInfo(response.data.message);
                        }

                } else {

                    if(response.status == 401){

                            console.log("Istekla sesija");
    
                            toast.error(response.data.message, toastError);
                            
                            dispatch(actions.logOut());
                            navigate('/');

                    } else {
                            toast.error(response.data.message,
                                toastError);
                                                

                    }
  
               
                }        
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
            


            
                        if(!error.response){

                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);
                          


                        } else {


                             if(!error.response.status){

                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);

                             }else{

                                  if (error.response.status == 401) {
              
                           
                                       toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                  
                             
                                  } else {
                             
                             
                                            toast.error(error.response.data.message,
                                                 toastError);
                                                                           
                                       
                                  }
                             }
                        }
                    
                   
            
            
            });

            
            
} 

async function getUlicaFromID (id, idMjesto) {


    return     APICall(

        '/GetUlicaFromID',
        
        {

             platform: '0',
             version:'1.0',
             ulica: id,
             mjesto:idMjesto

         },
        {
            token
        })
    

            
            
} 

async function getMjestoFromID (idMjesto) {

    
    return APICall(

        '/GetMjestoFromID',
        
        {

             platform: '0',
             version:'1.0',

             mjesto:idMjesto

         },
        {
            token
        })

            
            
} 


function updateOznaka() {
      
   
    let unmounted = false;
    let source = axios.CancelToken.source();

    console.log("*********** referent to send *********");
    console.log(selectedReferent)

    dispatch(actions.isLoading());



    APICall(
        '/UpdateValDnevnik_v2',
        {

            platform: '0',
            version:'1.0',
            //oznaka: selectedItemsTelefon,
            oznaka: selectedItems,
            referent: selectedReferent

        },
        {
            token
        }).then(


            (response) => {




                        dispatch(actions.isNotLoading());

                        if(response==undefined) dispatch(actions.isNotLoading());
                    
                        if(response.status == 200){
                                
                                toast.info(response.data.message, toastInfo);

                     
                                setRasporedivanjeZadatakaIsShown(false);
    
                                getDataChangesRef();

        
                        } else {
        
                            if(response.status == 401){
        
                                    console.log("Istekla sesija");
            
                                    toast.error(response.data.message, toastError);
                                    
                                    dispatch(actions.logOut());
                                    navigate('/');
        
                            } else {
                                    toast.error(response.data.message,
                                        toastError);
                                                        
        
                            }
        
                    
                        }        
                    

            
            },

            (error) => {

                        dispatch(actions.isNotLoading());

                        if(!error.response){

                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);
                        


                        } else {


                            if(!error.response.status){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);

                            }else{

                                if (error.response.status == 401) {
            
                        
                                    toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                
                            
                                } else {
                            
                            
                                            toast.error(error.response.data.message,
                                                toastError);
                                                                        
                                    
                                }
                            }
                        }

            
            });

             
    
}


async function vratiArhiva(tel, cnt, datum_curr, tkID_curr){



    console.log("Vraćam******************************************")

    console.log(tel);


    console.log(cnt);



    dispatch(actions.isLoading());


 
    APICall(
        '/vratiArhiva_v2',
        
        {


             oznaka_n: tel,
             cnt: cnt,
             referent: ref,
             datum_curr: datum_curr,
             datum_inserta: new Date(),
             tkID: tkID_curr

         },
        {
            token
        }).then(


            (response) => {
               
                console.log(response);
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
            
                if(response.status==200){


                                    console.log("Došli reeeeeez");
                                    console.log(response.data);


                                   toast.info("Uspješno odrađene sve izmjene",
                                   toastSuccess);
                                

                                       
                }else{

     

                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                        toastError);

                                   

                                  


            }
           
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());




            
                        if(!error.response){

                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);


                        } else {

                             if(!error.response.status){

                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);

                             }else{

                                  if (error.response.status == 401) {
              
                           
                                       toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                  
                             
                                  } else {
                             
                             
                                            toast.error(error.response.data.message,
                                                 toastError);
                                                                           
                                       
                                  }
                             }
                        }
                    

            });
           

}

async function vratiArhivaIzvor(tel, cnt, datum_curr, tkID_curr){



    console.log("Vraćam******************************************")

    console.log(tel);


    console.log(cnt);



    dispatch(actions.isLoading());


 
    APICall(
        '/vratiArhiva_v2',
        
        {


             oznaka_n: tel,
             cnt: cnt,
             referent: ref,
             datum_curr: datum_curr,
             datum_inserta: new Date(datum_curr),
             tkID: tkID_curr

         },
        {
            token
        }).then(


            (response) => {
               
                console.log(response);
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
            
                if(response.status==200){


                                    console.log("Došli reeeeeez");
                                    console.log(response.data);


                                   toast.info("Uspješno odrađene sve izmjene",
                                   toastSuccess);
                                

                                       
                }else{

     

                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                        toastError);

                                   

                                  


            }
           
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());




            
                        if(!error.response){

                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);


                        } else {

                             if(!error.response.status){

                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);

                             }else{

                                  if (error.response.status == 401) {
              
                           
                                       toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                  
                             
                                  } else {
                             
                             
                                            toast.error(error.response.data.message,
                                                 toastError);
                                                                           
                                       
                                  }
                             }
                        }
                    

            });
           

}

const handleOwnerChange = (event) => {
    setSelectedOwner(event.target.id);
    
    console.log(event);
    console.log(event.target.id);

    console.log("Traženi referent je: " + ref);

    if(event.target.id == 1){

        getDataChangesRef();

    } else {

        getDataChanges();

    }

};

const handleFilterChanges = (filters) => {
    console.log("Filtering the data");
    console.log(filters);

    console.log("SelectedItemd");
    console.log(selectedItems.length);

    
    console.log(filteredTableData.length);

    let tmpData = [];

    if(filters[0]){
        let helperData = data.filter(datum=>datum.Stanje==0);

        console.log("Filter 0");
        console.log(helperData.length);

        tmpData = tmpData.concat(helperData);
  
    }

    if(filters[1]){

        let helperData = data.filter(datum=>datum.Stanje==1);

        console.log("Filter 1");
        console.log(helperData.length);
        tmpData = tmpData.concat(helperData);
    }

    if(filters[2]){

        let helperData = data.filter(datum=>(datum.Stanje==2 && datum.Gotovo==0));
        console.log("Filter 2");
        console.log(helperData.length);
        tmpData = tmpData.concat(helperData);
    }
    if(filters[3]){

        let helperData = data.filter(datum=>(datum.Stanje==2 && datum.Gotovo==1));
        console.log("Filter 3");
        console.log(helperData.length);
        tmpData = tmpData.concat(helperData);
    }
    if(filters[4]){

        let helperData = data.filter(datum=>(datum.Stanje==2 && datum.Gotovo==4));
        console.log("Filter 4");
        console.log(helperData.length);
        tmpData = tmpData.concat(helperData);
    }
    if(filters[5]){

        let helperData = data.filter(datum=>datum.Stanje==3);
        console.log("Filter 5");
        console.log(helperData.length);
        tmpData = tmpData.concat(helperData);
    }
    if(filters[6]){

        let helperData = data.filter(datum=>datum.Stanje==4);
        console.log("Filter 6");
        console.log(helperData.length);
        tmpData = tmpData.concat(helperData);
    }
    if(filters[7]){

        let helperData = data.filter(datum=>datum.Stanje==5);
        console.log("Filter 7");
        console.log(helperData.length);
        tmpData = tmpData.concat(helperData);
    }
    if(filters[8]){

        let helperData = data.filter(datum=>datum.Stanje==6);
        console.log("Filter 8");
        console.log(helperData.length);
        tmpData = tmpData.concat(helperData);
    }
   


    console.log(tmpData.length);

    if(filters[0] || filters[1] || filters[2] || filters[3] || filters[4] || filters[5] || filters[6] || filters[7] || filters[8]){

        console.log("Postoji barem jedan aktivan filter!");

        //setFilteredTableData(tmpData);

        if(tmpData && tmpData.length != 0){




                let columns= Object.getOwnPropertyNames(tmpData[0]).map((column,index)=>{
                      var a = column.charAt(0).toUpperCase() + column.slice(1);
                      return(
                          {
                              "field": column,
                              "getRowId": index,
                              
                          
                          }
                      )
                  })

                  

              const comparator = (v1, v2) => {
                  const currVal = v1.startsWith('***')?v1.substring(3):v1;
                  const nextVal = v2.startsWith('***') ?v2.substring(3):v2;
                
                  if (currVal === nextVal) { return 0; }
                
                  return currVal < nextVal ? -1 : 1;
                }
                



              const updatedColumns = columns.map((col) => {
             
                    if(col.field == 'rbr'){

                        return{

                            ...col,
                            //'headerCheckboxSelection': true,
                            hide:true
                        }
                    }
                  if(col.field == 'Datum'){

                      return {
                          ...col,
                          valueFormatter: ({ value }) => {
                            if (value) {
                              
                             
                              let date = new Date(value);


                              //return date.toLocaleDateString("DD.MM.YYYY"); // Format as MM/DD/YYYY (or customize)
                              const options = {
                               
                                  year: "numeric",
                                  month: "numeric",
                                  day: "numeric",
                                };
                                return date.toLocaleDateString("hr-HR", options);
                              
                             
                            }
                            return value;
                          },
                          sortComparator: (v1, v2) => {
                            const date1 = new Date(v1);
                            const date2 = new Date(v2);
                            return date1 - date2; // Compare dates
                          },
                        };
                      

                  }

                  if(col.field == 'Vrsta rada'){

                      return {
                          ...col, comparator
                       
                        };
                      

                  }
                    if(col.field == 'Naziv'){

                        return{

                            ...col,
                            comparator:(valueA, valueB, nodeA, nodeB, isDescending)=>{
                                return new Intl.Collator('hr').compare(valueA, valueB)
                            }
                        }
                    }
                  return col;
              });


                  //columns = updatedColumns;
                columns =  [
                    {
                        headerName: "Br",
                        'headerCheckboxSelection': true,
                    valueGetter: "node.rowIndex + 1",
                    width:30
                    },
                    ...updatedColumns
                ];

                  
                  let rows =tmpData.map((item, index)=> {
                      return({...item,id:index})
                  })

                

                  setFilteredTableData({
                          columns,
                          rows
                  })
                 


        } else {

            setFilteredTableData([],[]);
        }







    } else {
        console.log("Nema aktivnih filtera");

        if(data && data.length!=0){


                let columns= Object.getOwnPropertyNames(data[0]).map((column,index)=>{
                    var a = column.charAt(0).toUpperCase() + column.slice(1);
                    return(
                        {
                            "field": column,
                            "getRowId": index,
                            
                        
                        }
                    )
                })

                

            const comparator = (v1, v2) => {
                const currVal = v1.startsWith('***')?v1.substring(3):v1;
                const nextVal = v2.startsWith('***') ?v2.substring(3):v2;
            
                if (currVal === nextVal) { return 0; }
            
                return currVal < nextVal ? -1 : 1;
            }
            



            const updatedColumns = columns.map((col) => {
        
                    if(col.field == 'rbr'){

                        return{

                            ...col,
                            //'headerCheckboxSelection': true,
                            hide:true
                        }
                    }
                if(col.field == 'Datum'){

                    return {
                        ...col,
                        valueFormatter: ({ value }) => {
                        if (value) {
                            
                        
                            let date = new Date(value);


                            //return date.toLocaleDateString("DD.MM.YYYY"); // Format as MM/DD/YYYY (or customize)
                            const options = {
                            
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                            };
                            return date.toLocaleDateString("hr-HR", options);
                            
                        
                        }
                        return value;
                        },
                        sortComparator: (v1, v2) => {
                        const date1 = new Date(v1);
                        const date2 = new Date(v2);
                        return date1 - date2; // Compare dates
                        },
                    };
                    

                }

                if(col.field == 'Vrsta rada'){

                    return {
                        ...col, comparator
                    
                    };
                    

                }
                    if(col.field == 'Naziv'){

                        return{

                            ...col,
                            comparator:(valueA, valueB, nodeA, nodeB, isDescending)=>{
                                return new Intl.Collator('hr').compare(valueA, valueB)
                            }
                        }
                    }
                return col;
            });


                  //columns = updatedColumns;
                columns =  [
                    {
                        headerName: "Br",
                        'headerCheckboxSelection': true,
                    valueGetter: "node.rowIndex + 1",
                    width:30
                    },
                    ...updatedColumns
                ];

                
                let rows =data.map((item, index)=> {
                    return({...item,id:index})
                })

            

                setFilteredTableData({
                        columns,
                        rows
                })
            
    
                //setFilteredTableData(data);


        } else {

            setFilteredTableData([],[]);
        }



    }




};


const handleFilterChangesOnArrival = (filters, dataArr) => {
    console.log("Filtering the data");
    console.log(filters);


    let tmpData = [];

    if(filters[0]){
        let helperData = dataArr.filter(datum=>datum.Stanje==0);

        console.log("Filter 0");
        console.log(helperData.length);

        tmpData = tmpData.concat(helperData);
  
    }

    if(filters[1]){

        let helperData = dataArr.filter(datum=>datum.Stanje==1);

        console.log("Filter 1");
        console.log(helperData.length);
        tmpData = tmpData.concat(helperData);
    }

    if(filters[2]){

        let helperData = dataArr.filter(datum=>(datum.Stanje==2 && datum.Gotovo==0));
        console.log("Filter 2");
        console.log(helperData.length);
        tmpData = tmpData.concat(helperData);
    }
    if(filters[3]){

        let helperData = dataArr.filter(datum=>(datum.Stanje==2 && datum.Gotovo==1));
        console.log("Filter 3");
        console.log(helperData.length);
        tmpData = tmpData.concat(helperData);
    }
    if(filters[4]){

        let helperData = dataArr.filter(datum=>(datum.Stanje==2 && datum.Gotovo==4));
        console.log("Filter 4");
        console.log(helperData.length);
        tmpData = tmpData.concat(helperData);
    }
    if(filters[5]){

        let helperData = dataArr.filter(datum=>datum.Stanje==3);
        console.log("Filter 5");
        console.log(helperData.length);
        tmpData = tmpData.concat(helperData);
    }
    if(filters[6]){

        let helperData = dataArr.filter(datum=>datum.Stanje==4);
        console.log("Filter 6");
        console.log(helperData.length);
        tmpData = tmpData.concat(helperData);
    }
    if(filters[7]){

        let helperData = dataArr.filter(datum=>datum.Stanje==5);
        console.log("Filter 7");
        console.log(helperData.length);
        tmpData = tmpData.concat(helperData);
    }
    if(filters[8]){

        let helperData = dataArr.filter(datum=>datum.Stanje==6);
        console.log("Filter 8");
        console.log(helperData.length);
        tmpData = tmpData.concat(helperData);
    }
   


    console.log(tmpData.length);

    if(filters[0] || filters[1] || filters[2] || filters[3] || filters[4] || filters[5] || filters[6] || filters[7] || filters[8]){

        console.log("Postoji barem jedan aktivan filter!");

        //setFilteredTableData(tmpData);

        if(tmpData && tmpData.length != 0){


                let columns= Object.getOwnPropertyNames(tmpData[0]).map((column,index)=>{
                      var a = column.charAt(0).toUpperCase() + column.slice(1);
                      return(
                          {
                              "field": column,
                              "getRowId": index,
                              
                          
                          }
                      )
                  })

                  

              const comparator = (v1, v2) => {
                  const currVal = v1.startsWith('***')?v1.substring(3):v1;
                  const nextVal = v2.startsWith('***') ?v2.substring(3):v2;
                
                  if (currVal === nextVal) { return 0; }
                
                  return currVal < nextVal ? -1 : 1;
                }
                



              const updatedColumns = columns.map((col) => {
             
                    if(col.field == 'rbr'){

                        return{

                            ...col,
                            //'headerCheckboxSelection': true,
                            hide:true
                        }
                    }
                  if(col.field == 'Datum'){

                      return {
                          ...col,
                          valueFormatter: ({ value }) => {
                            if (value) {
                              
                             
                              let date = new Date(value);


                              //return date.toLocaleDateString("DD.MM.YYYY"); // Format as MM/DD/YYYY (or customize)
                              const options = {
                               
                                  year: "numeric",
                                  month: "numeric",
                                  day: "numeric",
                                };
                                return date.toLocaleDateString("hr-HR", options);
                              
                             
                            }
                            return value;
                          },
                          sortComparator: (v1, v2) => {
                            const date1 = new Date(v1);
                            const date2 = new Date(v2);
                            return date1 - date2; // Compare dates
                          },
                        };
                      

                  }

                  if(col.field == 'Vrsta rada'){

                      return {
                          ...col, comparator
                       
                        };
                      

                  }
                    if(col.field == 'Naziv'){

                        return{

                            ...col,
                            comparator:(valueA, valueB, nodeA, nodeB, isDescending)=>{
                                return new Intl.Collator('hr').compare(valueA, valueB)
                            }
                        }
                    }
                  return col;
              });


                  //columns = updatedColumns;
                columns =  [
                    {
                        headerName: "Br",
                        'headerCheckboxSelection': true,
                    valueGetter: "node.rowIndex + 1",
                    width:30
                    },
                    ...updatedColumns
                ];

                  
                  let rows =tmpData.map((item, index)=> {
                      return({...item,id:index})
                  })

                

                  setFilteredTableData({
                          columns,
                          rows
                  })
                 


        } else {

            setFilteredTableData([],[]);
        }







    } else {
        console.log("Nema aktivnih filtera");

        if(dataArr && dataArr.length!=0){


                let columns= Object.getOwnPropertyNames(dataArr[0]).map((column,index)=>{
                    var a = column.charAt(0).toUpperCase() + column.slice(1);
                    return(
                        {
                            "field": column,
                            "getRowId": index,
                            
                        
                        }
                    )
                })

                

            const comparator = (v1, v2) => {
                const currVal = v1.startsWith('***')?v1.substring(3):v1;
                const nextVal = v2.startsWith('***') ?v2.substring(3):v2;
            
                if (currVal === nextVal) { return 0; }
            
                return currVal < nextVal ? -1 : 1;
            }
            



            const updatedColumns = columns.map((col) => {
        
                    if(col.field == 'rbr'){

                        return{

                            ...col,
                            //'headerCheckboxSelection': true,
                            hide:true
                        }
                    }
                if(col.field == 'Datum'){

                    return {
                        ...col,
                        valueFormatter: ({ value }) => {
                        if (value) {
                            
                        
                            let date = new Date(value);


                            //return date.toLocaleDateString("DD.MM.YYYY"); // Format as MM/DD/YYYY (or customize)
                            const options = {
                            
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                            };
                            return date.toLocaleDateString("hr-HR", options);
                            
                        
                        }
                        return value;
                        },
                        sortComparator: (v1, v2) => {
                        const date1 = new Date(v1);
                        const date2 = new Date(v2);
                        return date1 - date2; // Compare dates
                        },
                    };
                    

                }

                if(col.field == 'Vrsta rada'){

                    return {
                        ...col, comparator
                    
                    };
                    

                }
                    if(col.field == 'Naziv'){

                        return{

                            ...col,
                            comparator:(valueA, valueB, nodeA, nodeB, isDescending)=>{
                                return new Intl.Collator('hr').compare(valueA, valueB)
                            }
                        }
                    }
                return col;
            });


                  //columns = updatedColumns;
                columns =  [
                    {
                        headerName: "Br",
                        'headerCheckboxSelection': true,
                    valueGetter: "node.rowIndex + 1",
                    width:30
                    },
                    ...updatedColumns
                ];

                
                let rows =dataArr.map((item, index)=> {
                    return({...item,id:index})
                })

            

                setFilteredTableData({
                        columns,
                        rows
                })
            
    
                //setFilteredTableData(data);


        } else {

            setFilteredTableData([],[]);
        }



    }




};


async function getBijeleZuteDnevne (tel) {

    //let tmpTKC = tkc?tkc.tkc:'';
    let tmpTKC = selectedNetwork?selectedNetwork.tkc:'';

    console.log("Tkc in getbijelezute");

    console.log(tmpTKC)


    console.log(tel);

    let tmpTel = '';

    if(tel.startsWith('01')){

        tmpTel = tel.slice(2);

    }else {
        tmpTel = tel.slice(3);

    }

    let tmpMreza = '';

    if(tel.startsWith('01')){

        tmpMreza = tel.slice(0, 2);

    }else {
        tmpMreza = tel.slice(0,3);

    }
    console.log(tel);
    console.log(tmpTel);

   

    dispatch(actions.isLoading());

    
    APICall(
        '/GetBijeleZuteDnevne',
        
        {

             platform: '0',
             version:'1.0',
             tel: tmpTel,
             tkc: tmpMreza

         },
        {
            token
        }).then(


            (response) => {
               
                console.log(response);
                dispatch(actions.isNotLoading());


                if(response==undefined) dispatch(actions.isNotLoading());

                if(response.status !== 200) {

                    if(response.status == 401){
      
                            console.log("Istekla sesija");
      
                            toast.error(response.data.message, toastError);
                            
                            dispatch(actions.logOut());
                            navigate('/');
      
                    } else{
      
                            toast.error(response.data.message, toastError);
      
      
                    }
                    
      
      
      
                } else {
            
                if(response.data && response.data.company && response.data.company != "" && response.data.company.length!= 0){


                                    console.log("Došli reeeeeez");
                                    console.log(response.data.company);

                                    let i = 0;


                                    let columns= Object.getOwnPropertyNames(response.data.company[0]).map((column,index)=>{
                                        var a = column.charAt(0).toUpperCase() + column.slice(1);
                                      
                                        let widthC = 100;
                                        switch(column) {
                                            case "firma":
                                                widthC = 250;
                                                break;
                                            case "adresa":
                                                widthC = 200;
                                                break;
                                             case "redos":
                                                    widthC = 60;
                                                    break;
                                                    case "objava_c":
                                                        widthC = 60;
                                                        break;
                                                        case "objava":
                                                            widthC = 60;
                                                            break;
                                                            case "kategorija":
                                                                widthC = 90;
                                                                break;
                                            default:
                                                widthC = 100;
                                            } 
                                        
                                        return(
                                            {
                                                "field": column,
                                                "getRowId": index,
                                                "width": widthC

                                            
                                            }
                                        )
                                    })

                                      let rows = response.data.company.map((item, index)=> {
                                          return({...item,id:index})
                                      })

                                      setBijeleZuteData({
                                              columns,
                                              rows
                                      })

  
                                    setPojavljivanjeBijeleIsOpen(true);
                                

                                       
                }else{

                            console.log("Going to toast some toast for myself only one toast is necessery but a big one")

                                    toast.info(response.data.message, toastInfo);
                                    
                           
                                    setBijeleZuteData([],[]);


                }
        }
           
                    
            
            },

            (error) => {

                        dispatch(actions.isNotLoading());

                        setBijeleZuteData([],[]);


            /*
                        if(!error.response){

                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);


                        } else {

                             if(!error.response.status){

                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);

                             }else{

                                  if (error.response.status == 401) {
              
                           
                                       toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                  
                             
                                  } else {
                             
                             
                                            toast.error(error.response.data.message,
                                                 toastError);
                                                                           
                                       
                                  }
                             }
                        }
                    
*/
            });
           
}      


async function vratiBijeleZute(tel, sifra, sentTKC){




    //let tmpTKC = tkc?tkc.tkc:'';

    let tmpTKC = selectedNetwork?selectedNetwork.tkc:'';


    console.log("Tkc in vratibijelezute");
    console.log(tmpTKC)

    tmpTKC = sentTKC;


    console.log(tel);

    let tmpTel = '';

    let tmpMreza = '';

    if(tel.startsWith('01')){

        tmpTel = tel.slice(2);

        tmpMreza = tel.slice(1,2);

    }else {

        tmpTel = tel.slice(3);

        tmpMreza = tel.slice(1,3);

    }

    console.log(tel);
    console.log(tmpTel);
    console.log(tmpMreza)

    console.log("vracam objavu")



    dispatch(actions.isLoading());

    
    APICall(
        '/VratiObjaveBijeleZute',
        
        {

             platform: '0',
             version:'1.0',
             tel: tmpTel,
             tkc: tmpTKC,
             sifra: sifra,
             mreza: tmpMreza

         },
        {
            token
        }).then(


            (response) => {
               
                console.log(response);
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
            
                if(response.data && response.data.message && response.data.message != ""){


                                    console.log("Došli reeeeeez");
                                    console.log(response.data);


                                    setPojavljivanjeBijeleIsOpen(false);

                                    setBijeleZuteData([],[]);

                                    setVratiObjavu(null)

                                   //toast.info(response.data.message,
                                   //toastError);
                                

                                       
                }else{

     

                                   // toast.info(response.data.message,
                                   //     toastError);

                                   setBijeleZuteData([],[]);

                                   setPojavljivanjeBijeleIsOpen(false);

                                   setVratiObjavu(null)

                                  


            }
           
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

                setBijeleZuteData([],[]);

                setPojavljivanjeBijeleIsOpen(false);

                setVratiObjavu(null)


            
                        if(!error.response){

                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);


                        } else {

                             if(!error.response.status){

                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);

                             }else{

                                  if (error.response.status == 401) {
              
                           
                                       toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                  
                             
                                  } else {
                             
                             
                                            toast.error(error.response.data.message,
                                                 toastError);
                                                                           
                                       
                                  }
                             }
                        }
                    

            });
           

}



async function getSimilarCompany () {

    //let tmpTKC = tkc2?tkc2.tkc:'';
    let tmpTKC = selectedNetwork?selectedNetwork.tkc:'';

    console.log("Tkc in getSimilar");
   
    
    
    console.log(tmpTKC)

    console.log("Getting tkc")



    if((selectedItems && selectedItems.length && selectedItems.length>0) || selectedCell){

        let item;

        if(selectedItems && selectedItems.length && selectedItems.length > 0){

            item = selectedItems;

            if(!tmpTKC || tmpTKC==''){

                //tmpTKC = selectedItems[0][0].TKC;
                tmpTKC = selectedItems[0].TKC;

                console.log("Tkc selectedItem");
                console.log(tmpTKC)
            }

        } else {

            if(!tmpTKC || tmpTKC==''){

                tmpTKC = selectedCell.TKC;

                console.log("Tkc selectedCell");
                console.log(tmpTKC)
            }

            item = selectedCell;
        } 

   

    dispatch(actions.isLoading());

    
    APICall(
        //'/GetSimilarCompanyBijele_dnevne',
        '/GetSimilarCompanyBijele_dnevne_v2',
        
        {

             platform: '0',
             version:'1.0',
             items: item,
             txtSearch:txtSearchAutoBijele,
             tkc: tmpTKC

         },
        {
            token
        }).then(


            (response) => {
               
                console.log(response);
                dispatch(actions.isNotLoading());


                if(response==undefined) dispatch(actions.isNotLoading());

                if(response.status !== 200) {

                    if(response.status == 401){
      
                            console.log("Istekla sesija");
      
                            toast.error(response.data.message, toastError);
                            
                            dispatch(actions.logOut());
                            navigate('/');
      
                    } else{
      
                            toast.error(response.data.message, toastError);
      
      
                    }
                    
      
      
      
                } else {
            
                if(response.data && response.data.company && response.data.company != "" && response.data.company.length!= 0){


                                    console.log("Došli reeeeeez");
                                    console.log(response.data.company);

                           


                                    let i = 0;

                                    let columns= Object.getOwnPropertyNames(response.data.company[0]).map((column,index)=>{
                                      var a = column.charAt(0).toUpperCase() + column.slice(1)
                                          return(
                                              {
                                                  "field": column,
                                                  "getRowId": index
                                              }
                                          )
                                      })
                                      let rows = response.data.company.map((item, index)=> {
                                          return({...item,id:index})
                                      })

                                      console.log("Printing rows and column")
                                      console.log(columns);
                                      console.log(rows);

                                      setSimilarCompanyData({
                                              columns,
                                              rows
                                      })

                                      setSimilarTvrtkeModalOpen(true);

                       
                                

                                       
                }else{

                                    console.log("Going to toast some toast for myself only one toast is necessery but a big one")

                                    toast.info(response.data.message, toastInfo);
                                    
                           
                                    setSimilarCompanyData([],[]);

                               

                                  


                }
        }
           
                    
            
            },

            (error) => {

                        dispatch(actions.isNotLoading());

                        setSimilarCompanyData([],[]);

            });
      
            
    } else {

        toast.error("Nije odabran nijedan redak za traženje sličnih tvrtki", toastError);
    }
}      

function cleanString(input) {
  let str = input ?? '';
  return str
    .replace(/"/g, '') // remove all double quotes
    .replace(/([^a-zA-Z0-9])\1+/g, '$1'); // collapse repeated non-alphanumerics
}

async function setBijeleCompany() {

    //let tmpTKC = tkc2?tkc2.tkc:'';
    let tmpTKC = selectedNetwork?selectedNetwork.tkc:'';



    let ulicaComp = -2;
    let mjestoComp = -1;

    let kbrComp = '';
    let kbrAlfaComp = '';


    if((selectedItems && selectedItems.length && selectedItems.length>0) || selectedCell){

        let item;

      

        let tkcCompany = '';
     
        let nazivCompany = '';

        if(selectedItems && selectedItems.length && selectedItems.length > 0){

            item = selectedItems;

            //tkcCompany = selectedItems[0].TKC;
            //nazivCompany = selectedItems[0].Naziv;
            tkcCompany = selectedItems[0].TKC;
            nazivCompany = cleanString(selectedItems[0]["Novi naziv"]);


            if(selectedItems[0].rucnoMjestoID && selectedItems[0].rucnoMjestoID!='' && selectedItems[0].rucnoMjestoID!=0){

                                                ulicaComp = selectedItems[0].rucnoAdresaID;

                                                kbrComp = selectedItems[0].rucnoKBR?selectedItems[0].rucnoKBR:'';

                                                kbrAlfaComp = selectedItems[0].rucnoDodatak?selectedItems[0].rucnoDodatak:'';

                                                mjestoComp = selectedItems[0].rucnoMjestoID;

                                                console.log("Promijenjena ulicaSTR: " + ulicaComp);
            } else {


                                                ulicaComp = selectedItems[0].sifra_ulice;

                                                kbrComp = selectedItems[0].newKBR?selectedItems[0].newKBR:'';

                                                kbrAlfaComp = selectedItems[0].newKBR_Dod?selectedItems[0].newKBR_Dod:'';

                                                mjestoComp = selectedItems[0].MJESTO;

                                                console.log("Nije promijenjena ulicaSTR: " + ulicaComp);
            }             

        } else {

            item = selectedCell;
            //tkcCompany = selectedCell.TKC;
            //nazivCompany = selectedCell.Naziv;

            tkcCompany = selectedCell.TKC;
            nazivCompany = cleanString(selectedCell["Novi naziv"]);

            if(selectedCell.rucnoMjestoID && selectedCell.rucnoMjestoID!='' && selectedCell.rucnoMjestoID!=0){

                                                ulicaComp = selectedCell.rucnoAdresaID;

                                                kbrComp = selectedCell.rucnoKBR?selectedCell.rucnoKBR:'';

                                                kbrAlfaComp = selectedCell.rucnoDodatak?selectedCell.rucnoDodatak:'';

                                                mjestoComp = selectedCell.rucnoMjestoID;

                                                console.log("Promijenjena ulicaSTR: " + ulicaComp);
            } else {


                                                ulicaComp = selectedCell.sifra_ulice;

                                                kbrComp = selectedCell.newKBR?selectedCell.newKBR:'';

                                                kbrAlfaComp = selectedCell.newKBR_Dod?selectedCell.newKBR_Dod:'';

                                                mjestoComp = selectedCell.MJESTO;

                                                console.log("Nije promijenjena ulicaSTR: " + ulicaComp);
            }           

        } 

        console.log(item);
      

                console.log("Set the tkc from selector");
                console.log(tmpTKC);

   

                dispatch(actions.isLoading());

                APICall(
                                
                    '/CreateBijeleCompany',
                    {


                        platform: '0',
                        version:'1.0',
                        //sifra: sifra,
                        tkc: tkcCompany,
                        naziv_mas: nazivCompany,
                        naziv: nazivCompany,
                        naziv_nemas: '',
                        naziv_znak: '',
                        naziv_kratki: nazivCompany,
                        //vrsta_sloga: vrstaSloga,
                        alfa: kbrAlfaComp?kbrAlfaComp:'',
                        komentar: '',
                        komentar2: '',
                        objava: 1,
                        mb: '',
                        oib: OIB2?OIB2:'',
                        kontakti: '',
                        sifra_ulice: ulicaComp?ulicaComp:'',
                        kbr: kbrComp?kbrComp:'',
                        ref:ref



                    },
                    {
                        token
                    }).then(
                
                
                        (response) => {
                            console.log(response)
                            dispatch(actions.isNotLoading());
                
                            if(response==undefined) dispatch(actions.isNotLoading());
                            if (response.status==200) {
                                
                                var dataTmp = response.data.msg;

                                let codeCompany = response.data.code;
                
                
                
                                console.log(dataTmp)
                
                                toast.success("Uspješno spremljene izmjene",
                                    toastSuccess);

                                
                                //setBijeleStrukture(codeCompany, nazivCompany, '');
                                setBijeleStrukture(codeCompany, nazivCompany, '', '', '');

                            } else {

                                if(response.status==401){

                                    toast.error(response.data.message,
                                        toastError);
                                
                                        setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                        }, 5000);   
                                } else {

                                    toast.error("Došlo je do problema u komunikaciji sa serverom, molimo provjerite funkcioniranje mreže", toastError);
                                }


                            }
                
                    
                                
                        
                        },
                
                        (error) => {
                
                            dispatch(actions.isNotLoading());
                
                        
                
                
                
                        
                                    if(!error.response){
                
                                        toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                            toastError);
                                    
                
                
                                    } else {
                
                
                                        if(!error.response.status){
                
                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                            toastError);
                
                                        }else{
                
                                            if (error.response.status == 401) {
                        
                                    
                                                toast.error(error.response.data.message,
                                                        toastError);
                                                
                                                        setTimeout(() => {
                                                            dispatch(actions.logOut());
                                                            navigate('/');
                                                        }, 5000);   
                
                                            
                                        
                                            } else {
                                        
                                        
                                                        toast.error(error.response.data.message,
                                                            toastError);
                                                                                    
                                                
                                            }
                                        }
                                    }
                                
                            
                        
                        
                        });
            
    } else {

        toast.error("Nije odabran nijedan redak za spremanje u novu tvrtku, ništa nije odrađeno", toastError);
    }

 
            
}  
    
    



async function setBijeleStrukture(codeCompany, nazivCompany, mjesto, oibComp, id_mjesta) {


    console.log("Dolazni podaci!!!");
    console.log(codeCompany);
    console.log(nazivCompany);
    console.log(mjesto);
    console.log(oibComp);
    console.log(id_mjesta);
    console.log('***********************************************')


    //let tmpTKC = tkc2?tkc2.tkc:'';
    let tmpTKC = selectedNetwork?selectedNetwork.tkc:'';

    console.log("Tkc in getSimilar");

    console.log(tmpTKC);

    console.log("Getting TKC from companies");

    let nazivSTR = '';

    let mjestoSTR = '';

    let ulicaSTR = '';
    let kbrSTR = '';
    let kbrAlfaSTR='';

    let noviNazivSTR = '';


    if((selectedItems && selectedItems.length && selectedItems.length>0) || selectedCell){

        let item;

        let tkcCompany = '';
        //let nazivCompany = '';
        let tel = '';

        if(selectedItems && selectedItems.length && selectedItems.length > 1){


                        console.log("SelectedItem je array!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!")
                        console.log(selectedItems[0]);

                        console.log("**************************************MJESTOID - " + selectedItems[0].MJESTO);
                        item = selectedItems;

                        tkcCompany = selectedItems[0].TKC;


                        nazivSTR = selectedItems[0].Naziv;
                        tel = selectedItems[0].Telefon;

                        mjestoSTR = selectedItems[0].Mjesto;

                        ulicaSTR = selectedItems[0].sifra_ulice;
                        kbrSTR = selectedItems[0].newKBR;
                        kbrAlfaSTR = selectedItems[0].newKBR_Dod;

                        noviNazivSTR = cleanString(selectedItems[0]["Novi naziv"]);

                        console.log("Novi naziv strukture!");
                        console.log(noviNazivSTR);

                        dispatch(actions.isLoading()); 
        
                        APICall(
                            '/CreateArrayStrukture',
                            {
                        
                                platform: '0',
                                version:'1.0',
                                sifra: codeCompany,
                                tkc: tkcCompany,
                                nazivComp: nazivCompany,
                                mjestoID: id_mjesta?id_mjesta:'',
                                selectedItems: selectedItems,
                                ref:ref
                            },
                            {
                                token
                            }).then(
                        
                        
                                (response) => {
                                    console.log(response)
                                    dispatch(actions.isNotLoading());
                        
                                    if(response==undefined) dispatch(actions.isNotLoading());
                                    if (response.status==200) {
                                        
                                        var dataTmp = response.data.msg;

                                        console.log(dataTmp)
                        
                                        toast.success("Uspješno spremljena nova struktura",
                                            toastSuccess);

                                            setAutomaticBijeleOpen(false);
                                            setSelectedItemsGrid([],[]);
                                            setSimilarCompanyData([],[]);

                        
                            
                                    } else {

                                        if(response.status==401){

                                            toast.error(response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   
                                        } else {

                                            toast.error(response.data.message, toastError);
                                        }


                                    } 
                                
                                },
                        
                                (error) => {
                        
                                    dispatch(actions.isNotLoading());
                        
 
                                            if(!error.response){
                        
                                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);
                                            
                        
                        
                                            } else {
                        
                        
                                                if(!error.response.status){
                        
                                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);
                        
                                                }else{
                        
                                                    if (error.response.status == 401) {
                                
                                            
                                                        toast.error(error.response.data.message,
                                                                toastError);
                                                        
                                                                setTimeout(() => {
                                                                    dispatch(actions.logOut());
                                                                    navigate('/');
                                                                }, 5000);   
                        
                                                    
                                                
                                                    } else {
                                                
                                                
                                                                toast.error(error.response.data.message,
                                                                    toastError);
                                                                                            
                                                        
                                                    }
                                                }
                                            }
                                        
                                    
                                
                                
                                });



        } else {

                    console.log("setting selected dclkndswlkncldjkswnwvclsjdnvljsnvjlksnfvljknsfjvklsnfj:");

                    console.log("**************************************MJESTOID - " + selectedCell.MJESTO);
                    console.log("**********************************ULICA_ID_ " + selectedCell.sifra_ulice);
                    console.log(selectedCell);

                    console.log("Dolazni podaci!!!");
                    console.log(codeCompany);
                    console.log(nazivCompany);
                    console.log(mjesto);
                    console.log(oibComp);
                    console.log(id_mjesta);
                    console.log('***********************************************')

                    console.log(oibComp)
                    console.log(selectedCell.OIB_n);
                    console.log('***********************************************')

                    item = selectedCell;
                    tkcCompany = selectedCell.TKC;
                    nazivSTR = selectedCell.Naziv;
                    tel = selectedCell.Telefon;

                    mjestoSTR = selectedCell.Mjesto;

                    ulicaSTR = selectedCell.sifra_ulice;
                    kbrSTR = selectedCell.newKBR;
                    kbrAlfaSTR = selectedCell.newKBR_Dod;

                    noviNazivSTR = cleanString(selectedCell["Novi naziv"]);

                    console.log("Naziv str:");
                    console.log(nazivSTR)

                    console.log("Novi naziv strukture!");
                    console.log(noviNazivSTR);

                    nazivSTR = noviNazivSTR;
             

                console.log(tel);

                console.log(nazivSTR);
                console.log(mjestoSTR);

                let mr = '';

                if(tel.startsWith('01')){
                    mr = tel.substring(0,2)
                } else {
                    mr = tel.substring(0,3);
                }

                let telStrukt = '';

                if(tel.startsWith('01')){
                    telStrukt = tel.substring(2)
                } else {
                    telStrukt = tel.substring(3);
                }

                let nazivMob = '';

                if(tel.startsWith('09')){

                    nazivMob = 'mobitel';
                } 


                let tmpRedos = 1;
                let tmpNivo = 600;

                console.log("Setting struktura!!!!");
                console.log(nazivSTR);
                console.log(nazivCompany)



                if(!nazivSTR || (nazivSTR && nazivSTR.toUpperCase().trim() =='')){



                        toast.error("Naziv strukture se ne poklapa s nazivom tvrtke u koju ga želite dodati",
                            toastError);


                } else if ((!nazivCompany || nazivCompany=='') || 
                (nazivCompany && nazivCompany.trim().substring(0, 4).toUpperCase().localeCompare(nazivSTR.trim().substring(0, 4).toUpperCase())!=0 
                && nazivCompany.trim().substring(0, 4).toUpperCase().localeCompare(noviNazivSTR.trim().substring(0, 4).toUpperCase())!=0)) {

                           if(oibComp && selectedCell.OIB_n && oibComp == selectedCell.OIB_n){


                                    nazivSTR = nazivCompany;

                        

                                    console.log("Checking idddddddd");
                                    console.log(id_mjesta);
                                    console.log(selectedCell.MJESTO);
                                    console.log(ulicaSTR);
                                    console.log(selectedCell.rucnoAdresaID);

                                    console.log(selectedCell);


                                    if(selectedCell.rucnoAdresaID && selectedCell.rucnoAdresaID!='' && selectedCell.rucnoAdresaID!=0){

                                                ulicaSTR = selectedCell.rucnoAdresaID;

                                                kbrSTR = selectedCell.rucnoKBR?selectedCell.rucnoKBR:'';

                                                kbrAlfaSTR = selectedCell.rucnoDodatak?selectedCell.rucnoDodatak:'';

                                                console.log("Promijenjena ulicaSTR: " + ulicaSTR);
                                    } 
      
                                
                                        dispatch(actions.isLoading());
                                        
                                        APICall(
                                            //'/GetDnevneFiksni',
                                            '/CreateBijeleStrukture',
                                            {
                                        
                                                platform: '0',
                                                version:'1.0',
                                                sifra: codeCompany,
                                                tkc: tkcCompany,
                                                mreza: mr,
                                                
                                                nivo: tmpNivo,
                                                tel: telStrukt,
                                                naziv: nazivMob,
                                                ulica: ulicaSTR,
                                                kbr: kbrSTR,
                                                kbrAlfa: kbrAlfaSTR,
                                                komentar: '',
                                                pojam1: '',
                                                pojam2: '',
                                                pojam3: '',
                                                objava: 1,
                                                redos: tmpRedos,
                                                id_mjesta:id_mjesta,
                                                ref:ref
                                        
                                        
                                            },
                                            {
                                                token
                                            }).then(
                                        
                                        
                                                (response) => {
                                                    console.log(response)
                                                    dispatch(actions.isNotLoading());
                                        
                                                    if(response==undefined) dispatch(actions.isNotLoading());
                                                    if (response.status==200) {
                                                        
                                                        var dataTmp = response.data.msg;
                                        
                                        
                                        
                                                        console.log(dataTmp)
                                        
                                                        toast.success("Uspješno spremljena nova struktura",
                                                            toastSuccess);

                                                            setAutomaticBijeleOpen(false);
                                                            setSelectedItemsGrid([],[]);
                                                            setSimilarCompanyData([],[]);

                                                        /*Swal.fire({
                                                                title: "Uspjeh",
                                                                text: "Uspješno spremljena struktura",
                                                                icon: "success"
                                                        });*/

                                        
                                            
                                                    } else {

                                                        if(response.status==401){

                                                            toast.error(response.data.message,
                                                                toastError);
                                                        
                                                                setTimeout(() => {
                                                                    dispatch(actions.logOut());
                                                                    navigate('/');
                                                                }, 5000);   
                                                        } else {

                                                            toast.error("Došlo je do problema u komunikaciji sa serverom, molimo provjerite funkcioniranje mreže", toastError);
                                                        }


                                                    } 
                                                
                                                },
                                        
                                                (error) => {
                                        
                                                    dispatch(actions.isNotLoading());
                                        
                                                
                                        
                                        
                                        
                                                
                                                            if(!error.response){
                                        
                                                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                                    toastError);
                                                            
                                        
                                        
                                                            } else {
                                        
                                        
                                                                if(!error.response.status){
                                        
                                                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                                    toastError);
                                        
                                                                }else{
                                        
                                                                    if (error.response.status == 401) {
                                                
                                                            
                                                                        toast.error(error.response.data.message,
                                                                                toastError);
                                                                        
                                                                                setTimeout(() => {
                                                                                    dispatch(actions.logOut());
                                                                                    navigate('/');
                                                                                }, 5000);   
                                        
                                                                    
                                                                
                                                                    } else {
                                                                
                                                                
                                                                                toast.error(error.response.data.message,
                                                                                    toastError);
                                                                                                            
                                                                        
                                                                    }
                                                                }
                                                            }
                                                        
                                                    
                                                
                                                
                                                });
                                } else {

                                        toast.error("Naziv strukture se ne poklapa s nazivom tvrtke u koju ga želite dodati",
                                            toastError);
                                }

                } else {


                        nazivSTR = nazivCompany;

                    
                        //if(mjesto && mjesto != '' && mjestoSTR && mjestoSTR != '' && 
                        //    mjesto.trim().toUpperCase().localeCompare(mjestoSTR.trim().toUpperCase())!=0){

                        console.log("Checking idddddddd");
                        console.log(id_mjesta);
                        console.log(selectedCell.MJESTO);
                        console.log(ulicaSTR);
                        console.log(selectedCell.rucnoAdresaID);

                        console.log(selectedCell);

                        if(selectedCell.rucnoMjestoID && selectedCell.rucnoMjestoID!= 0 && selectedCell.rucnoMjestoID!= -1 &&
                            selectedCell.rucnoMjestoID!='' && id_mjesta && id_mjesta!='' && id_mjesta!= selectedCell.rucnoMjestoID
                        ){

                                    toast.error("Mjesto strukture se ne poklapa s mjestom tvrtke u koju ga želite dodati",
                                    toastError);

                        } else if(id_mjesta && id_mjesta!='' && (id_mjesta!=selectedCell.MJESTO && 
                            (!selectedCell.rucnoMjestoID || selectedCell.rucnoMjestoID=='' || selectedCell.rucnoMjestoID==0 ))){

                                    


                                    toast.error("Mjesto strukture se ne poklapa s mjestom tvrtke u koju ga želite dodati",
                                    toastError);
                                



                        } else {

                                if(!mjesto || mjesto ==''){
                                    mjesto = mjestoSTR;
                                }

                                if(selectedCell.rucnoAdresaID && selectedCell.rucnoAdresaID!='' && selectedCell.rucnoAdresaID!=0){

                                    ulicaSTR = selectedCell.rucnoAdresaID;

                                    kbrSTR = selectedCell.rucnoKBR?selectedCell.rucnoKBR:'';

                                    kbrAlfaSTR = selectedCell.rucnoDodatak?selectedCell.rucnoDodatak:'';

                                    console.log("Promijenjena ulicaSTR: " + ulicaSTR);
                                } 


                              
                                
                        dispatch(actions.isLoading());
                        
                        APICall(
                            //'/GetDnevneFiksni',
                            '/CreateBijeleStrukture',
                            {
                        
                                platform: '0',
                                version:'1.0',
                                sifra: codeCompany,
                                tkc: tkcCompany,
                                mreza: mr,
                                
                                nivo: tmpNivo,
                                tel: telStrukt,
                                naziv: nazivMob,
                                ulica: ulicaSTR,
                                kbr: kbrSTR,
                                kbrAlfa: kbrAlfaSTR,
                                komentar: '',
                                pojam1: '',
                                pojam2: '',
                                pojam3: '',
                                objava: 1,
                                redos: tmpRedos,
                                id_mjesta:id_mjesta,
                                ref:ref
                        
                        
                            },
                            {
                                token
                            }).then(
                        
                        
                                (response) => {
                                    console.log(response)
                                    dispatch(actions.isNotLoading());
                        
                                    if(response==undefined) dispatch(actions.isNotLoading());
                                    if (response.status==200) {
                                        
                                        var dataTmp = response.data.msg;
                        
                        
                        
                                        console.log(dataTmp)
                        
                                        toast.success("Uspješno spremljena nova struktura",
                                            toastSuccess);

                                            setAutomaticBijeleOpen(false);
                                            setSelectedItemsGrid([],[]);
                                            setSimilarCompanyData([],[]);

                                        /*Swal.fire({
                                                title: "Uspjeh",
                                                text: "Uspješno spremljena struktura",
                                                icon: "success"
                                        });*/

                        
                            
                                    } else {

                                        if(response.status==401){

                                            toast.error(response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   
                                        } else {

                                            toast.error("Došlo je do problema u komunikaciji sa serverom, molimo provjerite funkcioniranje mreže", toastError);
                                        }


                                    } 
                                
                                },
                        
                                (error) => {
                        
                                    dispatch(actions.isNotLoading());
                        
                                
                        
                        
                        
                                
                                            if(!error.response){
                        
                                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);
                                            
                        
                        
                                            } else {
                        
                        
                                                if(!error.response.status){
                        
                                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);
                        
                                                }else{
                        
                                                    if (error.response.status == 401) {
                                
                                            
                                                        toast.error(error.response.data.message,
                                                                toastError);
                                                        
                                                                setTimeout(() => {
                                                                    dispatch(actions.logOut());
                                                                    navigate('/');
                                                                }, 5000);   
                        
                                                    
                                                
                                                    } else {
                                                
                                                
                                                                toast.error(error.response.data.message,
                                                                    toastError);
                                                                                            
                                                        
                                                    }
                                                }
                                            }
                                        
                                    
                                
                                
                                });

                        }
                    }
        }


    }




        
        
}  


function odradi5_1(){



    let unmounted = false;
    let source = axios.CancelToken.source();

    console.log("5-1!!!");
    console.log(telefon);

    console.log(operator)

    console.log("stanje")

    console.log(selectedCell);
    console.log(selectedCell.Stanje);
    console.log(selectedCell.Gotovo);

    console.log(selectedCell.Komentar);

    console.log(selectedCell["ID operatera"]);

    console.log(selectedItems.length);
    console.log("Ima selektiranih!");

    console.log(selectedCell.Ref);


    if(selectedItems.length > 0){

        let len = selectedItems.length;

        if(len==1){

            APICall(
                '/Izmjena5-1_Interval',
                {
        
                    platform: '0',
                    version:'1.0',
                    telList: selectedItems,
                    ref: ref
                    //tkID: tkList.map(item=>item.toString()),
                    //tkID: operator
                    //tkID: selectedCell["ID operatera"]
        
                },
                {
                    token
                }).then(
        
        
                    (response) => {
        

                        dispatch(actions.isNotLoading());

                        if(response==undefined) dispatch(actions.isNotLoading());
                    
                        if(response.status == 200){
                                console.log(response.data);
                                toast.info(response.data.message, toastInfo);

                                console.log(selectedOwner);
                                console.log("opla")

                                if(selectedOwner == 1){

                                    getDataChangesRef();
                                } else {
    
                                    getDataChanges();
                                }
        
                        } else {
        
                            if(response.status == 401){
        
                                    console.log("Istekla sesija");
            
                                    toast.error(response.data.message, toastError);
                                    
                                    dispatch(actions.logOut());
                                    navigate('/');
        
                            } else {
                                    toast.error(response.data.message,
                                        toastError);
                                                        
        
                            }
        
                    
                        }        
                    

                    
                    },
        
                    (error) => {
        
                        if (!unmounted) {
                    
                    
        
        
                    
                                if(!error.response){
        
                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                        toastError);
                                
        
        
                                } else {
        
        
                                    if(!error.response.status){
        
                                        toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                        toastError);
        
                                    }else{
        
                                        if (error.response.status == 401) {
                    
                                
                                            toast.error(error.response.data.message,
                                                    toastError);
                                            
                                                    setTimeout(() => {
                                                        dispatch(actions.logOut());
                                                        navigate('/');
                                                    }, 5000);   
        
                                        
                                    
                                        } else {
                                    
                                    
                                                    toast.error(error.response.data.message,
                                                        toastError);
                                                                                
                                            
                                        }
                                    }
                                }
                            
                        }
                    
                    
                    });

        } else {


                Swal.fire({
                    title: `Trenutno su odabrana ` + len + ` retka u tablici. Želite li izmijeniti status svih odabranih redaka?`,
                    text: "Ova radnja se ne može poništiti",
                    icon: "warning",
                    iconSize: '5',
            
                    confirmButtonText: "Da, promijeni cijeli interval!",
                    confirmButtonColor: "#e31b2e",
                    cancelButtonColor: "#29648a",
                    //showDenyButton: true,
                    showCancelButton: true,
                    
                    //denyButtonColor:'blue',
                    //denyButtonText: "Samo odabrani redak",
                    
                    cancelButtonText: "Odustani od promjene",
                    showCancelButton: true,
                    reverseButtons: false
                    }).then((result) => {
                    if (result.isConfirmed) {
                        
                                //interval

                                console.log("aaaaaaaaaaaaaaa");
                                        APICall(
                                            '/Izmjena5-1_Interval',
                                            {
                                    
                                                platform: '0',
                                                version:'1.0',
                                                telList: selectedItems,
                                                ref: ref
                                                //tkID: tkList.map(item=>item.toString()),
                                                //tkID: operator
                                                //tkID: selectedCell["ID operatera"]
                                    
                                            },
                                            {
                                                token
                                            }).then(
                                    
                                    
                                                (response) => {
                                    
                    
                                                    dispatch(actions.isNotLoading());
                    
                                                    if(response==undefined) dispatch(actions.isNotLoading());
                                                
                                                    if(response.status == 200){
                                                            console.log(response.data);
                                                            toast.info(response.data.message, toastInfo);

                                                            console.log(selectedOwner);
                                                            console.log("opla")
                    
                                                            if(selectedOwner == 1){

                                                                getDataChangesRef();
                                                            } else {
                                
                                                                getDataChanges();
                                                            }
                                    
                                                    } else {
                                    
                                                        if(response.status == 401){
                                    
                                                                console.log("Istekla sesija");
                                        
                                                                toast.error(response.data.message, toastError);
                                                                
                                                                dispatch(actions.logOut());
                                                                navigate('/');
                                    
                                                        } else {
                                                                toast.error(response.data.message,
                                                                    toastError);
                                                                                    
                                    
                                                        }
                                    
                                                
                                                    }        
                                                
                    
                                                
                                                },
                                    
                                                (error) => {
                                    
                                                    if (!unmounted) {
                                                
                                                
                                    
                                    
                                                
                                                            if(!error.response){
                                    
                                                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                                    toastError);
                                                            
                                    
                                    
                                                            } else {
                                    
                                    
                                                                if(!error.response.status){
                                    
                                                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                                    toastError);
                                    
                                                                }else{
                                    
                                                                    if (error.response.status == 401) {
                                                
                                                            
                                                                        toast.error(error.response.data.message,
                                                                                toastError);
                                                                        
                                                                                setTimeout(() => {
                                                                                    dispatch(actions.logOut());
                                                                                    navigate('/');
                                                                                }, 5000);   
                                    
                                                                    
                                                                
                                                                    } else {
                                                                
                                                                
                                                                                toast.error(error.response.data.message,
                                                                                    toastError);
                                                                                                            
                                                                        
                                                                    }
                                                                }
                                                            }
                                                        
                                                    }
                                                
                                                
                                                });
                                

                                            }
                    });

        }


    } else {


        if(selectedCell.Stanje != 1){

        
            toast.error("Izmjena je predviđena samo za stavke koje su u stanju 1, 0", toastError);


        } else if(selectedCell.Gotovo && selectedCell.Gotovo != 0){

    
                toast.error("Izmjena je predviđena samo za stavke koje su u stanju 1, 0", toastError);
        
        } else if (selectedCell.Komentar && selectedCell.Komentar.toUpperCase().indexOf("RAZL")== -1){
        
                toast.error("Izmjena je predviđena samo za slučaj promijenjenog TK operatera.", toastError);
                
        } else if (!selectedCell.Ref || selectedCell.Ref!=ref){

                toast.error("Prije izmjene morate preuzeti podatak na sebe.", toastError);
                
        } else if (!selectedCell.Komentar){
        
                toast.error("Izmjena je predviđena samo za slučaj promijenjenog TK operatera.", toastError);

        } else {

            
    
                APICall(
                    '/Izmjena5-1',
                    {
            
                        platform: '0',
                        version:'1.0',
                        tel: telefon,
                        //tkID: tkList.map(item=>item.toString()),
                        //tkID: operator
                        tkID: selectedCell["ID operatera"]
            
                    },
                    {
                        token
                    }).then(
            
            
                        (response) => {
            

                            dispatch(actions.isNotLoading());

                            if(response==undefined) dispatch(actions.isNotLoading());
                        
                            if(response.status == 200){
                                    
                                    toast.info(response.data.message, toastInfo);

                                    if(selectedOwner == 1){

                                        getDataChangesRef();
                                    } else {
        
                                        getDataChanges();
                                    }
            
                            } else {
            
                                if(response.status == 401){
            
                                        console.log("Istekla sesija");
                
                                        toast.error(response.data.message, toastError);
                                        
                                        dispatch(actions.logOut());
                                        navigate('/');
            
                                } else {
                                        toast.error(response.data.message,
                                            toastError);
                                                            
            
                                }
            
                        
                            }        
                        

                        
                        },
            
                        (error) => {
            
                            if (!unmounted) {
                        
                        
            
            
                        
                                    if(!error.response){
            
                                        toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                            toastError);
                                    
            
            
                                    } else {
            
            
                                        if(!error.response.status){
            
                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                            toastError);
            
                                        }else{
            
                                            if (error.response.status == 401) {
                        
                                    
                                                toast.error(error.response.data.message,
                                                        toastError);
                                                
                                                        setTimeout(() => {
                                                            dispatch(actions.logOut());
                                                            navigate('/');
                                                        }, 5000);   
            
                                            
                                        
                                            } else {
                                        
                                        
                                                        toast.error(error.response.data.message,
                                                            toastError);
                                                                                    
                                                
                                            }
                                        }
                                    }
                                
                            }
                        
                        
                        });
        

        }

    }

    





}

const knjiziRucno = () => {
    
 
 

    
    Swal.fire({
        title: `Odaberite promjene koje želite knjižiti`,
        text: `
        Sve promjene sa statusom 1 (greška) prebacit ćete u status 3 (forsiranje) i proknjižiti.
        Ova radnja se ne može poništiti.`,
        icon: "warning",
        iconSize: '5',
        input: "select",
        inputOptions: {

            sve: "Sve",
            odabrane: "Odabrani retci",


        },
        inputPlaceholder: "Odaberite promjene za knjiženje",
        inputValidator: (value) => {
            return new Promise((resolve) => {
                console.log(value);
              if (value == "sve") {
                console.log("Odabrani svi!!");

                proknjiziOdabrano(0);

                

                resolve(0);
                Swal.close();
              } else if (value=="odabrane"){
                console.log("Odabrani neki!")

                proknjiziOdabrano(1);
                resolve(1);
                Swal.close();
              } else {
                console.log("Nista!!!");
                
                resolve("Niste odabrali podatke za knjiženje");
              }
            });
          },
        showCancelButton: true,
        confirmButtonColor: "#e31b2e",
        cancelButtonColor: "#29648a",
        showCancelButton: true,
        confirmButtonText: "Knjiži",
        cancelButtonText: "Odustani",
        reverseButtons: true
/*}).then((result) => {
        if (result.isConfirmed) {

            console.log("aaaaaaaaaaaaaaa");

            //proknjiziOdabrano();

     

        }*/
      });
      
    
};


const proknjiziOdabrano = async (what) => {

    console.log("Knjižim: ");
    console.log(what)

    let item = [];

    /*
    dispatch(actions.isLoading());
    setTimeout(() => {
        dispatch(actions.isNotLoading());
        toast.error("Nije moguće dohvatiti podatke na serveru, provjerite mrežnu povezivost i pokušajte ponovno", toastError);
    }, 10000);  
    */

    if(what == 0){

            console.log(filteredTableData.rows.length);
            console.log(filteredTableData.rows[0]);

            let tmp = await filteredTableData.rows.filter((val)=>{
                    console.log(val.rbr);
                    console.log(val.Stanje);
                    if(val.Stanje=='1' || val.Stanje==1 || val.Stanje =='3' || val.Stanje==3){

                        
                        return val;
                    } else if (val.Stanje == '0' || val.Stanje==0){
                        
                        return val;
                    }
            })

            console.log(tmp.length);

            console.log(tmp);

            item = tmp;


            if (tmp.length > 500){

                    toast.error("Istovremeno možete ručno knjižiti najviše 500 podataka", toastError);

 

            } else {



            dispatch(actions.isLoading());

    
            APICall(
                '/rucnoKnjizi',
                
                {
        
                     platform: '0',
                     version:'1.0',
                     items: item,
                     ref: ref,
                     tkID: tkList.map(item=>item.toString()),
        
                 },
                {
                    token
                }).then(
        
        
                    (response) => {
                       
                        console.log(response);
                        dispatch(actions.isNotLoading());
        
        
                        if(response==undefined) dispatch(actions.isNotLoading());
        
                        if(response.status !== 200) {
        
                            if(response.status == 401){
              
                                    console.log("Istekla sesija");
              
                                    toast.error(response.data.message, toastError);
                                    
                                    dispatch(actions.logOut());
                                    navigate('/');
              
                            } else{
              
                                    toast.error(response.data.message, toastError);
              
              
                            }
                            
              
              
              
                        } else {

        
                                            console.log("Going to toast some toast for myself only one toast is necessery but a big one")
        
                                            toast.info(response.data.message, toastInfo);

                                            getDataChangesRef();

        
                        
                        }
                   
                            
                    
                    },
        
                    (error) => {
        
                                dispatch(actions.isNotLoading());
        
                                
        
                    });
                       
                }

    } else {

            if((selectedItems && selectedItems.length && selectedItems.length>0) || selectedCell){



                if(selectedItems && selectedItems.length && selectedItems.length > 0){

                    console.log("Odabrani itemi")
                    console.log(selectedItems.length)
                    console.log(selectedItems);
                    //console.log(selectedItems.rows)

                    let tmp2 = [];

                    let tmp = selectedItems.filter((val)=>{
                    
                        if(val.Stanje=='1' || val.Stanje==1 || val.Stanje =='3' || val.Stanje==3){
    

                            tmp2.push(val);
                            return val;
                        } else if (val.Stanje == '0' || val.Stanje==0){
                            
                            tmp2.push(val);
                            return val;
                        }
                    })
                    item = tmp2;

                    console.log(item);

                } else {

                    console.log("Odabrana celija");
                    console.log(selectedCell);
                    item.push(selectedCell);
                    //item = selectedCell;

                    console.log(item);
                } 

                console.log("Calling the API!!!!");
                console.log(item)


                if (item.length > 500){

                    toast.error("Istovremeno možete ručno knjižiti najviše 500 podataka", toastError);


                } else {

        

                dispatch(actions.isLoading());

                APICall(
                    '/rucnoKnjizi',
                    
                    {
            
                         platform: '0',
                         version:'1.0',
                         items: item,
                         ref: ref,
                         tkID: tkList.map(item=>item.toString()),
            
                     },
                    {
                        token
                    }).then(
            
            
                        (response) => {
                           
                            console.log(response);
                            dispatch(actions.isNotLoading());
            
            
                            if(response==undefined) dispatch(actions.isNotLoading());
            
                            if(response.status !== 200) {
            
                                if(response.status == 401){
                  
                                        console.log("Istekla sesija");
                  
                                        toast.error(response.data.message, toastError);
                                        
                                        dispatch(actions.logOut());
                                        navigate('/');
                  
                                } else{
                  
                                        toast.error(response.data.message, toastError);
                  
                  
                                }
                                
                  
                  
                  
                            } else {
    
            
                                                console.log("Going to toast some toast for myself only one toast is necessery but a big one")
            
                                                toast.info(response.data.message, toastInfo);

                                                getDataChangesRef();
    
            
                            
                            }
                       
                                
                        
                        },
            
                        (error) => {
            
                                    dispatch(actions.isNotLoading());
            
                                    
            
                        });
                    }

            } else {

                console.log("Nema podataka za knjizti!");
                toast.error("Nije odabran nijedan redak za knjiženje", toastError);
            }

    }

}






const naziv1Ref = useRef(null);
const naziv2Ref = useRef(null);


const mjesto_ref = useRef(null);
const ulica_ref = useRef(null);
const kbr_ref = useRef(null);
const kbrZnak_ref = useRef(null);


function rucnaKorekcija(){



    let unmounted = false;
    let source = axios.CancelToken.source();

    

    console.log("Ručna korekcija!!!");
    console.log(telefon);
    console.log(selectedRucnoTip);
    console.log(selectedUlica);
    console.log(selectedMjesto);

    let tmpTip = tip;

    console.log(tmpTip)

    if(selectedRucnoTip == 0){

                tmpTip = "Privatni"
    }else if(selectedRucnoTip == 1 || selectedRucnoTip == 2){

                tmpTip = "Poslovni"

    }

    let tmptel= telefon;
    let tmpNaziv1 = rucnoNaziv1?rucnoNaziv1:'';
    let tmpNaziv2 =  rucnoNaziv2?rucnoNaziv2:'';



    let tmpmj_id = selectedMjesto.MJESTO_ID?selectedMjesto.MJESTO_ID:selectedMjesto.mjesto_id;
    let tmpulica_id = selectedUlica.ULICA_ID?selectedUlica.ULICA_ID:selectedUlica.ulica_id;
    let tmpkbr = rucnoKBR?rucnoKBR:'';
    let tmpkbr_plus = rucnoKBRDodatak?rucnoKBRDodatak:'';

    if(tmpmj_id && tmpmj_id!='' && tmpulica_id && tmpulica_id!='' && tmpkbr && tmpkbr!='' && tmpkbr_plus && 
        tmpkbr_plus.toUpperCase().localeCompare('BB')==0){

            console.log(tmpkbr);
            console.log(tmpkbr_plus);

            console.log("Ne moze BB!!!!!!!!!");

                Swal.fire({

                title: `Upisali ste i kućni broj i BB kao znak - jeste li sigurni da želite nastaviti upis?`,
                text: "Ova radnja se ne može poništiti",
                icon: "warning",
                iconSize: '5',

                showCancelButton: true,
                confirmButtonColor: "#e31b2e",
                cancelButtonColor: "#29648a",
                showCancelButton: true,
                confirmButtonText: "Da, nastavi!",
                cancelButtonText: "Odustani",
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {

                        APICall(
                            //'/RucnaKorekcija',
                            '/RucnaKorekcija_v2',
                            {

                                platform: '0',
                                version:'1.0',
                                tel: telefon,
                                cnt:cnt,
                                naziv1: tmpNaziv1,
                                naziv2: tmpNaziv2,
                                mj_id: tmpmj_id,
                                ulica_id: tmpulica_id,
                                kbr: tmpkbr,
                                kbr_plus: tmpkbr_plus,
                                tip: tmpTip,
                                ref: ref
                                

                            },
                            {
                                token
                            }).then(


                                (response) => {

                                    if(response==undefined) dispatch(actions.isNotLoading());
                                                            
                                    if(response.status == 200){
                                            console.log(response.data);
                                            toast.info(response.data.message, toastInfo);


                                            getDataChanges();

                                    } else {

                                        if(response.status == 401){

                                                console.log("Istekla sesija");
                        
                                                toast.error(response.data.message, toastError);
                                                
                                                dispatch(actions.logOut());
                                                navigate('/');

                                        } else {
                                                toast.error(response.data.message,
                                                    toastError);
                                                                    

                                        }

                                
                                    }        
                                
                                },

                                (error) => {

                                    if (!unmounted) {
                                
                                


                                
                                            if(!error.response){

                                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);
                                            


                                            } else {


                                                if(!error.response.status){

                                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);

                                                }else{

                                                    if (error.response.status == 401) {
                                
                                            
                                                        toast.error(error.response.data.message,
                                                                toastError);
                                                        
                                                                setTimeout(() => {
                                                                    dispatch(actions.logOut());
                                                                    navigate('/');
                                                                }, 5000);   

                                                    
                                                
                                                    } else {
                                                
                                                
                                                                toast.error(error.response.data.message,
                                                                    toastError);
                                                                                            
                                                        
                                                    }
                                                }
                                            }
                                        
                                    }
                                
                                
                                });

                    

                }
            });


    } else {

                        APICall(
                            //'/RucnaKorekcija',
                            '/RucnaKorekcija_v2',
                            {

                                platform: '0',
                                version:'1.0',
                                tel: telefon,
                                cnt:cnt,
                                naziv1: tmpNaziv1,
                                naziv2: tmpNaziv2,
                                mj_id: tmpmj_id,
                                ulica_id: tmpulica_id,
                                kbr: tmpkbr,
                                kbr_plus: tmpkbr_plus,
                                tip: tmpTip,
                                ref: ref
                                

                            },
                            {
                                token
                            }).then(


                                (response) => {

                                    if(response==undefined) dispatch(actions.isNotLoading());
                                                            
                                    if(response.status == 200){
                                            console.log(response.data);
                                            toast.info(response.data.message, toastInfo);


                                            getDataChanges();

                                    } else {

                                        if(response.status == 401){

                                                console.log("Istekla sesija");
                        
                                                toast.error(response.data.message, toastError);
                                                
                                                dispatch(actions.logOut());
                                                navigate('/');

                                        } else {
                                                toast.error(response.data.message,
                                                    toastError);
                                                                    

                                        }

                                
                                    }        
                                
                                },

                                (error) => {

                                    if (!unmounted) {
                                
                                


                                
                                            if(!error.response){

                                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);
                                            


                                            } else {


                                                if(!error.response.status){

                                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);

                                                }else{

                                                    if (error.response.status == 401) {
                                
                                            
                                                        toast.error(error.response.data.message,
                                                                toastError);
                                                        
                                                                setTimeout(() => {
                                                                    dispatch(actions.logOut());
                                                                    navigate('/');
                                                                }, 5000);   

                                                    
                                                
                                                    } else {
                                                
                                                
                                                                toast.error(error.response.data.message,
                                                                    toastError);
                                                                                            
                                                        
                                                    }
                                                }
                                            }
                                        
                                    }
                                
                                
                                });

    }








}

function rucnaKorekcija_interval(){



    let unmounted = false;
    let source = axios.CancelToken.source();

    

    console.log("Ručna korekcija!!!");
    console.log(selectedItemsTelefon);
    console.log(selectedRucnoTip);
    console.log(selectedUlica);
    console.log(selectedMjesto);

    let tmpTip = tip;

    console.log(tmpTip)

    if(selectedRucnoTip == 0){

                tmpTip = "Privatni"
    }else if(selectedRucnoTip == 1 || selectedRucnoTip == 2){

                tmpTip = "Poslovni"

    }

    let tmptel= selectedItemsTelefon;
    let tmpNaziv1 = rucnoNaziv1?rucnoNaziv1:'';
    let tmpNaziv2 =  rucnoNaziv2?rucnoNaziv2:'';



    let tmpmj_id = selectedMjesto.MJESTO_ID?selectedMjesto.MJESTO_ID:selectedMjesto.mjesto_id;
    let tmpulica_id = selectedUlica.ULICA_ID?selectedUlica.ULICA_ID:selectedUlica.ulica_id;
    let tmpkbr = rucnoKBR?rucnoKBR:'';
    let tmpkbr_plus = rucnoKBRDodatak?rucnoKBRDodatak:'';


    if(tmpmj_id && tmpmj_id!='' && tmpulica_id && tmpulica_id!='' && tmpkbr && tmpkbr!='' && tmpkbr_plus && 
        tmpkbr_plus.toUpperCase().localeCompare('BB')==0){

            console.log(tmpkbr);
            console.log(tmpkbr_plus);

            console.log("Ne moze BB!!!!!!!!!");

                Swal.fire({

                title: `Upisali ste i kućni broj i BB kao znak - jeste li sigurni da želite nastaviti upis?`,
                text: "Ova radnja se ne može poništiti",
                icon: "warning",
                iconSize: '5',

                showCancelButton: true,
                confirmButtonColor: "#e31b2e",
                cancelButtonColor: "#29648a",
                showCancelButton: true,
                confirmButtonText: "Da, nastavi!",
                cancelButtonText: "Odustani",
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {

                        APICall(
                            '/RucnaKorekcija_v2_interval',
                            {

                                platform: '0',
                                version:'1.0',
                                //tel: selectedItemsTelefon,
                                tel: selectedItems,
                                //cnt:cnt,
                                naziv1: tmpNaziv1,
                                naziv2: tmpNaziv2,
                                mj_id: tmpmj_id,
                                ulica_id: tmpulica_id,
                                kbr: tmpkbr,
                                kbr_plus: tmpkbr_plus,
                                tip: tmpTip,
                                ref: ref
                                

                            },
                            {
                                token
                            }).then(


                                (response) => {

                                    if(response==undefined) dispatch(actions.isNotLoading());
                                                            
                                    if(response.status == 200){
                                            console.log(response.data);
                                            toast.info(response.data.message, toastInfo);

                                            getDataChanges();

                                    } else {

                                        if(response.status == 401){

                                                console.log("Istekla sesija");
                        
                                                toast.error(response.data.message, toastError);
                                                
                                                dispatch(actions.logOut());
                                                navigate('/');

                                        } else {
                                                toast.error(response.data.message,
                                                    toastError);
                                                                    

                                        }

                                
                                    }        
                                
                                },

                                (error) => {

                                    if (!unmounted) {
                                
                                


                                
                                            if(!error.response){

                                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);
                                            


                                            } else {


                                                if(!error.response.status){

                                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);

                                                }else{

                                                    if (error.response.status == 401) {
                                
                                            
                                                        toast.error(error.response.data.message,
                                                                toastError);
                                                        
                                                                setTimeout(() => {
                                                                    dispatch(actions.logOut());
                                                                    navigate('/');
                                                                }, 5000);   

                                                    
                                                
                                                    } else {
                                                
                                                
                                                                toast.error(error.response.data.message,
                                                                    toastError);
                                                                                            
                                                        
                                                    }
                                                }
                                            }
                                        
                                    }
                                
                                
                                });

                            }
            });

    } else {



            APICall(
                '/RucnaKorekcija_v2_interval',
                {

                    platform: '0',
                    version:'1.0',
                    //tel: selectedItemsTelefon,
                    tel:selectedItems,
                    naziv1: tmpNaziv1,
                    naziv2: tmpNaziv2,
                    mj_id: tmpmj_id,
                    ulica_id: tmpulica_id,
                    kbr: tmpkbr,
                    kbr_plus: tmpkbr_plus,
                    tip: tmpTip,
                    ref: ref
                    

                },
                {
                    token
                }).then(


                    (response) => {

                        if(response==undefined) dispatch(actions.isNotLoading());
                                                
                        if(response.status == 200){
                                console.log(response.data);
                                toast.info(response.data.message, toastInfo);

                                getDataChanges();

                        } else {

                            if(response.status == 401){

                                    console.log("Istekla sesija");
            
                                    toast.error(response.data.message, toastError);
                                    
                                    dispatch(actions.logOut());
                                    navigate('/');

                            } else {
                                    toast.error(response.data.message,
                                        toastError);
                                                        

                            }

                    
                        }        
                    
                    },

                    (error) => {

                        if (!unmounted) {
                    
                    


                    
                                if(!error.response){

                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                        toastError);
                                


                                } else {


                                    if(!error.response.status){

                                        toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                        toastError);

                                    }else{

                                        if (error.response.status == 401) {
                    
                                
                                            toast.error(error.response.data.message,
                                                    toastError);
                                            
                                                    setTimeout(() => {
                                                        dispatch(actions.logOut());
                                                        navigate('/');
                                                    }, 5000);   

                                        
                                    
                                        } else {
                                    
                                    
                                                    toast.error(error.response.data.message,
                                                        toastError);
                                                                                
                                            
                                        }
                                    }
                                }
                            
                        }
                    
                    
                    });

    }

}
const izmijeniIntervalStatus=() => {




    Swal.fire({
        title: `Jeste li sigurni da želite promijeniti status 1-->5 za sve odabrane podatke?`,
        text: "Ova radnja se ne može poništiti",
        icon: "warning",
        iconSize: '5',

        showCancelButton: true,
        confirmButtonColor: "#e31b2e",
        cancelButtonColor: "#29648a",
        showCancelButton: true,
        confirmButtonText: "Da, promijeni!",
        cancelButtonText: "Odustani",
        reverseButtons: true
        }).then((result) => {
        if (result.isConfirmed) {

            

        }
        });
    
};
    



function changeTKC(tmpTKC) {
      
   
    let unmounted = false;
    let source = axios.CancelToken.source();

    console.log("SelectedPhone is:");
    console.log(telefon);

    console.log("selected cell cnt is: ");
    console.log(cnt);


    APICall(
        '/ChangeTKCValDnevnik',
        {

            platform: '0',
            version:'1.0',
            oznaka: telefon,
            tkc: tmpTKC,
            cnt:cnt

        },
        {
            token
        }).then(


            (response) => {

                    if (!unmounted) {
            





                        dispatch(actions.isNotLoading());

                        if(response==undefined) dispatch(actions.isNotLoading());
                    
                        if(response.status == 200){
                                
                                toast.info(response.data.message, toastInfo);

                                setChangingTKC(false);
                                setChosenTKCRow('');

                     
    
                                getDataChangesRef();

        
                        } else {
        
                            if(response.status == 401){
        
                                    console.log("Istekla sesija");
            
                                    toast.error(response.data.message, toastError);
                                    
                                    dispatch(actions.logOut());
                                    navigate('/');
        
                            } else {
                                    toast.error(response.data.message,
                                        toastError);
                                                        
        
                            }
        
                    
                        }        
                    


        
                    }
            
            },

            (error) => {

                if (!unmounted) {
            
            


            
                        if(!error.response){

                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);
                        


                        } else {


                            if(!error.response.status){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);

                            }else{

                                if (error.response.status == 401) {
            
                        
                                    toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                
                            
                                } else {
                            
                            
                                            toast.error(error.response.data.message,
                                                toastError);
                                                                        
                                    
                                }
                            }
                        }
                    
                }
            
            
            });

             
    
}

const handleChangeTKCRow = (event) => {
    //setChosenTKCRow(event.target.id);
    
    console.log(event);
    console.log(event.target.value);

    setChosenTKCRow(event.target.value);

    Swal.fire({
        title: `Jeste li sigurni da želite promijeniti TKC odabranog broja?`,
        text: "Ova radnja se ne može poništiti",
        icon: "warning",
        iconSize: '5',

        showCancelButton: true,
        confirmButtonColor: "#e31b2e",
        cancelButtonColor: "#29648a",
        showCancelButton: true,
        confirmButtonText: "Da, promijeni!",
        cancelButtonText: "Odustani",
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {

            changeTKC(event.target.value);
            

        }
      });
      
    
};

const otvoriArhivu=async ()=>{

const inputValue = '';

await Swal.fire({
    title: "Unesite telefon kojeg želite pretražiti?",
    input: "text",
    inputLabel: "Telefon",
    inputValue,
    showCancelButton: true,
    confirmButtonColor: "#e31b2e",
    confirmButtonText: "Traži",
    inputValidator: (value) => {
      if (!value) {
        return "Morate upisati telefonski broj";
      } 
    }
    }).then((result) => {

        console.log("They clicked ok")
        console.log(result.value);
    if (result.isConfirmed) {

        dispatch(actions.isLoading());




        //dispatch(actions.isLoading());

 
    
        setSelectedItems([]);
        setSelectedItemsTelefon([]);
    
        setSelectedOwner(0);

        APICall(
         
            '/GetDnevnePromjeneArhiva',
            
            {
    
                 platform: '0',
                 version:'1.0',
                 tel: result.value,
    
             },
            {
                token
            }).then(
    
    
                (response) => {
                   
                    dispatch(actions.isNotLoading());
    
                    if(response==undefined) dispatch(actions.isNotLoading());

                    if(response.status==200){
                
                            if(response.data.list && response.data.list.length!=0){
                                    
                                    var dataTmp = response.data;
    
                              
                                    console.log(dataTmp.list[0]);

                                    console.log("Postoji lista");
                                    console.log(response.data.list.length);
    
    
                                    let dataArr = dataTmp.list;



                                    let columns= Object.getOwnPropertyNames(dataArr[0]).map((column,index)=>{
                                        var a = column.charAt(0).toUpperCase() + column.slice(1);
                                        return(
                                            {
                                                "field": column,
                                                "getRowId": index,
                                                
                                            
                                            }
                                        )
                                    })
                    
                                    
                    
                                    const comparator = (v1, v2) => {
                                        const currVal = v1.startsWith('***')?v1.substring(3):v1;
                                        const nextVal = v2.startsWith('***') ?v2.substring(3):v2;
                                    
                                        if (currVal === nextVal) { return 0; }
                                    
                                        return currVal < nextVal ? -1 : 1;
                                    }
                                
                    
                    
                    
                                    const updatedColumns = columns.map((col) => {
                                
                                        if(col.field == 'rbr'){
                        
                                            return{
                        
                                                ...col,
                                                'headerCheckboxSelection': false,
                                            }
                                        }
                                        if(col.field == 'Datum'){
                        
                                            return {
                                                ...col,
                                                valueFormatter: ({ value }) => {
                                                if (value) {
                                                    
                                                
                                                    let date = new Date(value);
                        
                        
                                                    //return date.toLocaleDateString("DD.MM.YYYY"); // Format as MM/DD/YYYY (or customize)
                                                    const options = {
                                                    
                                                        year: "numeric",
                                                        month: "numeric",
                                                        day: "numeric",
                                                    };
                                                    return date.toLocaleDateString("hr-HR", options);
                                                    
                                                
                                                }
                                                return value;
                                                },
                                                sortComparator: (v1, v2) => {
                                                const date1 = new Date(v1);
                                                const date2 = new Date(v2);
                                                return date1 - date2; // Compare dates
                                                },
                                            };
                                            
                        
                                        }
                        
                                        if(col.field == 'Vrsta rada'){
                        
                                            return {
                                                ...col, comparator
                                            
                                            };
                                            
                        
                                        }
                        
                                        return col;
                                    });
                    
                    
                                    columns = updatedColumns;
                    
                                    
                                    let rows =dataArr.map((item, index)=> {
                                            return({...item,id:index})
                                    })
                    
                                    console.log(rows);
                                    console.log(columns);
                                
                    
                                    setFilteredTableData({
                                                columns,
                                                rows
                                    })

                                    setArchiveView(true);
                                
                    
 
                            }else{
    
         
    
                                    setFilteredTableData([],[])
    
                                    setData([]);     

                                    Swal.fire(`Nisu pronađeni podaci za traženi telefon, molimo provjerite unos`);
                                    
                                   
    
                            }
                        } else {


                            if(response.status == 401){

                                toast.error(response.data.message,
                                    toastError);
                            
                                    setTimeout(() => {
                                        dispatch(actions.logOut());
                                        navigate('/');
                                    }, 5000);   

                            }else {

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            }
                        }
                        
                
                },
    
                (error) => {
    
                    dispatch(actions.isNotLoading());
    
                
                    setFilteredTableData([],[]);
    
    
                
                            if(!error.response){
    
                                 toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                      toastError);
                              
    
    
                            } else {
    
    
                                 if(!error.response.status){
    
                                      toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                      toastError);
    
                                 }else{
    
                                      if (error.response.status == 401) {
                  
                               
                                           toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   
    
                                      
                                 
                                      } else {
                                 
                                 
                                                toast.error(error.response.data.message,
                                                     toastError);
                                                                               
                                           
                                      }
                                 }
                            }
                        
                       
                
                
                });
    
                



    } else{

        setChangeVisible(true);
    }
  });






  

}





const skiniObjavu = () => {
    //setChosenTKCRow(event.target.id);
    
    setTimeout(() => {
        toast.success("Uspješno izmijenjen podataka u bazi", toastSuccess);
    }, 5000);   

    /*
    Swal.fire({
        title: `Jeste li sigurni da želite maknuti objavu za sve odabrane podatke?`,
        text: "Ova radnja se ne može poništiti",
        icon: "warning",
        iconSize: '5',

        showCancelButton: true,
        confirmButtonColor: "#e31b2e",
        cancelButtonColor: "#29648a",
        showCancelButton: true,
        confirmButtonText: "Da, makni!",
        cancelButtonText: "Odustani",
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {

            

        }
      });
      */
    
};

const staviObjavu = () => {
    //setChosenTKCRow(event.target.id);
    
    setTimeout(() => {
        toast.success("Uspješno izmijenjen podataka u bazi", toastSuccess);
    }, 5000);   
/*
    Swal.fire({
        title: `Jeste li sigurni da želite postaviti objavu za sve odabrane podatke?`,
        text: "Ova radnja se ne može poništiti",
        icon: "warning",
        iconSize: '5',

        showCancelButton: true,
        confirmButtonColor: "#e31b2e",
        cancelButtonColor: "#29648a",
        showCancelButton: true,
        confirmButtonText: "Da, objavi!",
        cancelButtonText: "Odustani",
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {

            

        }
      });
      */
    
};





  const rucnoTipChange = (event) => {
    setSelectedRucnoTip(event.target.id);

    console.log("Traženi tip je");
    
    console.log(event);
    console.log(event.target.id);
    
  
  };


 

const [open, setOpen] = React.useState(false);
const [loading, setLoading] = React.useState(false);
const inputRefUlice = React.useRef();

const [highlightedOption, setHighlightedOption] = React.useState(null);

const [openMjesto, setOpenMjesto] = React.useState(false);
const [loadingMjesto, setLoadingMjesto] = React.useState(false);
const inputRefMjesto = React.useRef();

const [highlightedOptionMjesto, setHighlightedOptionMjesto] = React.useState(null);



React.useEffect(() => {
    const fetchData = async () => {
      if (rucnoUlica && rucnoUlica.length >= 3) {
        console.log(rucnoUlica)
        setLoading(true);
        await searchForUlica(rucnoUlica);
     
        setOpen(true);
        setLoading(false);
      } else {
        setOpen(false);

      }
    };
    
    fetchData();
  }, [rucnoUlica]);


  React.useEffect(() => {
    const fetchDataMjesto = async () => {
      if (rucnoMjesto && rucnoMjesto.length >= 3) {
        console.log("I'm gonna attempt searching!!!!!");
        console.log(rucnoMjesto);
        setLoadingMjesto(true);
        await searchForMjesto(rucnoMjesto);
     
        setOpenMjesto(true);
        setLoadingMjesto(false);
      } else {
        setOpenMjesto(false);

      }
    };
    
    fetchDataMjesto();
  }, [rucnoMjesto]);



  const handleKeyDownUlica = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // prevent form submit or default behavior

      if (!selectedUlica && highlightedOption) {
        console.log(highlightedOption);
        setSelectedUlica(highlightedOption);

        // blur the input after selection
        if (inputRefUlice.current) {
          inputRefUlice.current.blur();
        }
        setOpen(false); // close dropdown
      }

      if(selectedUlica){

            kbr_ref.current.focus();
      }

    }
  };


  const handleKeyDownMjesto = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // prevent form submit or default behavior

      if (!selectedMjesto && highlightedOptionMjesto) {
        console.log(highlightedOptionMjesto);
        setSelectedMjesto(highlightedOptionMjesto);

        // blur the input after selection
        if (inputRefMjesto.current) {
          inputRefMjesto.current.blur();
        }
        setOpenMjesto(false); // close dropdown
      }

      if(selectedMjesto){

            inputRefUlice.current.focus();
      }


    }
  };








async function searchForUlica(val){

    console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaa");
    let tmpMjesto = 0;
    
    if(selectedMjesto && selectedMjesto.MJESTO_ID!=''){

        console.log("Postoji mjesto");

        console.log(selectedMjesto);

        tmpMjesto = selectedMjesto.MJESTO_ID?selectedMjesto.MJESTO_ID:selectedMjesto.mjesto_id;
        console.log(tmpMjesto)

    } else if (MJESTO_ID && MJESTO_ID!=0){

        console.log("Ima mjesta!!!");

        console.log(MJESTO_ID);

        tmpMjesto = MJESTO_ID;
    }

    if(tmpMjesto != 0){

        if(val.length>2){
       
            APICall(
                '/getUlicaSuggestionMjesto',
                {
        
                    platform: '0',
                    version:'1.0',
    
                    val: val,
                    mjesto:tmpMjesto
        
                },
                {
                    token
                }).then(
        
        
                    (response) => {
                        console.log(response)
        
        
                        if (response.status==200) {
                            
                               setListUlice(response.data.strukture)
                         
        
        
                        }
        
                
                            
                    
                    },
        
                    (error) => {
        
                        dispatch(actions.isNotLoading());
        
                    
           
        
        
                    
                                if(!error.response){
        
                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                        toastError);
                                
        
        
                                } else {
        
        
                                    if(!error.response.status){
        
                                        toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                        toastError);
        
                                    }else{
        
                                        if (error.response.status == 401) {
                    
                                
                                            toast.error(error.response.data.message,
                                                    toastError);
                                            
                                                    setTimeout(() => {
                                                        dispatch(actions.logOut());
                                                        navigate('/');
                                                    }, 5000);   
        
                                        
                                    
                                        } else {
                                    
                                    
                                                    toast.error(error.response.data.message,
                                                        toastError);
                                                                                
                                            
                                        }
                                    }
                                }
                            
                        
                    
                    
                    });
        } else{
            setListUlice([])
    
        }

    } else {

        if(val.length>2){
       
            APICall(
                '/getUlicaSuggestion',
                {
        
                    platform: '0',
                    version:'1.0',
    
                    val: val,
                 
        
                },
                {
                    token
                }).then(
        
        
                    (response) => {
                        console.log(response)
        
        
                        if (response.status==200) {
                            
                               setListUlice(response.data.strukture)
                         
        
        
                        }
        
                
                            
                    
                    },
        
                    (error) => {
        
                        dispatch(actions.isNotLoading());
        
                    
           
        
        
                    
                                if(!error.response){
        
                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                        toastError);
                                
        
        
                                } else {
        
        
                                    if(!error.response.status){
        
                                        toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                        toastError);
        
                                    }else{
        
                                        if (error.response.status == 401) {
                    
                                
                                            toast.error(error.response.data.message,
                                                    toastError);
                                            
                                                    setTimeout(() => {
                                                        dispatch(actions.logOut());
                                                        navigate('/');
                                                    }, 5000);   
        
                                        
                                    
                                        } else {
                                    
                                    
                                                    toast.error(error.response.data.message,
                                                        toastError);
                                                                                
                                            
                                        }
                                    }
                                }
                            
                        
                    
                    
                    });
        } else{
            setListUlice([])
    
        }

    }


}


async function searchForMjesto(val){

    if(val.length>2){

        console.log(selectedNetwork);
     

        let tmpTKC = selectedNetwork?(selectedNetwork.tkc?selectedNetwork.tkc:''):'';
       
        APICall(
            '/getMjestoSuggestionDnevne',
            {
    
                platform: '0',
                version:'1.0',

                val: val,
                tkc:tmpTKC
    
            },
            {
                token
            }).then(
    
    
                (response) => {
                    console.log(response)
    
    
                    if (response.status==200) {

                            console.log(response.data.strukture[0]);
                        
                            setListMjesta(response.data.strukture)
    
    
                    }
    
            
                        
                
                },
    
                (error) => {
    
                    dispatch(actions.isNotLoading());
    
                
       
    
    
                
                            if(!error.response){
    
                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            
    
    
                            } else {
    
    
                                if(!error.response.status){
    
                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
    
                                }else{
    
                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   
    
                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                            }
                        
                    
                
                
                });
    } else{
        setListMjesta([])
    }
}

async function getMjestoFromUlica(val){


       
        APICall(
            '/getMjesto',
            {
    
                platform: '0',
                version:'1.0',

                id: val
    
            },
            {
                
                token

            }).then(
    
    
                (response) => {
                    
                    console.log(response)
    
    
                    if (response.status==200) {
                        
                            console.log(response.data.mjesto);


                            setSelectedMjesto(response.data.mjesto[0])
                            setRucnoMjesto(response.data.mjesto[0].NAZIV);
                            setTkcFirma(response.data.mjesto[0].ID_TKC)

                            

                            
    
    
                    }
    
            
                        
                
                },
    
                (error) => {
    
                    dispatch(actions.isNotLoading());
    
                
       
    
    
                
                            if(!error.response){
    
                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            
    
    
                            } else {
    
    
                                if(!error.response.status){
    
                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
    
                                }else{
    
                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   
    
                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                            }
                        
                    
                
                
                });
    
}

const [existStrukt, setExistStrukt] = useState ([]);
const [existStruktGrid, setExistStruktGrid] = useState ([]);


async function getBijeleStruktureDnevne(codeCompany, tkcTmp, compNaziv, mjNaziv, koment) {

        let tmp = tkcTmp;
     

        console.log("Getting strukture");
        console.log(tmp);
        console.log(codeCompany)

        dispatch(actions.isLoading());

    
    APICall(
        '/GetBijeleStrukture',
        {

            platform: '0',
            version:'1.0',
            sifra:codeCompany,
            tkc: tmp

        },
        {
            token
        }).then(


            (response) => {
                console.log(response)
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());


                if(response.status !== 200) {

                        if(response.status == 401){
        
                                console.log("Istekla sesija");
        
                                toast.error(response.data.message, toastError);
                                
                                dispatch(actions.logOut());
                                navigate('/');
        
                        } else{
        
                                //toast.error(response.data.message, toastError);
        
        
                        }
                        
      
      
      
                } else {                

                    
                        var dataTmp = response.data;



                        console.log(dataTmp.strukture)

                        if(dataTmp && dataTmp.strukture && dataTmp.strukture.length && dataTmp.strukture.length!=0){

                            setExistStrukt(dataTmp.strukture);

                            console.log("**************************************")
                            console.log("Mapiranje struktura");

                            let rowsTmp = [];
                            dataTmp.strukture.map((item)=>{

                                console.log("item");
                                console.log(item);

                                let fullAdress1 = item.ulica_naziv?item.ulica_naziv.trim():'';
                         
                                let fullAdress2 = fullAdress1.concat(' ', item.kbr?item.kbr:'');
                                let fullAdress = fullAdress2.concat(' ', item.alfa?item.alfa.trim():'');

                                let newDateUnos = new Date(item.datum_unosa)

                                let options = {              
                                        year: "numeric",
                                        month: "numeric",
                                        day: "numeric"
                                };

                                let formattedDateUnos = newDateUnos.toLocaleDateString("hr-HR", options);

                                let newDateAzur = new Date(item.datum_zadnjeg_azur)

                                let formattedDateAzur = newDateUnos.toLocaleDateString("hr-HR", options);

                                rowsTmp.push({
                                    "TKC": tmp,
                                    "Šifra":codeCompany,
                                    "Redos": item.redos,
                                    "Naziv": item.naziv,
                                    "Telefon": "0" + item.mreza + item.telefon,
                                    "Adresa": fullAdress,
                                    "Objava": item.objava,
                                    "Datum unosa": formattedDateUnos, 
                                    //"Datum ažuriranja": formattedDateAzur,
                                    "Komentar": item.komentar,
                                    //"Telefon": "0" + item.mreza + item.telefon,
                                    //"Naziv": item.naziv,
                                    //"Adresa": fullAdress,
                                    //"Objava": item.objava,
                                    //"Nivo": item.nivo,
                                    
                                    //"Redos": item.redos,
                                    
                                })

                            })

                            console.log(rowsTmp);
                            console.log("Sad je spremno");

                            let columnsChildren = Object.getOwnPropertyNames(rowsTmp[0]).map((column,index)=>{
                                       
                                        var a = column.charAt(0).toUpperCase() + column.slice(1);
                                    


                                        let widthC = 100;
                                        switch(column) {
                                            case "TKC":
                                                widthC=50;
                                                break;
                                            case "Šifra":
                                                widthC=75;
                                                break;

                                            case "Datum unosa":
                                                widthC = 100;
                                                break;
                                            case "Datum ažuriranja":
                                                widthC = 100;
                                                break;
                                            case "Komentar":
                                                widthC = 100;
                                                break;
                                            case "Telefon":
                                                widthC = 120;
                                                break;
                                            case "Naziv":
                                                widthC = 100;
                                                break;
                                            case "Adresa":
                                                widthC = 270;
                                                break;
                                            case "Objava":
                                                widthC = 90;
                                                break;                                                
                                            case "Nivo":
                                                widthC = 50;
                                                break;
                                            case "Redos":
                                                widthC = 75;
                                                break;                                                
                                            default:
                                                // code block
                                            } 
                                    


                                        
                                        return(
                                            {
                                                "field": column,
                                                "getRowId": index,
                                                "width": widthC,
                                                "columnGroupShow": 'open'

                                            
                                            }
                                        )
                            })                           
                      

                            let columns = [
                                {
                                    headerName: codeCompany + " - " + mjNaziv + " - " + compNaziv + "    ----    " + "Komentar: " + koment,
                                    children: columnsChildren
                                },
                            ];

                                                                
                            let rows = rowsTmp.map((item, index)=> {
                                console.log("Trying to map rows");
                                console.log(item);
                                return(item);
                      
                            })

                                                        

                        
                            setExistStruktGrid({
                                    columns,
                                    rows
                            })

                        }

                        //setTableDataModal(response.data.strukture)


                }

        
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());


                        if(!error.response){

                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);
                        


                        } else {


                            if(!error.response.status){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);

                            }else{

                                if (error.response.status == 401) {
            
                        
                                    toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                
                            
                                } else {
                            
                            
                                            toast.error(error.response.data.message,
                                                toastError);
                                                                        
                                    
                                }
                            }
                        }
                    
                
            
            
            });

            
            
}  




const getDetailPanelContent = ({ row }) => (
    <Box sx={{ p: 2 }}>{`Order #${row.id}`}</Box>
  );
const getDetailPanelHeight = () => 50;



return (
    <ThemeProvider theme={theme}>

        <AutoModal tableName="val_dnevnik" tkID={ tkList.map(item=>item.toString())} tkName="Telemach"/>


            
{/*--------------------------------BIJELE STRANICE---------------------------------*/} 
            
        <Modal
            open={bijeleStraniceOpen}
            onClose={()=> {
                setBijeleStraniceOpen(false)
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
                    <BijeleStranice state={{ row: selectedCell?selectedCell:"", currentCodeBijele:currentCodeBijele,
                        currentTKCBijele:currentTKCBijele
                    }} bijeleStraniceIsOpen={bijeleStraniceOpen}/>
        </Modal>

            
{/*--------------------------------ŽUTE STRANICE-----------------------------------*/} 
        <Modal
            open={zuteStraniceOpen}
            onClose={()=> {
                setZuteStraniceOpen(false)
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
                    <ZuteStranice  state={{ row: selectedCell?selectedCell:""}} zuteStraniceIsOpen={zuteStraniceOpen} />
        </Modal>


{/*---------------------------------POŠILJKE--------------------------------------*/}
        <Modal
            open={openModalPosiljke}
            onClose={()=> {
                setOpenModalPosiljke(false)
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box className="DPDonat-modal-container"  ref={popupRefFiles}      style={{resize: "both", transform: `translate(${modalPositionFiles.x}px, ${modalPositionFiles.y}px)` }}> 

            <Box className = "DPDonat-modal-header" onClick={(e) => e.stopPropagation()}      onMouseDown={(e)=> onMouseDown(e)}>
                    
                    <Typography className="DPDonat-header-title-text" variant="h6">
                        Dolazne datoteke
                    </Typography>  



            </Box>
            <TableContainer  sx={{ maxHeight: 350 }} component={Paper}>
                        <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                            <TableHead>
                                <TableRow >
                                    
                                    {/*<TableCell sx={{fontWeight:600}}>Rbr</TableCell>*/}
                                    <TableCell sx={{fontWeight:600}} align="right">Ime pošiljke</TableCell>
                                    <TableCell sx={{fontWeight:600}} align="right">Datum</TableCell>
                                    <TableCell sx={{fontWeight:600}} align="right">Stanje</TableCell>
                                    <TableCell sx={{fontWeight:600}} align="right">Stavki</TableCell>
                                    <TableCell sx={{fontWeight:600}} align="right">Uključenja</TableCell>
                                    <TableCell sx={{fontWeight:600}} align="right">Isključenja</TableCell>
                                    <TableCell sx={{fontWeight:600}} align="right">Promjena</TableCell>
                                    <TableCell sx={{fontWeight:600}} align="right">Prihvat Val</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                            {tableDataModalPosiljke.map((row) => (
                                
                                <TableRow
                                key={row.rbr}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                
                                >
                                    {/*<TableCell component="th" scope="row">
                                        {row.rbr}
                                    </TableCell>*/}
                                    <TableCell align="right">{row.file}</TableCell>
                                    <TableCell align="right">{row.date_start}</TableCell>
                                    <TableCell align="right">{row.imp_percentage}</TableCell>
                                    <TableCell align="right">{row.nr_proc}</TableCell>
                                    <TableCell align="right">{row.inserts}</TableCell>
                                    <TableCell align="right">{row.deletes}</TableCell>
                                    <TableCell align="right">{row.updates}</TableCell>
                                    <TableCell align="right">{row.date_end}</TableCell>

                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
            </TableContainer>

            <div className='DPDonat-modal-bottom'
        
                onMouseDown={(e)=>onMouseDown(e)}>

            </div>
            </Box>
        </Modal>


{/*---------------------------------ODABRANI TEL U BIJELIM STR--------------------*/}

<       Modal
        open={pojavljivanjeBijeleIsOpen}
        onClose={()=> {
            setPojavljivanjeBijeleIsOpen(false)

            setPojavljivanjeBijeleIsOpen(false)
            setCurrentCodeBijele('');
            setCurrentTKCBijele('');
            setVratiObjavu('')
        }}

        >
            <Box className="DPDonat-modal-container"  ref={popupRefPojavljivanjeBijele}      style={{resize: "both", transform: `translate(${modalPositionaPojavljivanjeBijele.x}px, ${modalPositionaPojavljivanjeBijele.y}px)` }}> 

                <Box className = "DPDonat-modal-header" onClick={(e) => e.stopPropagation()}      onMouseDown={(e)=> onMouseDown(e)}>
                    
                    <Typography className="DPDonat-header-title-text" variant="h6">
                        Pojavljivanje odabranog telefona u bijelim i žutim stranicama
                    </Typography>  

                    {selectedCell && <Typography sx={{margin:'10px'}}> {selectedCell['Novi naziv']} -- {selectedCell.OIB_n?selectedCell.OIB_n:'-'} -- {selectedCell.Mjesto}, {selectedCell.Adresa}  -- {selectedCell["Novi Telefon"]}</Typography>}



                </Box>

                <Box className="BijeleStranice-modal-data-display">

                        {bijeleZuteData && bijeleZuteData.rows &&  <div style={{ width: "100%", height: "100%" }}> <AgGridReact
                                rowData={bijeleZuteData.rows}
                                columnDefs={bijeleZuteData.columns}

                        

                               
                                ref={gridRefBijele}
                                theme={themeAGBijele}
                              
                                autoSizeStrategy={autoSizeStrategyBijele}
                                onGridReady={onGridReadyBijele}
                                onColumnResized={onColumnResizedBijele}

                                //onRowDoubleClicked={onRowDoubleClicked}

                                //rowSelection={rowSelection}
                         
                                onRowSelected={onRowSelectedBijele}
                                onSelectionChanged={onSelectionChangedBijele}

                                rowSelection="multiple"

                   
                                onRowClicked={cellClickedBijele}


                /></div> } 

                {/*<Box sx={{ display:"flex", flexDirection: "column", alignItems: "center", justifyContent:"center", gap:"20px", width:"100%" }}>
                    
                        {bijeleZuteData.rows && <DataGrid
                            columnBufferPx={10}
                            rows={bijeleZuteData.rows}
                            columns={bijeleZuteData.columns}
                            sx={{ overflowX: 'scroll', width:"100%",     
                                '&.MuiDataGrid-footerContainer': {
                                    color:"blue",
                                minHeight: '40px',
                            },}}
                            onCellClick={(rowChosen)=>{
                                    
                                console.log("Selected: ");
                                console.log(rowChosen.row);
                                setVratiObjavu(rowChosen.row)
                               

                                console.log("Sifra; ");
                                console.log(rowChosen.row.sifra);
                                setCurrentCodeBijele(rowChosen.row.sifra);
                                setCurrentTKCBijele(rowChosen.row.tkcID);


                            }}

                        />} */}
                </Box>


                
                <Box sx={{ display:"flex", flexDirection: "row", alignItems: "center", justifyContent:"center", gap:"20px", margin: '10px'}}>

                        <Button sx={{height:"30px", fontSize:"10px"}} variant="contained" 
                                
                                onClick={()=>{
                                    console.log("Sending company code:");
                                    console.log(currentCodeBijele);

                                    if(bijeleZuteData.rows.length==1){

                                        console.log("Selected only one row!!!: ");
                                        console.log(bijeleZuteData.rows[0]);
                                        setVratiObjavu(bijeleZuteData.rows[0])
                                       
        
                                        console.log("Sifra; ");
                                        console.log(bijeleZuteData.rows[0].sifra);
                                        setCurrentCodeBijele(bijeleZuteData.rows[0].sifra);
                                        setCurrentTKCBijele(bijeleZuteData.rows[0].tkcID);

                                    }

                                    setBijeleStraniceOpen(true);
                                    //window.open("/BijeleStranice?companyCode=" + currentCodeBijele + "&tkc=" + currentTKCBijele, "_blank"); 

                                 }}>
                                Bijele stranice
                        </Button>  
                        <Button sx={{height:"30px", fontSize:"10px"}} variant="contained" 
                        
                            onClick={()=>{console.log("Vracam!"); 
                                
                                if(!vratiObjavu || !vratiObjavu.sifra || vratiObjavu.sifra==''){
                                    toast.error("Morate odabrati redak koji želite vratiti u objavu", toastError);
                                } else {
                                    console.log(vratiObjavu);
                                    console.log(vratiObjavu.sifra);
                                    vratiBijeleZute(telefon, vratiObjavu.sifra, vratiObjavu.tkcID);
                                }
                        }}>
                            Vrati telefon u objavu
                        </Button>  
                    
                </Box>

                <div className='DPDonat-modal-bottom'
        
                    onMouseDown={(e)=>onMouseDown(e)}>

                </div>

            </Box>
        </Modal>


{/*---------------------------------AUTOMATSKI U BIJELE STR-----------------------*/}

            <Modal
                                    
                open={automaticBijeleOpen}
                onClose={()=> {
                    setSimilarCompanyData([],[])
                    setTxtSearchAutoBijele('')
                    setModalRowToBeShown('');
                    setAutomaticBijeleOpen(false)
                }}

                >
                            <Box className="DPDonat-modal-container"  ref={popupRefAutomaticBijele}      style={{resize: "both", transform: `translate(${modalPositionaAutomaticBijele.x}px, ${modalPositionaAutomaticBijele.y}px)` }}> 
                                <Box className = "DPDonat-modal-header" onClick={(e) => e.stopPropagation()}      onMouseDown={(e)=> onMouseDown(e)}>
                                
                                        <Typography className="DPDonat-header-title-text" variant="h6" >
                                            Automatski u Bijele stranice
                                        </Typography>  
                                    
                                    



                                </Box>

                                <Box sx={{width:"100%", margin: "10px 0 10px 0", height:'150px', backgroundColor:'white'}}>
                                        {selectedItemsGrid && selectedItemsGrid.rows &&  <div style={{ width: "100%", height: "100%" }}> 
                                            <AgGridReact
                                            rowData={selectedItemsGrid.rows}
                                            //columnDefs={selectedItemsGrid.columns}
                                            columnDefs={columnDefsAutoBijele}

                                        
                                            ref={gridRefAutoBijele}
                                            theme={themeAGAutoBijele}
                                        
                                            autoSizeStrategy={autoSizeStrategyAutoBijele}
                                            onGridReady={onGridReadyAutoBijele}
                                            onColumnResized={onColumnResizedAutoBijele}

                                    

                                         /></div> }                                      
                                
                                {/*<Box sx={{width:"100%"}}>

                                        <DataGrid
                                    
                                                columnBufferPx={10}
                                                
                                                rows={selectedItemsGrid.rows}
                                        
                                                visibleFields={VISIBLE_FIELDS}
                                                
                                                columns={selectedItemsGrid.columns}

                                                

                                                initialState={{
                                                    pagination: {
                                                    paginationModel: { page: 10, pageSize: 15 },
                                                    },
                                                    columns: {
                                                        columnVisibilityModel: {
                                                            Ref: false,
                                                            Datum: false,
                                                            Operater: false,
                                                            "Vrsta rada": false,
                                                            "Stanje": false,
                                                            Gotovo: false,
                                                            Komentar: false,
                                                            Priklj: false,
                                                            Tajni: false,
                                                            "Tajni_staro": false,
                                                            Objava: false,
                                                            Tip2: false,
                                                            Tip1: false,
                                                            Tip3: false,
                                                            Tip2_n: false,
                                                            Tip1_n: false,
                                                            Tip3_n: false,
                                                            "Novi Telefon": false,
                                                            "T_mob_tip": false,
                                                            TKC: false,
                                                            sekvenca: false,
                                                            "ID operatera": false,
                                                            OIB: false,
                                                            Filter: false,
                                                            name: false,
                                                            surname: false,name_s: false,
                                                            surname_s: false,
                                                            id: false,
                                                            PTT:false,
                                                            PTT_n:false,
                                                            rbr: false,
                                                            MJESTO: false,
                                                            Adresa_s: false,
                                                            Mjesto_s: false


                                                        },
                                                        },
                                                }}

                                                slots={{
                                                    footer: "no",
                                                    }}
                                        
                                
                                        
                                        /> */}
                                </Box>
                                <Box sx={{width:"100%", display:"flex", alignItems: "center", justifyContent:"space-between", padding: '20px 0 20px 0', flexDirection:'column'}}>
                                    <Grid container spacing={2} sx={{width:"100%", display:"flex", flexDirection:'row', alignItems: "center", justifyContent:"space-between", padding:'0 0 30px 0', }}>


                                        <Grid container item xs={6} sx={{display:"flex", flexDirection:'row', alignItems: "center", justifyContent:"flex-start", padding:'10px', }}>
                                            <Grid item xs={6}>
                                                <MyTextField
                                                        InputProps={{sx:{height:30, backgroundColor:'white', color: 'black', fontWeight:400,
                                                            
                                                            
                                                        }}}

                                                        InputLabelProps={{
                                                                sx: {
                                                                    
                                                                    fontSize: "14px", shrink: true,
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "14px" }
                                                            }
                                                        }}                    
                                                   
                                                   
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="Dodatni tekst za pretragu"
                                                    //disabled
                                                    variant="outlined"

                                                    value={txtSearchAutoBijele}
                                                    onChange={(event) => {
                                                        console.log("Written txt:");
                                                        console.log(event.target.value);
                                                        setTxtSearchAutoBijele(event.target.value?event.target.value.toUpperCase():'');
                                                    }}
                                                    
                                                    
                                            />
                                    
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Link sx={{marginLeft:'10px'}}>
                                                        <Button sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="success"  onClick={()=> getSimilarCompany()}>Potraži tvrtku</Button>
                                                </Link>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Link >
                                                    <Button sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color='primary' onClick={()=> setBijeleCompany()}>Stvori tvrtku</Button>
                                            </Link>
                                        </Grid>

                                    </Grid>

                                    <Box className="BijeleStranice-similar-tvrkte"  sx={{width:"95%"}}>

                                        
                                        <TableContainer  sx={{ maxHeight: 550, width:'100%' }} >
                                            <Table stickyHeader aria-label="sticky table" sx={{ width:'100%' }} >
                                                <TableHead>
                                                    <TableRow colSpan={16}  sx={{width:'100%'}}>
                                                    
                                                    

                                                
                                                    

                                                        {similarCompanyData.rows && similarCompanyData.columns.map((column) =>{
                                                          
                                                            return (
                                                                 <TableCell sx={{fontWeight:400, backgroundColor:'lightblue'}} align="right">{column.field}</TableCell>
                                                            )
                                                        })}

                        
                            


                                                    </TableRow>
                                                </TableHead>
                                                <TableBody colSpan={16}  sx={{width:'100%', }} >


                                                    
                                                    

                                                
                                               

                                                    {similarCompanyData.rows && similarCompanyData.rows.map((row) =>{
                                                        
                                                        return (<>
                                                             <TableRow onClick={()=>{
                                                                console.log(row)
                                                                setModalRowToBeShown(modalRowToBeShown=='rbr'+row.rbr ? "" :'rbr'+row.rbr)
                                                                console.log("getting strukture!!!");
                                                                console.log(row);
                                                                let tmpTKC = '';
                                                                if(selectedNetwork && selectedNetwork.tkc && selectedNetwork.tkc!=''){
                                                                    tmpTKC = selectedNetwork.tkc;
                                                                }
                                                             
                                                            
                                                                if(selectedItems && selectedItems.length && selectedItems.length > 0){
                                                                    tmpTKC = selectedItems[0].TKC;
                                                                } else {
                                                                    tmpTKC = selectedCell.TKC;
                                                                }

                                                               
                                                                //getBijeleStruktureDnevne(row.sifra, tmpTKC, row.naziv, row.NAZIV);
                                                                getBijeleStruktureDnevne(row.SIFRA, tmpTKC, row.NAZIV, row.MJESTO, row.komentar?row.komentar:'');
                                                                
                                                             }} >
                                                                {
                                                                    
                                                                Object.keys(row).map((element,key) =>{

                                                                    if(element=='id'){
                                                                        
                                                                    } else {

                                                                    return (
                                                                    <>
                                                                            <TableCell  sx={{}} align="right">{row[element]}</TableCell>
                                                                            
                                                                            

                                                                    </>
                                                                    
                                                                    
                                                                    )
                                                                    }
                                                                })
                                                                }
                                                                </TableRow>
                                                              
                                                                <TableRow    sx={{width:'100%', display:modalRowToBeShown==='rbr'+row.rbr ? "table-row" : "none" }} align="right">
                                                                    <TableCell colSpan={7} align="center" style={{padding:0}}>
                                                                        <Box sx={{width:"100%", margin: "10px 0 10px 0", height:'250px', backgroundColor:'white'}}>
                                                                                {existStruktGrid && existStruktGrid.rows &&  <div style={{ width: "100%", height: "100%" }}> 
                                                                                    <AgGridReact
                                                                                    rowData={existStruktGrid.rows}
                                                                                    columnDefs={existStruktGrid.columns}
                                                                                    

                                                                                
                                                                                    ref={gridRefSimilar}
                                                                                    theme={themeAGSimilar}
                                                                                
                                                                                    autoSizeStrategy={autoSizeStrategySimilar}
                                                                                    onGridReady={onGridReadySimilar}
                                                                                    onColumnResized={onColumnResizedSimilar}

                                                                            

                                                                                /></div> } 
                                                                
                                                                        </Box>
                                                                    </TableCell>
                                                                    <TableCell sx={{border:'none'}} colSpan={1} align="center">
                                                                            <Button  sx={{height:"32px", fontSize:"9px", border:'none'}} variant="contained" color="primary" 
                                                                                            onClick={() => {
                                                                                                
                                                                                                //setBijeleStrukture(row.sifra, row.naziv, row.NAZIV);

                                                                                                //setBijeleStrukture(row.SIFRA, row.NAZIV, row.MJESTO);
                                                                                                setBijeleStrukture(row.SIFRA, row.NAZIV, row.MJESTO, row.OIB, row.MJESTO_ID);

                                                                                                setSimilarCompanyData([],[])
                                                                                                setTxtSearchAutoBijele('')
                                                                                                setModalRowToBeShown('');
                                                                                                setAutomaticBijeleOpen(false)

                                                                                            }}
                                                                                    
                                                                                            >
                                                                                        Pridijeli tvrtci
                                                                            </Button>


                                                                    </TableCell>

                                                                </TableRow>
                                                          
                                                        </>
                                                        ) 
                                                        
                                                        
                                                       

                                                        
                                                     })}

                                                   

                     
                         




                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                  

                                        
                                        

                                    </Box>
                                
                                </Box>

                                <div className='DPDonat-modal-bottom'
        
                                    onMouseDown={(e)=>onMouseDown(e)}>

                                </div>
                        
                            </Box>



        </Modal>


{/**************************************************************************************************************** */}




        <div className="DPDonat-main-container">
        <div className={`DPDonat-header ${isMenuOpen ? "is-extended": ""}`}            
                onMouseEnter={()=> dispatch(actions.openMenu())}
                onMouseLeave={()=> dispatch(actions.closeMenu())}
            >

                <div className="DPDonat-header-changes-title">

                    <Typography className="DPDonat-header-changes-title-text" variant="h5">
                        Val - Obrada dnevnih promjena Telemach
                    </Typography>
                    <Fab variant="extended" color="secondary"
                           onClick={() => {
                                          
                                dispatch(actions.openAutoModal())

                                console.log("Attempting auto!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");


                            }}
                    >
        
                            AUTO
                    </Fab>


                </div>

            </div>
            <div className="DPDonat-body">
                <div className="DPDonat-data-display">


                {archiveView && <Grid container spacing={2}>


                        
                        <Grid item xs={1}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="primary"
                                        onClick={() => {
                                           
                                            setChangeVisible(false);

                                            otvoriArhivu();


                                        }}
                                 
                                        >
                                        Nova pretraga
                                    </Button>
                        </Grid>
                        


                        <Grid item xs={1}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="error" 
                                     disabled={!archiveView}
                                        onClick={() => {

                                            setChangeVisible(false);
                                        
                                            setData([]);
                                            setFilteredTableData([],[]);
                                
                                            
                                            setDoubleClickedRow(null)
                                            setSelectedCell(null)
        
            
                                            setTelefon('');
                                            setTelefon2('');
                                            setOperator('');
                                       
            
                                            setNaziv1('')
                                           
                                            setNaziv12('');
                                            
                                            setOIB('');
                                            setOIB2('');
            
            
                                            setDiffNaziv(false);
                                            
                                            setDiffOIB(false);
                                            setDiffTel(false);
                                           
            
            
                                            setIsObjava(false);
            
                                           
            
                                            setMjesto('')
                                            setMjesto2('')
            
                                            setPtt('');
                                            setPtt2('');
            
                                            
                                            setUlica('');
                                            setUlica2('');
            
                                            setDiffPTT(false);
                                            setDiffMjesto(false);
                                            setDiffUlica(false);
                                            setDiffName(false);
                                            setDiffSurname(false);
                                            
                                            
            
            
                                            
                                            setTip('');
                                            setTip12('');
                                            setTip2('');
                                            setTip22('');
                                            setTip3('');
                                            setTip32('');
            
                                            setKomentar('');
            
            
                                            setDiffTIP1(false);
                                         
            
                                            setDiffTIP2(false);
                                          
                                            setDiffTIP3(false);
                                            
            
            
                                            setDatumVal('');
            
            
                                            setName('');
                                            setSurname('');
                                            setName2('');
                                            setSurname2('')
            
                                            setStatusObrade('');
            
                                            setSkloniti('');
            
                                            setObrnuto('  ');
                                            setObrnuto2('  ');
        
                                            setTkOperatorRow('');
                                            setAkcijaRow('');
        
                                            setActiveTKCRow('');
                                            setTkOperatorRowID('');
        
                                            setRucnoKBR('');
                                            setRucnoKBRDodatak('');
                                            setRucnoMjesto('');
                                            setRucnoUlica('');
                                            setRucnoNaziv1('');
                                            setRucnoNaziv2('');
                                            setSelectedRucnoTip(3);
                                            setRucneKorekcije(false);
                                            setSelectedUlica({'ULICA_ID':'', 'NAZIV':''});
                                            setSelectedMjesto({'MJESTO_ID':'', 'NAZIV':''});

                                            setBureInfo('');
                                            
                                            setFilters([false, false, false, false, false, false, false, false, false]);

                                            setCheck0(false);
                                            setCheck1(false);
                                            setCheck2(false);
                                            setCheck3(false);
                                            setCheck4(false);
                                            setCheck5(false);
                                            setCheck6(false);
                                            setCheck7(false);
                                            setCheck8(false);

                                            setSelectedOwner(0);

                                            setArchiveView(false);
                                            


                                        }}
                                 
                                        >
                                        Kraj
                                    </Button>
                        </Grid>
                        <Grid item xs={1}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained"  
                                     disabled={!archiveView}
                                        onClick={() => {

                                            if(telefon2 && telefon2!='' && cnt && cnt!=''){

                                                console.log("Selected cell: ")
                                                console.log(selectedCell);
                                                console.log(selectedCell["ID operatera"]);
                                                console.log(selectedCell.Datum);
                                                vratiArhiva(telefon2, cnt, selectedCell.Datum, selectedCell["ID operatera"]);

                                            } else {

                                                toast.error("Morate odabrati zapis koji želite vratiti iz arhive", toastError);
                                            }

                                            


                                        }}
                                 
                                        >
                                        Vrati broj
                                    </Button>

                                    
                        </Grid>   
                        <Grid item xs={2}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained"  
                                     disabled={!archiveView} color="success"
                                        onClick={() => {

                                            if(telefon2 && telefon2!='' && cnt && cnt!=''){

                                                console.log("Selected cell: ")
                                                console.log(selectedCell);
                                                console.log(selectedCell["ID operatera"]);
                                                console.log(selectedCell.Datum);
                                                vratiArhivaIzvor(telefon2, cnt, selectedCell.Datum, selectedCell["ID operatera"]);

                                            } else {

                                                toast.error("Morate odabrati zapis koji želite vratiti iz arhive", toastError);
                                            }

                                            


                                        }}
                                 
                                        >
                                        Vrati s izvornim datumom
                                    </Button>

                                    
                        </Grid>                           
                </Grid>}

                {!archiveView && <Grid container spacing={2}>


                        <Grid item xs={1}>
                                     <Button sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="primary" 
                                        onClick={() => {
                                           setOpenModalPosiljke(!openModalPosiljke);
                                        }}
                                 
                                        >
                                    Datoteke
                                    </Button>
                        </Grid>

                        <Grid item xs={1}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="primary" disabled={!changeVisible}
                                        onClick={() => {
                                           setRasporedivanjeZadatakaIsShown(!rasporedivanjeZadatakaIsShown)
                                           //getDataChanges();
                                        }}
                                 
                                        >
                                     Rasporedi
                                    </Button>
                        </Grid>

                        <Grid item xs={1}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="primary" disabled={changeVisible}
                                        onClick={() => {
                                            getDataChanges();
                                            setChangeVisible(true);
                                            setArchiveView(false);
                                            
                                        }}
                                 
                                        >
                                        Promjene
                                    </Button>
                        </Grid>

                        
                        <Grid item xs={1}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}}variant="contained" color="success" disabled={!changeVisible}
                                        onClick={() => {
                                           
                                            //toast.info("Nema novih promjena koje se uklapaju u potrebne kriterije", toastInfo);

                                            knjiziRucno();
                                        }}
                                 
                                        >
                                        Knjiženje
                                    </Button>
                        </Grid>
                        
                        <Grid item xs={1.5}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="success" disabled={!changeVisible}
                                        onClick={() => {
                                           
                                                //skiniArhiva();
                                                //filterChosenLines();

                                                skiniOznacene();
                                        }}
                                 
                                        >
                                        Skinuti sa spiska
                                    </Button>
                        </Grid>
                        
                        <Grid item xs={1}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="primary"
                                        onClick={() => {
                                           
                                            setChangeVisible(false);

                                            otvoriArhivu();


                                        }}
                                 
                                        >
                                        Arhiva
                                    </Button>
                        </Grid>


                        <Grid item xs={1}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="error" disabled={!(changeVisible)}
                                        onClick={() => {

                                            setChangeVisible(false);
                                        
                                            setData([]);
                                            setFilteredTableData([],[]);
                                
                                            
                                            setDoubleClickedRow(null)
                                            setSelectedCell(null)
        
            
                                            setTelefon('');
                                            setTelefon2('');
                                            setOperator('');
                                       
            
                                            setNaziv1('')
                                           
                                            setNaziv12('');
                                            
                                            setOIB('');
                                            setOIB2('');
            
            
                                            setDiffNaziv(false);
                                            
                                            setDiffOIB(false);
                                            setDiffTel(false);
                                           
            
            
                                            setIsObjava(false);
            
                                           
            
                                            setMjesto('')
                                            setMjesto2('')
            
                                            setPtt('');
                                            setPtt2('');
            
                                            
                                            setUlica('');
                                            setUlica2('');
            
                                            setDiffPTT(false);
                                            setDiffMjesto(false);
                                            setDiffUlica(false);
                                            setDiffName(false);
                                            setDiffSurname(false);
                                            
                                            
            
            
                                            
                                            setTip('');
                                            setTip12('');
                                            setTip2('');
                                            setTip22('');
                                            setTip3('');
                                            setTip32('');
            
                                            setKomentar('');
            
            
                                            setDiffTIP1(false);
                                         
            
                                            setDiffTIP2(false);
                                          
                                            setDiffTIP3(false);
                                            
            
            
                                            setDatumVal('');
            
            
                                            setName('');
                                            setSurname('');
                                            setName2('');
                                            setSurname2('')
            
                                            setStatusObrade('');
            
                                            setSkloniti('');
            
                                            setObrnuto('  ');
                                            setObrnuto2('  ');
        
                                            setTkOperatorRow('');
                                            setAkcijaRow('');
        
                                            setActiveTKCRow('');
                                            setTkOperatorRowID('');
        
                                            setRucnoKBR('');
                                            setRucnoKBRDodatak('');
                                            setRucnoMjesto('');
                                            setRucnoUlica('');
                                            setRucnoNaziv1('');
                                            setRucnoNaziv2('');
                                            setSelectedRucnoTip(3);
                                            setRucneKorekcije(false);
                                            setSelectedUlica({'ULICA_ID':'', 'NAZIV':''});
                                            setSelectedMjesto({'MJESTO_ID':'', 'NAZIV':''});


                                            setBureInfo('');
                                            
                                            setFilters([false, false, false, false, false, false, false, false, false]);

                                            setCheck0(false);
                                            setCheck1(false);
                                            setCheck2(false);
                                            setCheck3(false);
                                            setCheck4(false);
                                            setCheck5(false);
                                            setCheck6(false);
                                            setCheck7(false);
                                            setCheck8(false);

                                            setErrorUlica(false);

                                            setNewMjesto('');
                                            setNewUlica('');
                                            setOldMjesto('');
                                            setOldUlica('');
                                       



                                        }}
                                 
                                        >
                                        Kraj
                                    </Button>
                        </Grid>

                        <Grid item xs={1}>
                            <FormControl fullWidth
                                    //variant="standard" 
                                    sx={{ m: 1, width:'100%', margin:0}}
                                    size="small"
                                    variant="outlined"
                                    >
                                <InputLabel sx={{fontSize: 12}}>Mreža</InputLabel>
                                <Select 
                                    sx={{height:32}}
                                    value={selectedNetwork?.pozivni || ""} onChange={handleChange}>
                                {listOfPozivni.map((obj) => (
                                    <MenuItem key={obj.tkc} value={obj.pozivni}>
                                    {obj.pozivni}
                                    </MenuItem>
                                ))}
                                <MenuItem value={''} name={''} >Svi</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>  
                        <Grid item xs={2}>
                        <Button sx={{height:"32px", fontSize:"9px", width:'100%', backgroundColor:'lightyellow', color:'black'}} variant="contained" disabled={!changeVisible}
                                        onClick={() => {



                                            const listOfSortModel = gridRef.current.api.getColumnState().filter(s => s.sort !== null);

                                            console.log("list sort models");
                                            console.log(listOfSortModel);


                                            if (listOfSortModel.some(e => (e.colId === 'Naziv' || e.colId === 'Novi naziv'))) {
                                                
                                                    console.log("woooohooooooooo sortirano!");


                                                    if(selectedItems.length == 0){

                                                                //let columns = filteredTableData.columns; 



                                                                console.log(filteredTableData.columns);
                                                                
                                                                console.log("Need to set the data!!!");

                                                                let columns= filteredTableData.columns.map((column,index)=>{
                                                                    //var a = column.charAt(0).toUpperCase() + column.slice(1);

                                                                
                                                                
                                                                    let widthC = 100;
                                                                    switch(column.field) {
                                                                        case "Telefon":
                                                                            widthC = 150;
                                                                            break;
                                                                        case "Naziv":
                                                                            widthC = 250;
                                                                            break;
                                                                        case "Adresa":
                                                                            widthC = 250;
                                                                            break;
                                                                        case "Mjesto":
                                                                            widthC = 150;
                                                                            break;
                                                                        case "Novi naziv":
                                                                            widthC = 250;
                                                                            break;
                                                                        default:
                                                                            // code block
                                                                        } 
                                                                    
                                                                    return(
                                                                        {
                                                                            "field": column.field,
                                                                            "getRowId": column.getRowId,
                                                                            "width": widthC
                            
                                                                        
                                                                        }
                                                                    )
                                                                })



                                                                console.log(columns);     

                                                                
                                                                console.log(selectedCell);
                                                            

                                                                if(!selectedCell){

                                                                        toast.error("Morate odabrati jedan ili više podataka za ubacivanje u bijele stranice", toastError);
                                                                } else {

                                                                        if(selectedCell.Stanje != 2){
                                                                                
                                                                            toast.error("Svi odabrani podaci moraju biti u stanju 2, molimo provjerite odabrane podatke", toastError);


                                                                        } else {

                                                                                let tmpRow = [];
                                                                                tmpRow.push(selectedCell);
                        
                                                                                let rows = tmpRow;
                                        
                                                                                setSelectedItemsGrid({
                                                                                        columns,
                                                                                        rows
                                                                                })
                
                                                                                setAutomaticBijeleOpen(true);

                                                                        }


                                                                }


                                                    } else {

                                                                console.log(selectedItems);
                                                                console.log("aaaaa")

                        
                                                                let columns= Object.getOwnPropertyNames(selectedItems[0]).map((column,index)=>{
                                                                    var a = column.charAt(0).toUpperCase() + column.slice(1);
                                                                
                                                                    let widthC = 100;
                                                                    switch(column) {
                                                                        case "Telefon":
                                                                            widthC = 100;
                                                                            break;
                                                                        case "Naziv":
                                                                            widthC = 300;
                                                                            break;
                                                                        case "Adresa":
                                                                            widthC = 250;
                                                                            break;
                                                                        case "Mjesto":
                                                                            widthC = 150;
                                                                            break;
                                                                        case "Novi naziv":
                                                                            widthC = 300;
                                                                            break;
                                                                        default:
                                                                            // code block
                                                                        } 
                                                                
                            

                                                                    
                                                                    return(
                                                                        {
                                                                            "field": column,
                                                                            "getRowId": index,
                                                                            "width": widthC
                            
                                                                        
                                                                        }
                                                                    )
                                                                })
                                                        
                                                            
                        
                                                            
                        
                                                                
                                                                let rows =selectedItems.map((item, index)=> {
                                                                    console.log("Trying to map rows");
                                                                    console.log(item);
                                                                    return(item);
                                                                    //return ({...item[0], index})
                                                                    //return({...item,id:index})
                                                                })

                                                        

                        
                                                                setSelectedItemsGrid({
                                                                        columns,
                                                                        rows
                                                                })

                                                                const allEqualState = arr => arr.every(val =>{
                                                                    console.log("Curr state");
                                                                    console.log(val);
                                                                    console.log(val.Stanje);
                                                                    console.log(arr[0].Stanje);
                                                                    return (val.Stanje == arr[0].Stanje && val.Stanje==2)
                                                                });

                                                                console.log("stanje");
                                                                console.log(allEqualState(rows));

                                                                const allEqual = arr => arr.every(val => { 

                                                                    //return val.Naziv === arr[0].Naziv

                                                                    return val.Naziv.localeCompare(arr[0].Naziv) == 0;
                                                                
                                                                });

                                                                const allEqualMjesto = arr => arr.every(val => {

                                                                    //return val.Mjesto === arr[0].Mjesto
                                                                    return val.Mjesto.localeCompare(arr[0].Mjesto)  == 0;
                                                                     
                                                                    });


                                                                if(allEqualState(rows)){
                                                                        if(allEqual(rows) && allEqualMjesto(rows)){

                                                                                setAutomaticBijeleOpen(true);

                                                                        } else {

                                                                                toast.error("Neki od odabranih podataka se razlikuju po mjestu ili nazivu, molimo provjerite odabir", toastError);
                                                                        }
                                                                } else {

                                                                        toast.error("Svi odabrani podaci moraju biti u stanju 2, molimo provjerite odabrane podatke", toastError);
                                                                }
        

                                                    }

                                            } else {
                                                    toast.error(`Prije automatskog dodavanja u bijele stranice morate sortirati podatke po nazivu. 
                                                        To možete učiniti klikom na polje "Naziv" ili "Novi naziv" pri čemu će se pojaviti strelica sortiranja`, toastError);
                                            }
                                            
                                        }}
                                 
                                        >
                                        Automatski u Bijele stranice
                                    </Button>
                        </Grid>
                        <Grid item xs={1}>
                        <Button sx={{height:"32px", fontSize:"9px", width:'100%'}} variant="contained" color="info" disabled={!changeVisible}
                                        onClick={() => {
                                            if(sortType==0){
                                                    console.log("Sorting it out!");
                                                    gridRef.current.api.applyColumnState({
                                                        state: [
                                                        { colId: "Vrsta rada", sort: "asc", sortIndex: 0 },
                                                        { colId: "Naziv", sort: "asc", sortIndex: 1 },
                                                        ],
                                                        defaultState: { sort: null },
                                                    });
                                                    setSortType(1);
                                            } else {
                                                    console.log("Sorting it out desc!");
                                                    gridRef.current.api.applyColumnState({
                                                        state: [
                                                        { colId: "Vrsta rada", sort: "desc", sortIndex: 0 },
                                                        { colId: "Naziv", sort: "asc", sortIndex: 1 },
                                                        ],
                                                        defaultState: { sort: null },
                                                    });

                                                    setSortType(0);
                                                
                                            }
                                            
                                        }}
                                 
                                        >
                                        Sort AKC/NAZ
                                    </Button>
                        </Grid>                          
                    </Grid>}
                   

                    <div className="DPDonat-data-display-table" style={{backgroundColor: togglingValue==1 ? "#eeeeee7a" : "white", display:(changeVisible||archiveView)? "flex":"none" }}>

   
                        {(changeVisible) &&   filteredTableData.rows &&  <div style={{ width: "100%", height: "100%" }}> <AgGridReact
                                rowData={filteredTableData.rows}
                                columnDefs={filteredTableData.columns}

                        

                               
                                ref={gridRef}
                                theme={themeAG}

                                onSortChanged={onSortChanged}

                                getRowStyle={getRowStyle}
                              
                                autoSizeStrategy={autoSizeStrategy}
                                onGridReady={onGridReady}
                                onColumnResized={onColumnResized}

                                //onRowDoubleClicked={onRowDoubleClicked}

                                //rowSelection={rowSelection}
                         
                                onRowSelected={onRowSelected}
                                onSelectionChanged={onSelectionChanged}

                                onCellKeyDown={onCellKeyDown}

                                suppressScrollOnNewData={true}

                                

                                selectAll={selectAll}


                                rowSelection="multiple"
                   
                                onRowClicked={debounceClick}


      /></div> } 
                        {(archiveView) &&   filteredTableData.rows &&  <div style={{ width: "100%", height: "100%" }}> <AgGridReact
                                rowData={filteredTableData.rows}
                                columnDefs={filteredTableData.columns}

                                onSortChanged={onSortChanged}

                                getRowStyle={getRowStyleArchive}

                             

                        

                               
                                ref={gridRef}
                                theme={themeAG}
                              
                                autoSizeStrategy={autoSizeStrategy}
                                onGridReady={onGridReady}
                                onColumnResized={onColumnResized}

                                //onRowDoubleClicked={onRowDoubleClicked}

                                //rowSelection={rowSelection}
                         
                                onRowSelected={onRowSelected}
                                onSelectionChanged={onSelectionChanged}

                                

                                selectAll={selectAll}

                                onCellKeyDown={onCellKeyDown}

                                suppressScrollOnNewData={true}

                                //navigateToNextCell={arrowKeysNavigation(gridRef)}


                                rowSelection="multiple"
                   
                                onRowClicked={debounceClick}


      /></div> } 
    
                    </div>



                </div>


                <div className="DPDonat-form">

                    <div className="DPDonat-napone-box-komentar"  >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                            size="small"
                                            fullWidth
                                            id=""
                                            label="Telefoni ('bure')"
                                            variant="outlined"
                                            value={bureInfo}
                                            disabled
                                            
                                            onChange={(event) => {
                                                
                                            }}
                                        />

                    </div>

                    <div className="DPDonat-form-first-part">



                        <div className="DPDonat-form-first-part-left">
                            <Grid sx={{padding:'0', margin: '0 3px'}} container spacing={0.8} columns={{xs:12}}>
                                {/*first row*/}
                                {/*xs <600px   600px<sm<1000px 1000px<lg<1200px xl>1200px*/}
                                <Grid xs={3} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        
                                        fullWidth
                                        id=""
                                        label="Tel"
                                        variant="outlined"
                                        disabled
                                        value={telefon}
                                        onChange={(event) => {
                                            console.log("Written phone:");
                                            console.log(event.target.value);
                                            setTelefon(event.target.value);
                                        }}
                                    />

                                </Grid>
                                <Grid xs={3}  >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label=""
                                        disabled
                                        variant="outlined"
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>
                                <Grid xs={3} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="OIB"
                                        variant="outlined"
                                        disabled
                                        value={OIB}
                                        
                                        onChange={(event) => {
                                            setOIB(event.target.value);
                                        }}
                                    />
                                </Grid>
                                <Grid xs={2}  >
                                <FormGroup>
                                 <FormControlLabel sx={{height:"30px", fontSize:12}} control={<Checkbox size="small" defaultChecked disabled="true" checked={isObjava}/>} label="Objava" />
                                </FormGroup>
                                {/*<Checkbox
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Objava"
                                        variant="outlined"
                                        checked={isObjava}
                                        disabled="true"
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />*/}
                                </Grid>                   
                                <Grid xs={1}  >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Obrnuto pretraživanje"
                                        disabled
                                        variant="outlined"
                                        value={obrnuto}
                                        onChange={(event) => {
                                            setObrnuto(event.target.value);
                                        }}
                                    />
                                </Grid>     
                                <Divider />


{/************************************************************************************************* */}

                                {/*first row*/}
                                {/*xs <600px   600px<sm<1000px 1000px<lg<1200px xl>1200px*/}
                                {(diffTel || diffOIB) && <Grid xs={3} >

                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:(diffTel?'yellow':'orange'), color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}                                      
                                
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Tel"
                                        variant="outlined"
                                        disabled
                                        value={telefon2}
                                        onChange={(event) => {
                                            setTelefon2(event.target.value)
                                        }}
                                    />

                                </Grid>}
                                {(diffTel || diffOIB) && <Grid xs={3}  >
                                    {/*<TextField
                                        size="small"
                                        fullWidth
                                        id=""
                                        label=""
                                        variant="outlined"
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />*/}
                                </Grid>}
                                {(diffTel || diffOIB) && <Grid xs={3} >

                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:(diffOIB?'yellow':'orange'), color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}                                        
                                  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="OIB"
                                        disabled
                                        variant="outlined"
                                        value={OIB2}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>}
                                {(diffTel || diffOIB) && <Grid xs={2}  >
                                {/*<Checkbox
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Objava"
                                        variant="outlined"
                                        checked={isObjava}
                                        disabled="true"
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />*/}
                                </Grid> }    
 
                                                                                       
                                {/*<Grid xs={1}  >
                               <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Obrnuto pretraživanje"
                                        variant="outlined"
                                        value={obrnuto2}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>       */}            
                                <Divider />

{/************************************************************************************************* */}


                                {/*second row*/}
                                <Grid xs={4} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Naziv"
                                        disabled
                                        variant="outlined"
                                        //value={naziv1}
                                        value = {name}
                                        
                                        onChange={(event) => {
                                            //setNaziv1(event.target.value);
                                            setName(event.target.value)
                                        }}
                                    />

                                </Grid>
                                <Grid xs={4} sm={4} md={4} lg={4} xl={4} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Naziv2"
                                        variant="outlined"
                                        //value={naziv12}
                                        value={surname}
                                        disabled
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>

                                <Grid xs={4} >
                                    
                                        <Button  sx={{height:"30px", fontSize:"10px", backgroundColor:'lightyellow', color:'black'}}
                                                   
                                                    fullWidth
                                                    variant="contained"
                                                    disabled={!changeVisible}
                                                    onClick={() => {
                                                    
                                                        console.log("Mijenjam");
                                                        console.log(name);
                                                        console.log(surname);

                                                        let tmpName = name;
                                                        let tmpSurname = surname;

                                                        setName(tmpSurname);
                                                        setSurname(tmpName);

                                                        setFlagChangeName(true);
                                                    }}
                                            
                                                    >
                                                    Zamjena ime/prezime
                                        </Button>
                                </Grid>
                                <Divider />

                                {/*second row*/}
                                {(diffName || diffSurname) && <Grid xs={4}  >

                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:(diffName?'yellow':'orange'), color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}                                      
                                  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Naziv"
                                        disabled
                                        variant="outlined"
                                        //value={naziv12}
                                        value={name2}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />

                                </Grid>}

                                {(diffName || diffSurname) && <Grid xs={4} sm={4} md={4} lg={4} xl={4} >

                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:(diffSurname?'yellow':'orange'), color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                   
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Naziv2"
                                        variant="outlined"
                                        //value={naziv22}
                                        value={surname2}
                                        disabled
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>}

                                {(diffName || diffSurname) && <Grid xs={4}>

                                </Grid>}

                                <Divider />
                                
                                {/*third row*/}
                                <Grid xs={4}>


                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        disabled
                                        label="Mjesto"
                                        variant="outlined"

                                        //value={mjesto}
                                        value={oldMjesto}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />

                                </Grid>
                                <Grid xs={3} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="PTT"
                                        disabled
                                        variant="outlined"
                                        value={ptt}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>
                                <Grid xs={5} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Ulica"
                                        disabled
                                        variant="outlined"
                                        //value={ulica}

                                        value={oldUlica}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>
                                {/*<Grid xs={2} sm={2} md={2} lg={2} xl={1}>
                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="KBR"
                                        variant="outlined"
                                        value={kbr}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>         

                                <Grid xs={2} sm={2} md={2} lg={2} xl={1}>

                                </Grid>    */}                        
                                <Divider />

                                {/*third row*/}
                                {(diffMjesto || diffPTT || diffUlica) && <Grid xs={4} >

                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:(diffMjesto?'yellow':'orange'), color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}                                      
                                 
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Mjesto"
                                        disabled
                                        variant="outlined"
                                        
                                        //value={mjesto2}
                                        value={newMjesto}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />

                                </Grid>}
                                {(diffMjesto || diffPTT || diffUlica) && <Grid xs={3} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:(diffPTT?'yellow':'orange'), color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }} 

                                  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="PTT"
                                        disabled
                                        variant="outlined"
                                        value={ptt2}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>}
                                {(diffMjesto || diffPTT || diffUlica) &&  <Grid xs={5} >

                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:(diffUlica?'yellow':'orange'), color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}                                     
                                
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Ulica"
                                        disabled
                                        variant="outlined"
                                        
                                        //value={ulica2}
                                        value={newUlica}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>}
                                {/*<Grid xs={2} sm={2} md={2} lg={2} xl={1}>
                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="KBR"
                                        variant="outlined"
                                        value={kbr2}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>    
                                <Grid xs={2} sm={2} md={2} lg={2} xl={1}>

                                </Grid>    */}                          
                                <Divider />

                                {/*forth row*/}
                                <Grid xs={3} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Tip"
                                        disabled
                                        variant="outlined"
                                        value={tip}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>
                                <Grid xs={3} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Tip2"
                                        disabled
                                        variant="outlined"
                                        value={tip2}
                                        
                                        onChange={(event) => {
                                            setTip2(event.target.value);
                                        }}
                                    />
                                </Grid>
                                <Grid xs={3}>
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Tip3"
                                        disabled
                                        variant="outlined"
                                        value={tip3}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />

                                </Grid>
                                <Grid xs={3}>
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Datum"
                                        disabled
                                        variant="outlined"
                                        value={datumVal}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>
                             
                                <Divider />



                                {(diffTip1 || diffTip2 || diffTip3) && <Grid xs={3} >

                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:(diffTip1?'yellow':'orange'), color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}                                      
                            
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Tip"
                                        disabled
                                        variant="outlined"
                                        value={tip12}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>}
                                {(diffTip1 || diffTip2 || diffTip3) && <Grid xs={3} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:(diffTip2?'yellow':'orange'), color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}      
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Tip2"
                                        disabled
                                        variant="outlined"
                                        value={tip22}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>}
                                {(diffTip1 || diffTip2 || diffTip3) &&  <Grid xs={3} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:(diffTip3?'yellow':'orange'), color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}      
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Tip3"
                                        disabled
                                        variant="outlined"
                                        value={tip32}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />

                                </Grid>}
                                {(diffTip1 || diffTip2 || diffTip3) && <Grid xs={3} >
   
                                </Grid>}


                                {/*forth row*/}
                                <Grid xs={4} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Operator"
                                        disabled
                                        variant="outlined"
                                        value={tkOperatorRow}
                                        

                                    />
                                </Grid>
                                <Grid xs={4} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Akcija"
                                        disabled
                                        variant="outlined"
                                        value={akcijaRow}
                                        

                                    />
                                </Grid>
                                <Grid xs={4}>
                                        {!changingTKC &&  <Button  sx={{height:"30px", fontSize:"10px", backgroundColor:'lightyellow', color:'black'}}
                                                    fullWidth
                                                    variant="contained"
                                                    disabled={!changeVisible}
                                                    onClick={() => {
                                                    
                                                        console.log("Mijenjam TKC");

                                                        setChangingTKC(true);

                                                        GetPozivni();
                                                        
                                                    }}
                                            
                                                    >
                                                    Promijeni TKC
                                        </Button>}


                                        {changingTKC && <div><FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                                               
                                                <Select
                                                   
                                                    id="tkc-select"
                                                    value={chosenTKCRow}
                                                    label="TKC"
                                                    onChange={handleChangeTKCRow}
                                                >
                                                {listOfPozivni && listOfPozivni.map((poziv,index)=> {
                                                    return (
                                                    <MenuItem value={poziv.tkc} name={poziv.pozivni} key={index}>{poziv.pozivni}</MenuItem>

                                                    )
                                                })}
                                                </Select>
                                        </FormControl>
                                         <Button  sx={{height:"30px", fontSize:"10px"}}
                                                    fullWidth
                                                    variant="contained"
                                                    onClick={() => {
                                                    
                                                        console.log("Mijenjam TKC");

                                                        setChangingTKC(false);

                                                        
                                                        
                                                    }}
                                            
                                                    >
                                                    Odustani
                                        </Button>
                                        </div>
                                        
                                        }

                                </Grid>

                             
                                <Divider />


                                {errorUlica && <Grid xs={4}>


                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                             
                                        size="small"
                                        fullWidth
                                        id=""
                                        disabled
                                        label="Mjesto"
                                        variant="outlined"
                                        value={mjesto2}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />

                                </Grid> }
                                {errorUlica && <Grid xs={3} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="PTT"
                                        disabled
                                        variant="outlined"
                                        value={ptt2}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid>}
                                {errorUlica && <Grid xs={5} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'lightyellow', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Ulica"
                                        disabled
                                        variant="outlined"
                                        value={ulica2}
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </Grid> }

                                {errorUlica &&  <Divider />  } 

                                {/*forth row*/}
                                <Grid xs={4} >




                                         <Button  sx={{height:"30px", fontSize:"10px"}}
                                                    fullWidth
                                                    variant="contained"
                                                    onClick={() => {

                                                        console.log("Treid choosing");
                                                        console.log(telefon);
                                                        getBijeleZuteDnevne(telefon);
                                                    
                                                        
                                                    }}
                                            
                                                    >
                                                    Tel bijele/žute
                                        </Button>
                                </Grid>
                                <Grid xs={4} >
                                        <Link  
                                        //to={{pathname: "/ZuteStranice", state: doubleClickedRow? doubleClickedRow:""}}
                                        to="" 
                                        >
                                                 <Button  sx={{height:"30px", fontSize:"10px"}} fullWidth
                                                    variant="contained" onClick={()=> {setZuteStraniceOpen(true)}}>Žute stranice</Button>
                                        </Link>
                                </Grid>
                                <Grid xs={4}>

                                    <Link 
                                    //to={{pathname: "/BijeleStranice", state: doubleClickedRow? doubleClickedRow:""}} 
                                    to="" 
                                    >
                                       
                                         <Button  sx={{height:"30px", fontSize:"10px"}} fullWidth
                                                    variant="contained"  onClick={()=>setBijeleStraniceOpen(true)}>Bijele stranice</Button>
                                    </Link>

                                </Grid>
                                <Divider />

                            </Grid>
                        </div>   



                        <div className="DPDonat-form-first-part-right">


                            <Container style={{padding:0, width:'auto', margin:'0px', display: rasporedivanjeZadatakaIsShown? "none": "unset"}}>


                                    <div style={{ backgroundColor: '#cfe8fc', borderRadius:'10px', marginRight:'10px'}}>
                                        <div className="DPDonat-form-statistika-header"style={{ paddingTop:'10px'}}>

                                            <Typography className="DPDonat-form-statistika-title" variant="p"  sx={{width:'20%'}}>
                                                    Statistika:

                                            </Typography>
                                            <FormControl  sx={{width:'100%'}}>
                                                <RadioGroup 
                                              
                                                row
                                                name="Vlasnik"
                                                onChange={handleOwnerChange}
                                                >
                                                     <FormControlLabel sx={{height:"30px",  '& .MuiFormControlLabel-label': { fontSize: '13px' } }} 
                                                     disabled={!changeVisible}
                                                     control={<Radio id='1' size="small"  />} checked={selectedOwner=='1'?true:false} label="Moje promjene" />  
                                                     <FormControlLabel sx={{height:"30px",  '& .MuiFormControlLabel-label': { fontSize: '13px' } }} 
                                                     disabled={!changeVisible}
                                                     control={<Radio id='0' size="small" />} checked={selectedOwner=='0'?true:false} label="Sve" />
                                                </RadioGroup>
                                            </FormControl>

                                        </div>

                                        <FormGroup  sx={{flexDirection:"row"}} className='DPDonat-form-checkboxes'>
                                            <Box  sx={{fontSize:"10px"}}  className='DPDonat-form-column-right'>
                                                <div className='DPDonat-form-statistika-checkbox'>
                                                    <div className="DPDonat-form-statistika-error-number">
                                                        <Typography sx={{fontSize: 13}}>
                                                            {data && data.filter(datum=>datum.Stanje==0).length}
                                                        </Typography>
                                                    </div>
                                                     <FormControlLabel sx={{height:"10px",  '& .MuiFormControlLabel-label': { fontSize: '13px' } }} 
                                                     disabled={!changeVisible}
                                                     control={<Checkbox checked={check0} size="big" onChange={(e)=> {
                                                        var newFilters=[...filters]
                                                        newFilters[0]= e.target.checked;

                                                        console.log("Filters trenutno: ");
                                                        console.log(newFilters);
                                                        setFilters(newFilters);

                                                        setCheck0(!check0);

                                                        handleFilterChanges(newFilters);

                                                    }} />} label="0 - čekaju knjiženje" />  
                                                </div>
                                                <div className='DPDonat-form-statistika-checkbox'>
                                                    <div className="DPDonat-form-statistika-error-number">
                                                        <Typography sx={{fontSize: 13}}>
                                                            {data && data.filter(datum=>datum.Stanje==1).length}
                                                        </Typography>
                                                    </div>
                                                     <FormControlLabel sx={{height:"30px", '& .MuiFormControlLabel-label': { fontSize: '13px' } }}  
                                                     disabled={!changeVisible}
                                                     control={<Checkbox checked={check1} size="big" onChange={(e)=> {
                                                        let newFilters=[...filters];
                                                        newFilters[1]= e.target.checked;
                                                        console.log("Filters trenutno: ");
                                                        console.log(newFilters);
                                                        setFilters(newFilters);

                                                        setCheck1(!check1);

                                                        handleFilterChanges(newFilters);

                                                    }}  />} label="1 - greška u knjiženju" /> 
                                                </div>
                                                <div className='DPDonat-form-statistika-checkbox'>
                                                    <div className="DPDonat-form-statistika-error-number">
                                                        <Typography sx={{fontSize: 13}}>
                                                            {data && data.filter(datum=>datum.Stanje==2 && datum.Gotovo==0).length}
                                                        </Typography>
                                                    </div>
                                                     <FormControlLabel sx={{height:"30px", '& .MuiFormControlLabel-label': { fontSize: '13px' } }} 
                                                     disabled={!changeVisible}
                                                     control={<Checkbox checked={check2} size="big" onChange={(e)=> {
                                                        let newFilters=[...filters];
                                                        newFilters[2]= e.target.checked;
                                                        setFilters(newFilters);

                                                        setCheck2(!check2);

                                                        handleFilterChanges(newFilters);

                                                    }}/>} label="2.0 - proknjiženo/ostaje" />   
                                                </div>
                                                <div className='DPDonat-form-statistika-checkbox'>
                                                    <div className="DPDonat-form-statistika-error-number">
                                                        <Typography sx={{fontSize: 13}}>
                                                            {data && data.filter(datum=>datum.Stanje==2 && datum.Gotovo==1).length}
                                                        </Typography>
                                                    </div>
                                                     <FormControlLabel sx={{height:"30px", '& .MuiFormControlLabel-label': { fontSize: '13px' } }} 
                                                     disabled={!changeVisible}
                                                     control={<Checkbox checked={check3} size="big" onChange={(e)=> {
                                                        let newFilters=[...filters];
                                                        newFilters[3]= e.target.checked;
                                                        setFilters(newFilters);

                                                        setCheck3(!check3);

                                                        handleFilterChanges(newFilters);

                                                    }}/>} label="2.1 - proknjiženo/skinuti" /> 
                                                </div>
                                                <div className='DPDonat-form-statistika-checkbox'>
                                                    <div className="DPDonat-form-statistika-error-number">
                                                        <Typography sx={{fontSize: 13}}>
                                                            {data && data.filter(datum=>datum.Stanje==2 && datum.Gotovo==4).length}
                                                        </Typography>
                                                    </div>
                                                     <FormControlLabel sx={{height:"30px", '& .MuiFormControlLabel-label': { fontSize: '13px' } }} 
                                                     disabled={!changeVisible}
                                                     control={<Checkbox checked={check4} size="big" onChange={(e)=> {
                                                        let newFilters=[...filters];
                                                        newFilters[4]= e.target.checked;
                                                        setFilters(newFilters);

                                                        setCheck4(!check4);

                                                        handleFilterChanges(newFilters);


                                                    }}/>} label="2.4 - proknjiženo/odgoda" />   
                                                </div>



                                                <div className='DPDonat-form-statistika-checkbox'>
                                                    <div className="DPDonat-form-statistika-error-number">
                                                        <Typography sx={{fontSize: 13}}>
                                                            {data && data.filter(datum=>datum.Stanje==3).length}
                                                        </Typography>
                                                    </div>
                                                     <FormControlLabel sx={{height:"30px", '& .MuiFormControlLabel-label': { fontSize: '13px' } }} 
                                                     disabled={!changeVisible}
                                                     control={<Checkbox checked={check5} size="big" onChange={(e)=> {
                                                        let newFilters=[...filters];
                                                        newFilters[5]= e.target.checked;
                                                        setFilters(newFilters);

                                                        setCheck5(!check5);

                                                        handleFilterChanges(newFilters);


                                                    }}/>} label="3 - forsira se knjiženje" /> 
                                                </div>

                                                <div className='DPDonat-form-statistika-checkbox'>
                                                    <div className="DPDonat-form-statistika-error-number">
                                                        <Typography sx={{fontSize: 13}}>
                                                            {data && data.filter(datum=>datum.Stanje==4).length}
                                                        </Typography>
                                                    </div>
                                                     <FormControlLabel sx={{height:"30px", '& .MuiFormControlLabel-label': { fontSize: '13px' } }} 
                                                     disabled={!changeVisible}
                                                     control={<Checkbox checked={check6} size="big" onChange={(e)=> {
                                                        let newFilters=[...filters];
                                                        newFilters[6]= e.target.checked;
                                                        setFilters(newFilters);

                                                        setCheck6(!check6);

                                                        handleFilterChanges(newFilters);


                                                    }}/>} label="4 - ne diraj do daljnjeg" />  
                                                </div>
                                                <div className='DPDonat-form-statistika-checkbox'>
                                                    <div className="DPDonat-form-statistika-error-number">
                                                        <Typography sx={{fontSize: 13}}>
                                                            {data && data.filter(datum=>datum.Stanje==5).length}
                                                        </Typography>
                                                    </div>
                                                     <FormControlLabel sx={{height:"30px", '& .MuiFormControlLabel-label': { fontSize: '13px' } }} 
                                                     disabled={!changeVisible}
                                                     control={<Checkbox checked={check7} size="big" onChange={(e)=> {
                                                        let newFilters=[...filters];
                                                        newFilters[7]= e.target.checked;
                                                        setFilters(newFilters);

                                                        setCheck7(!check7);

                                                        handleFilterChanges(newFilters);


                                                    }}/>} label="5 - višak/treba brisati" /> 
                                                </div>
                                                <div className='DPDonat-form-statistika-checkbox'>
                                                    <div className="DPDonat-form-statistika-error-number">
                                                        <Typography sx={{fontSize: 13}}>
                                                            {data && data.filter(datum=>datum.Stanje==6).length}
                                                        </Typography>
                                                    </div>
                                                     <FormControlLabel sx={{height:"30px", '& .MuiFormControlLabel-label': { fontSize: '13px' }}} 
                                                     disabled={!changeVisible}
                                                     control={<Checkbox checked={check8} size="big" onChange={(e)=> {
                                                        let newFilters=[...filters];
                                                        newFilters[8]= e.target.checked;
                                                        setFilters(newFilters);

                                                        setCheck8(!check8);

                                                        handleFilterChanges(newFilters);


                                                    }}/>} label="6 - ne znam riješiti" />   
                                                </div>
                                            </Box>
                                        </FormGroup>    

                                        <Divider />

                                        <FormGroup>
                                            <Box  sx={{ width: "100%"}} className='DPDonat-form-statistika-checkbox-total'>
                                                <Box  sx={{width: "100px"}} className="DPDonat-form-statistika-error-number DPDonat-form-statistika-error-total-number">
                                                    <Typography  sx={{ fontSize:15}}>{data.length}  </Typography>
                                                </Box>

                                                 <FormControlLabel sx={{height:"30px", '& .MuiFormControlLabel-label': { fontSize: '13px' }}}   
                                                 disabled={!changeVisible}
                                                 control={<div></div>} label="UKUPNO PROMJENA U LISTI" />  
                                            </Box>
                                            
                                        </FormGroup>
                                    </div>
                            </Container>
                            <Container style={{margin:'0', padding:'0 10px 0 0', display: !rasporedivanjeZadatakaIsShown? "none": "unset"}}>
                                <Typography className="DPDonat-form-rasporedivanje-title" variant="h4">
                                                    Rasporedi zadatke
                                </Typography>
                                <div className='DPDonat-form-selector'>
                                    <FormControl fullWidth >
                                            <InputLabel>Referent</InputLabel>
                                            <Select
                                                
                                                value={selectedReferent}
                                                label="Referent"
                                                onChange={(event) => {
                                                    console.log(event.target.value)
                                                    setSelectedReferent(event.target.value);
                                            
                                                }}
                                            >
                                                {allowedUsers && allowedUsers.map((user,index)=> {
                                                return (
                                                    <MenuItem key={index} value={user.val_id}>{user.val_name}</MenuItem>

                                                )
                                                })}
                                            </Select>
                                    </FormControl>
                                        

                                </div>

                                {/*
                                {selectedItems.length!=0 
                                ? <Typography variant="h4"><div className="DPDonat-form-list-items-title">Lista</div></Typography> 
                                : <Typography variant="h4"><div className="DPDonat-form-list-items-title">Nema odabranih stavki</div></Typography>
                                }
                                <div className='DPDonat-form-list-items'>

                                    {selectedItems.map((item,index)=> {
                                        return(
                                            <>
                                                <Typography key={index} className="DPDonat-form-list-items-item" variant="p">
                                                    {item[0].name}
                                                </Typography>
                                                <Divider />
                                            </>

                                        )
                                    })}
                                </div>
                                */}

                                <div className='DPDonat-form-list-items-actions'> 
                                             <Button  sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" 
                                                    onClick={() => {
                                                        updateOznaka()
                                                }}>
                                               Dodijeli referentu
                                            </Button>
                                            
                                             <Button  sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" 
                                                    onClick={() => {
                                                        setRasporedivanjeZadatakaIsShown(false);
                                                }}>
                                               Kraj
                                            </Button>
                                            
                                </div>

                            </Container>
                        </div>                          

                    </div>  
                    <div className="DPDonat-form-second-part">
                        <div className="DPDonat-form-second-part-left">
                                <div style={{width:'69%', padding: '5px'}}> 
                                <div style={{padding: '0 0 7px 0'}}> <Typography>RUČNI ISPRAVCI NAZIVA, ADRESA I TIPOVA</Typography>  </div>             
                                    <Grid container spacing={1}>
                                        
                                        <Grid xs={12}>
                                           <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                size="small"
                                                fullWidth
                                                id=""
                                                label="Naziv 1"
                                                disabled={!rucneKorekcije || !changeVisible}
                                                variant="outlined"
                                                value={rucnoNaziv1}
                                                
                                                onChange={(event) => {
                                                        
                                                    setRucnoNaziv1(event.target.value);
                                                    
                                                }}

                                                inputRef={naziv1Ref}
                                                onKeyDown={(event) => {
                                                    if (event.key === 'Enter'){

                                                        naziv2Ref.current.focus();
                                                    }
                                                }}

                                            />
                                        </Grid>

                                        
                                        <Grid xs={12}>
                                           <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                size="small"
                                                fullWidth
                                                id=""
                                                label="Naziv 2"
                                                variant="outlined"
                                                value={rucnoNaziv2}
                                                disabled={!rucneKorekcije || !changeVisible}
                                                
                                                onChange={(event) => {
                                                    setRucnoNaziv2(event.target.value);
                                                }}


                                                inputRef={naziv2Ref}
                                                onKeyDown={(event) => {
                                                    if (event.key === 'Enter'){

                                                        inputRefMjesto.current.focus();
                                                    }
                                                }}                                                     
                                            />
                                        </Grid>

                                        
                                        <Grid xs={12}>
                                                <Autocomplete

                                                                    //freeSolo
                                                                    //open={open}

                                                                   
                                                                   
                                                                    disabled={!rucneKorekcije || !changeVisible}
                                                                    variant="outlined"
                                                                
                                                                    options={listMjesta}

                                                                    getOptionLabel={(option) => option.NAZIV?option.NAZIV:(option.naziv?option.naziv:'')} 

                                                                    
                                                                    renderOption={(props, option) => {
                                                                        const { key, ...optionProps } = props;
                                                                        return (
                                                                        <Box
                                                                            key={option.MJESTO_ID?option.MJESTO_ID:(option.mjesto_id?option.mjesto_id:'')}
                                                                            component="li"
                                                                            sx={{backgroundColor: (option.AKTIVNO==1||option.aktivno==1)?'white':'yellow'}}
                                                                            {...optionProps}
                                                                        >   
                                                                            {option.NAZIV?option.NAZIV:(option.naziv?option.naziv:'')}   -   {option.ID_DOSTAVNE_POSTE?option.ID_DOSTAVNE_POSTE:(option.id_dostavne_poste?option.id_dostavne_poste:'')}  -  {option.NAZIV_OPCINE?option.NAZIV_OPCINE:(option.naziv_opcine?option.naziv_opcine:'')}
                                                                        </Box>
                                                                        );
                                                                    }}

                                                                    value={selectedMjesto}

                                                                    inputValue={rucnoMjesto}

                                                                    onHighlightChange={(event, option) => {
                                                                        setHighlightedOptionMjesto(option);
                                                                    }}
                                                                    onOpen={() => {
                                                                        setOpenMjesto(true); // Open only when clicked/focused
                                                                    }}
                                                                    onClose={() => {
                                                                        setOpenMjesto(false);
                                                                    }}
                                                                    onChange={(event, newValue) => {
                                                                        if (newValue) {
                                                                                console.log('Selected:', newValue);


                                                                                
                                                                                console.log(newValue)
                                                                                setSelectedMjesto(newValue)
                                                                                setRucnoMjesto(newValue.NAZIV?newValue.NAZIV:(newValue.naziv?newValue.naziv:''))

                                                                                setTkcFirma(newValue.ID_TKC?newValue.ID_TKC:(newValue.id_tkc?newValue.id_tkc:''))

                                                                                setSelectedUlica({'ULICA_ID': 0, 'NAZIV':''});
                                                                                setRucnoUlica('');
                                                                           
                                                                                setRucnoKBR('');
                                                                                setRucnoKBRDodatak('');
                                                                            

                                                                                setListMjesta([])
                                                                                // Remove focus (blur)

                                                                                if (inputRefMjesto.current) {
                                                                                    inputRefMjesto.current.blur();
                                                                                }
                                                                                setOpenMjesto(false);
                                                                        }

                                                                        
                                                                    }}
                                                                    loading={loadingMjesto}
                                                                
                                                                    onInputChange={(event, newInputValue, reason) => {
                                                                        console.log("New input value is here!!!!")
                                                                        console.log(newInputValue);
                                                                       
                                                                        setRucnoMjesto(newInputValue);

                                                      

                                                                      
                                                                        // Don't open while typing manually
                                                                        if (reason === 'reset') {
                                                                            setOpenMjesto(false);
                                                                        }
                                                                    }}

                                                                    renderInput={(params) => (
                                                                        <TextField

                                                                        {...params}

                                                                        label="Mjesto"
                                                                        size="small" // smaller baseline size
                                                                        InputProps={{
                                                                        ...params.InputProps,
                                                                        sx: {
                                                                            height: '30px',
                                                                            minHeight: '30px',
                                                                            '& input': {
                                                                            padding: '0 8px',
                                                                            height: '30px',
                                                                            boxSizing: 'border-box',
                                                                            },
                                                                        },
                                                                        }}
                                                                        InputLabelProps={{
                                                                        sx: {
                                                                            fontSize: '0.75rem', // smaller label font
                                                                            top: '-6px', // shift label slightly up
                                                                        }
                                                                        }}
                                                                        inputRef={inputRefMjesto}
                                                                        onKeyDown={handleKeyDownMjesto}
                                                                        onClick={() => setOpenMjesto(true)} // Open on click
                                                                        onFocus={() => setOpenMjesto(true)} // Open on focus
                                                                        />
                                                                    )}
                                                                    disableCloseOnSelect={false}

                                                                    autoHighlight
                                            />



                                        </Grid>


                                        
                                        <Grid xs={6}>
                                                <Autocomplete

                                                    //freeSolo
                                                    //open={open}
                                                    options={listUlice}
                                                  
                                                    disabled={!rucneKorekcije || !changeVisible}

                                                    getOptionLabel={(option) => option.NAZIV?option.NAZIV:(option.naziv?option.naziv:'')}

                                                    renderOption={(props, option) => {

                                                        
                                                                        const { key, ...optionProps } = props;
                                                                        return (
                                                                        <Box

                                                                            key={option.ULICA_ID?option.ULICA_ID:(option.ulica_id?option.ulica_id:'')}
                                                                            component="li"
                                                                            sx={{backgroundColor: (option.AKTIVNA==1||option.aktivna==1)?'white':'yellow'}}                                                                        
                                                                           
                                                                            {...optionProps}
                                                                        >   
                                                                            {option.NAZIV?option.NAZIV:(option.naziv?option.naziv:'')} - {(option.AKTIVNA==1||option.aktivna==1)?"aktivna":"neaktivna"}
                                                                        </Box>
                                                                        );
                                                    }}

                                                    value={selectedUlica}

                                                    inputValue={rucnoUlica}

                                                    onHighlightChange={(event, option) => {
                                                        setHighlightedOption(option);
                                                        }}
                                                        onOpen={() => {
                                                        setOpen(true); // Open only when clicked/focused
                                                        }}
                                                        onClose={() => {
                                                        setOpen(false);
                                                        }}
                                                    onChange={(event, newValue) => {
                                                        if (newValue) {
                                                            console.log('Selected street:', newValue);
                                                            
                                                            //setLoading(false);
                                                            //setOpen(false);
                                                            console.log(newValue)
                                                            setSelectedUlica(newValue)
                                                            setRucnoUlica(newValue.NAZIV?newValue.NAZIV:(newValue.naziv?newValue.naziv:''))
                                                            setListUlice([])
                                                            // Remove focus (blur)

                                                            if (inputRefUlice.current) {
                                                            inputRefUlice.current.blur();
                                                            }
                                                            setOpen(false);
                                                        }

                                                        
                                                        }}
                                                    loading={loading}
                                                
                                                    onInputChange={(event, newInputValue, reason) => {
                                                        console.log("New input value is here!!!!")
                                                        console.log(newInputValue);
                                                        setRucnoUlica(newInputValue);
                                                        // Don't open while typing manually
                                                        if (reason === 'reset') {
                                                            setOpen(false);
                                                        }
                                                    }}
                                        
                                                    renderInput={(params) => (
                                                        <TextField

                                                        {...params}

                                                        label="Ulica"
                                                        size="small" // smaller baseline size
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            sx: {
                                                            height: '30px',
                                                            minHeight: '30px',
                                                            '& input': {
                                                                padding: '0 8px',
                                                                height: '30px',
                                                                boxSizing: 'border-box',
                                                            },
                                                            },
                                                        }}
                                                        InputLabelProps={{
                                                            sx: {
                                                            fontSize: '0.75rem', // smaller label font
                                                            top: '-6px', // shift label slightly up
                                                            }
                                                        }}
                                                        inputRef={inputRefUlice}
                                                        onKeyDown={handleKeyDownUlica}
                                                        onClick={() => setOpen(true)} // Open on click
                                                        onFocus={() => setOpen(true)} // Open on focus
                                                        />
                                                    )}
                                                    disableCloseOnSelect={false}
                                                    
                                                    autoHighlight
                                                    />

                                        </Grid>
                                        
                                        <Grid xs={3}>
                                           <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                size="small"
                                                fullWidth
                                                id=""
                                                label="KBr"
                                                value={rucnoKBR}
                                                disabled={!rucneKorekcije || !changeVisible}
                                                variant="outlined"
                                                
                                                onChange={(event) => {
                                                    setRucnoKBR(event.target.value);
                                                    
                                                }}

                                                inputRef={kbr_ref}
                                                onKeyDown={(event) => {
                                                    if (event.key === 'Enter'){

                                                        kbrZnak_ref.current.focus();
                                                    }
                                                }}                                                   
                                            />
                                        </Grid>

                                        
                                        <Grid xs={3}>
                                           <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px", shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                size="small"
                                                fullWidth
                                                id=""
                                                label=""
                                                value={rucnoKBRDodatak}
                                                disabled={!rucneKorekcije || !changeVisible}
                                                variant="outlined"
                                                
                                                onChange={(event) => {
                                                    setRucnoKBRDodatak(event.target.value);
                                                    
                                                }}

                                                inputRef={kbrZnak_ref}
                                            />
                                        </Grid>
                                        
                                        <Grid xs={12}>
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-around"}}>
                                                <Typography className="DPDonat-form-statistika-title" variant="p">
                                                        Tip
                                                </Typography>

                                                <FormControl>
                                                    <RadioGroup row
                                                    name="Tip"
                                                    onChange={rucnoTipChange}
                                                    disabled={!rucneKorekcije || !changeVisible}
                                                    >
                                                         <FormControlLabel sx={{height:"30px", fontSize:12}} control={<Radio id='0' size="small" />} disabled={!rucneKorekcije || !changeVisible} checked={selectedRucnoTip=='0'?true:false} label="Osobe" />  

                                                         <FormControlLabel sx={{height:"30px", fontSize:12}} control={<Radio id='1' size="small" />} disabled={!rucneKorekcije || !changeVisible} checked={selectedRucnoTip=='1'?true:false} label="Obrtnici" />
                                                         <FormControlLabel sx={{height:"30px", fontSize:12}} control={<Radio id='2' size="small" />} disabled={!rucneKorekcije || !changeVisible} checked={selectedRucnoTip=='2'?true:false} label="Firme" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </div>
                                        </Grid>

                                        {/*<Grid xs={12}>
                                             <FormControlLabel sx={{height:"30px", fontSize:12}} control={<Checkbox size="small" />} checked={rucneKorekcije} onChange={()=>{ setRucneKorekcije(!rucneKorekcije);
                                                console.log("Changing rucneKorekcijeeeeee");
                                            }} label={<Typography sx={{fontSize:'15px'}}>Forsiranje?</Typography>} /> 
                                        </Grid>*/}
                                    </Grid>
                                

                                </div>

                               <div style={{width:'29%', padding: '4px'}}> 
                                    <Grid container spacing={1}>
                                        {/*<Grid xs={12}>
                                             <Button sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" 
                                                    onClick={() => {
                                            
                                                }}>
                                               Upute
                                            </Button>
                                        </Grid>*/}
                                        <Grid xs={12}>
                                            
                                            {/* <FormControlLabel sx={{height:"30px", fontSize:12}} control={<Checkbox size="small" />} checked={rucneKorekcije} onChange={()=>{ 
                                                setRucneKorekcije(!rucneKorekcije);
                                                console.log("Changing rucneKorekcijeeeeee");
                                            }} label={<Typography sx={{fontSize:'15px'}}>Forsiranje?</Typography>} /> 
                                             */}
                                        </Grid>
                                        <Grid xs={12}>
                                             <Button  sx={{height:"30px", fontSize:"10px", backgroundColor:'lightyellow', color:'black'}} fullWidth variant="contained" 
                                                    disabled={!rucneKorekcije || !changeVisible}
                                                    onClick={() => {
                                                            setRucnoNaziv1(name);
                                                            setRucnoNaziv2(surname);
                                                }}>
                                               Uzmi naziv
                                            </Button>
                                        </Grid>
                                        <Grid xs={12}>
                                             <Button  sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" color="error"
                                                    disabled={!rucneKorekcije || !changeVisible}
                                                    onClick={() => {
                                                            setRucnoKBR('');
                                                            setRucnoKBRDodatak('');
                                                            setRucnoMjesto('');
                                                            setRucnoUlica('');
                                                            setRucnoNaziv1('');
                                                            setRucnoNaziv2('');
                                                            setSelectedRucnoTip(3);
                                                            //setRucneKorekcije(false);
                                                }}>
                                               Odustani
                                            </Button>
                                        </Grid>
                                        <Grid xs={12}>
                                             <Button  sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" color="success"
                                                    disabled={!rucneKorekcije || !changeVisible}
                                                    onClick={() => {
                                                        rucnaKorekcija();
                                                }}>
                                               Prihvati pojedinačno
                                            </Button>
                                        </Grid>
                                        <Grid xs={12}>
                                             <Button  sx={{height:"30px", fontSize:"10px", backgroundColor:'lightyellow', color:'black'}} fullWidth variant="contained" 
                                                    disabled={!rucneKorekcije || !changeVisible}
                                                    onClick={() => {
                                            
                                                        rucnaKorekcija_interval();
                                                }}>
                                               Interval
                                            </Button>
                                        </Grid>
                                    </Grid>

                               </div>

                        </div>


                        <div className="DPDonat-form-second-part-right">
                                {/*<div className="DPDonat-napone">
                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }} size="small" fullWidth id="" label="Napomena" variant="outlined"
                                        onChange={(event) => {
                                            
                                        }}
                                    />
                                </div>   */}  
                                <div className="DPDonat-status">
                                    <div className="DPDonat-napone-box-selects">
                                        <FormControl variant="standard" sx={{ m: 1, width:'100%' }}>
                                            <InputLabel>Status obrade</InputLabel>
                                            <Select
                                            fullWidth
                                        
                                            value={statusObrade}
                                            disabled={!changeVisible}
                                        
                                            label="Status Obrade"
                                            onChange={(e)=>{
                                                
                                                console.log(e.target);
                                                console.log("Setting");
                                                console.log(e.target.value)
                                                setStatusObrade(e.target.value);
                                            }}
                                            >
                                                {statusObradeOptions}

                                            </Select>
                                        </FormControl>     
                                        <FormControl variant="standard" sx={{ m: 1, minWidth: '100% ' }} >
                                            <InputLabel>Treba li skloniti?</InputLabel>
                                            <Select
                                            value={skloniti}
                                            label="Status Obrade"
                                            disabled={!changeVisible}
                                            onChange={(e)=>{
                                                console.log(e.target)
                                                console.log(e.target.value);
                                                setSkloniti(e.target.value)
                                            
                                            }}
                                            >
                                                {trebaLiSklonitiOptions}

                                            </Select>
                                        </FormControl>                                          
                                    </div>


                                    <div className="DPDonat-napone-box-buttons">
                                         <Button  sx={{height:"30px", fontSize:"10px", backgroundColor:'lightyellow', color:'black'}} fullWidth variant="contained" 
                                                    disabled={!changeVisible}
                                                    onClick={() => {
                                                        //staviObjavu();
                                                        odradi5_1();
                                                }}>
                                               Stavi status 5.1
                                            </Button>                                    

                                         <Button  sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" color="success"
                                            disabled={!changeVisible}
                                            onClick={() => {

                                                let tmpSkloniti = 0;

                                                

                                                if(!skloniti){

                                                    tmpSkloniti = 0;
                                                } else {

                                                    tmpSkloniti = skloniti;
                                                }

                                                let tmpStatus = 0;

                                                if(!statusObrade){

                                                    tmpStatus = 0;
                                                } else {

                                                    tmpStatus = statusObrade;
                                                }

                                                if(selectedItems && selectedItems.length == 1){

                                                    console.log("Samo jedan mijenjam!!!");

                                                    
                                                    promijeniStatusStanje(tmpStatus, tmpSkloniti, selectedItems[0].Ref?selectedItems[0].Ref:0);
                                                } else {

                                                    if(selectedItems.length > 500){

                                                        console.log(selectedItems.length);
                                                        toast.error('Istovremeno možete promijeniti status najviše 500 podataka intervalno', toastError)
                                                    }else{

                                                        promijeniStatusStanjeInterval(tmpStatus, tmpSkloniti);
                                                    }

                                                    
                                                }
                                               
                                               


                                                //promijeniStatusStanjeInterval(tmpStatus, tmpSkloniti);
                                                //promijeniStatusStanje(tmpStatus, tmpSkloniti, selectedCell.Ref?selectedCell.Ref:0);
                                            }}>
                                            Prihvati izmjene
                                        </Button> 
                                    
                                         <Button  sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" color="info"
                                            disabled={!changeVisible}
                                            onClick={() => {

                                                izmijeniIntervalStatus()
                                            }}>
                                            Status interval
                                        </Button> 
                                

                                    </div>


                                </div>         
                                <div className="DPDonat-napone-box-komentar">
                                       <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",shrink: true,
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }} size="small" fullWidth id="" label="Komentar" variant="outlined" value={komentar}
                                           
                                                onChange={(event) => {
                                                    console.log(event.target.value);
                                                    setKomentar(event.target.value);
                                                }}
                                            />
                                </div>
                                        


                                        

                        </div>
                    </div>  
                </div>
            </div>



        </div>
    </ThemeProvider >
  );
}


export default DnevnePromjeneTele2;
